var _path, _polygon, _path2, _polygon2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-168",
    d: "M77.66,248.93c-95.18,54.95-95.17,144,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,194,77.66,248.93Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadows-2--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-168",
    d: "M225,333.05a11.38,11.38,0,0,1-5.63-1.42L114.11,270.8a6.64,6.64,0,0,1,0-11.91L250,180.47a11.89,11.89,0,0,1,11.27,0L366.48,241.3a6.63,6.63,0,0,1,0,11.91L230.65,331.63A11.39,11.39,0,0,1,225,333.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M117.51,405.35a11.46,11.46,0,0,1-5.63-1.41L40.51,362.72a6.64,6.64,0,0,1,0-11.91L135.38,296a11.89,11.89,0,0,1,11.27,0L218,337.22a6.64,6.64,0,0,1,0,11.91l-94.87,54.8A11.41,11.41,0,0,1,117.51,405.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M368.13,409.18a11.35,11.35,0,0,1-5.63-1.42L255.53,346a6.64,6.64,0,0,1,0-11.91l102-59a11.89,11.89,0,0,1,11.27,0l107,61.76a6.64,6.64,0,0,1,0,11.91l-101.95,59A11.38,11.38,0,0,1,368.13,409.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M233,451.63a11.44,11.44,0,0,1-5.63-1.41l-75.6-43.68a6.63,6.63,0,0,1,0-11.9l89.12-51.46a11.95,11.95,0,0,1,11.26,0l75.6,43.67a6.63,6.63,0,0,1,0,11.91l-89.12,51.45A11.35,11.35,0,0,1,233,451.63Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Platforms--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Steps--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Step--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Block--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.09,174.55a2.31,2.31,0,0,1,1.37-1.9L252.29,94.22a7.27,7.27,0,0,1,6.58,0l105.27,60.84a2.31,2.31,0,0,1,1.37,1.9V247.1a2.31,2.31,0,0,1-1.37,1.9L228.31,327.43a7.29,7.29,0,0,1-6.59,0L116.46,266.59a2.31,2.31,0,0,1-1.37-1.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.59,93.44a6.78,6.78,0,0,0-3.29.78L116.47,172.65a2.3,2.3,0,0,0-1.36,1.9v90.14a2.3,2.3,0,0,0,1.36,1.9l105.27,60.84a6.83,6.83,0,0,0,3.28.79l-.2-92.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.72,237.28,116.46,176.45c-1.82-1-1.82-2.75,0-3.8L252.29,94.22a7.27,7.27,0,0,1,6.58,0l105.27,60.84c1.82,1.05,1.82,2.75,0,3.8L228.31,237.28A7.29,7.29,0,0,1,221.72,237.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--step--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--block--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.26,294.78a2.31,2.31,0,0,1,1.37-1.9l94.87-54.81a7.27,7.27,0,0,1,6.58,0l71.37,41.22a2.3,2.3,0,0,1,1.36,1.9v60.49a2.3,2.3,0,0,1-1.36,1.9l-94.87,54.8a7.27,7.27,0,0,1-6.58,0L42.63,357.17a2.32,2.32,0,0,1-1.37-1.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.8,237.29a6.78,6.78,0,0,0-3.29.78L42.64,292.88a2.3,2.3,0,0,0-1.36,1.9v60.49a2.31,2.31,0,0,0,1.36,1.9L114,398.38a6.63,6.63,0,0,0,3.28.79V336.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,337.89,42.63,296.68c-1.82-1.05-1.82-2.75,0-3.8l94.87-54.81a7.27,7.27,0,0,1,6.58,0l71.37,41.22c1.82,1,1.82,2.75,0,3.8l-94.87,54.8A7.27,7.27,0,0,1,114,337.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--step--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--block--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.51,285.84a2.3,2.3,0,0,1,1.36-1.9l101.95-59a7.27,7.27,0,0,1,6.58,0l107,61.76a2.32,2.32,0,0,1,1.36,1.9V342a2.3,2.3,0,0,1-1.36,1.9l-101.95,59a7.33,7.33,0,0,1-6.58,0l-107-61.77a2.3,2.3,0,0,1-1.36-1.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.12,224.15a6.9,6.9,0,0,0-3.29.79l-101.95,59a2.32,2.32,0,0,0-1.36,1.9v53.35a2.32,2.32,0,0,0,1.36,1.9l107,61.77a6.74,6.74,0,0,0,3.28.78V347.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.84,349.5l-107-61.76c-1.82-1.05-1.82-2.76,0-3.8l101.95-59a7.27,7.27,0,0,1,6.58,0l107,61.76c1.82,1.05,1.82,2.75,0,3.8l-101.95,59A7.27,7.27,0,0,1,364.84,349.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--step--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--block--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.78,378.12a2.29,2.29,0,0,1,1.36-1.9l89.12-51.45a7.27,7.27,0,0,1,6.58,0l75.6,43.67a2.31,2.31,0,0,1,1.37,1.9v21.39a2.32,2.32,0,0,1-1.37,1.9l-89.12,51.45a7.27,7.27,0,0,1-6.58,0l-75.6-43.67a2.3,2.3,0,0,1-1.36-1.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.56,324a6.67,6.67,0,0,0-3.29.79l-89.12,51.45a2.31,2.31,0,0,0-1.36,1.9v21.39a2.3,2.3,0,0,0,1.36,1.9l75.6,43.67a6.67,6.67,0,0,0,3.29.79V420.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.74,423.69,154.14,380c-1.82-1-1.82-2.75,0-3.8l89.12-51.45a7.27,7.27,0,0,1,6.58,0l75.6,43.67c1.82,1.05,1.82,2.75,0,3.8l-89.12,51.45A7.27,7.27,0,0,1,229.74,423.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadows-1--inject-168"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-168",
    points: "274.97 458.7 354.36 412.87 341.49 405.44 262.1 451.27 274.97 458.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M285.08,298.24l61.3,35.39a5.93,5.93,0,0,0,5.41,0l90.86-52.45c1.49-.86,1.49-2.26,0-3.13l-61.3-35.39a6,6,0,0,0-5.42,0l-90.85,52.46C283.58,296,283.58,297.38,285.08,298.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M105.84,302.72,69.42,281.81a.42.42,0,0,1,0-.79l26.41-15.33a1.48,1.48,0,0,1,1.36,0l36.42,20.91a.42.42,0,0,1,0,.79L107.2,302.72A1.48,1.48,0,0,1,105.84,302.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M192.3,287l-32.19-18.58a4.28,4.28,0,0,0-3.91,0L86.61,308.6a1.19,1.19,0,0,0,0,2.26l32.18,18.58a4.36,4.36,0,0,0,3.92,0l69.59-40.18A1.19,1.19,0,0,0,192.3,287Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M150.3,457.13c-9.48-5.48-9.48-14.36,0-19.84s24.87-5.48,34.35,0,9.49,14.36,0,19.84S159.79,462.61,150.3,457.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M374.18,444.33c-11.23-6.48-11.23-17,0-23.48s29.45-6.49,40.68,0,11.23,17,0,23.49S385.41,450.82,374.18,444.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M151.58,165.61c-9,5.17-9,13.55,0,18.72s23.47,5.17,32.42,0,9-13.55,0-18.72S160.54,160.44,151.58,165.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M201.27,165.61c-9,5.17-9,13.55,0,18.72s23.47,5.17,32.42,0,8.95-13.55,0-18.72S210.22,160.44,201.27,165.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M238.51,122.18l4.69-2.71a3.62,3.62,0,0,1,3.44.08l24.24,15.64c4.74-2.76,11.27-4.47,18.49-4.47,14.45,0,26.15,6.84,26.15,15.27s-11.7,15.26-26.15,15.26-26.15-6.83-26.15-15.26a10.77,10.77,0,0,1,3.3-7.43l-28-14.45C237.56,123.6,237.54,122.74,238.51,122.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M66.76,289.66c3.85,2.26,3.85,5.91,0,8.16a15.3,15.3,0,0,1-14,0c-3.86-2.25-3.86-5.9,0-8.16A15.3,15.3,0,0,1,66.76,289.66Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrow--inject-168"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "291.27 436.08 302 442.27 290.43 431.48 279.7 425.28 291.27 436.08",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.7 425.28 291.27 436.08 302 442.27 290.43 431.48 279.7 425.28",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.85 397.45 320.58 403.64 338.67 421.1 327.94 414.91 309.85 397.45",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.85 397.45 320.58 403.64 338.67 421.1 327.94 414.91 309.85 397.45",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.53 448.79 279.26 454.99 290.43 431.48 279.7 425.28 268.53 448.79",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.54 433.44 302 442.27 320.58 403.64 309.85 397.45 292.54 433.44",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.3 412.06 338.67 421.1 366.88 362.11 356.15 355.91 329.3 412.06",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.38 354 370.45 364.44 369.19 342.95 352.38 354",
    style: {
      fill: "#10E2ED"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.84,295.08c-3.17-3.27-5-11.54-1.94-14.14H67.64c3.09,2.6,1.23,10.86-1.94,14.13l-.08.09-.11.11-.29.26-.08.06-.24.18a3.62,3.62,0,0,1-.41.27,10.34,10.34,0,0,1-9.44,0h0a3.62,3.62,0,0,1-.41-.27l-.23-.17-.09-.07-.28-.25-.12-.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.27,279.9c3.59,2.09,3.59,5.49,0,7.59a14.2,14.2,0,0,1-13,0c-3.59-2.1-3.59-5.5,0-7.59A14.2,14.2,0,0,1,66.27,279.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.55,280.91c2.63,1.53,2.63,4,0,5.57a10.45,10.45,0,0,1-9.55,0c-2.64-1.54-2.64-4,0-5.57A10.45,10.45,0,0,1,64.55,280.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,283.55a10.45,10.45,0,0,1,9.55,0A4.44,4.44,0,0,1,66.13,285a4.51,4.51,0,0,1-1.58,1.46,10.45,10.45,0,0,1-9.55,0A4.34,4.34,0,0,1,53.42,285,4.28,4.28,0,0,1,55,283.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.62,268.42c-1.06,1.35-4.26,1.94-5.85-1.35-1.49-3.09-3.07-6-3.54-7.13a1.2,1.2,0,0,1,.65-1.61s0-1.76,3-.8a11,11,0,0,1,6.79,5.4C60.17,265.7,59.57,267.88,57.62,268.42Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.62,268.42c-1.06,1.35-4.26,1.94-5.85-1.35-1.49-3.09-3.07-6-3.54-7.13a1.2,1.2,0,0,1,.65-1.61s0-1.76,3-.8a11,11,0,0,1,6.79,5.4C60.17,265.7,59.57,267.88,57.62,268.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.24,272.81a14.76,14.76,0,0,0-.39-1.75,24.79,24.79,0,0,0-1.24-3.34,25.43,25.43,0,0,0-3.92-6.07,21.85,21.85,0,0,0-2.92-2.85s-.05,0,0,.07a26.75,26.75,0,0,1,4.66,5.51,27.25,27.25,0,0,1,3,6.42c.19.64.38,1.27.55,1.91s.29,1.32.45,2c0,.06.12.1.12,0A11.78,11.78,0,0,0,59.24,272.81Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.24,272.81a14.76,14.76,0,0,0-.39-1.75,24.79,24.79,0,0,0-1.24-3.34,25.43,25.43,0,0,0-3.92-6.07,21.85,21.85,0,0,0-2.92-2.85s-.05,0,0,.07a26.75,26.75,0,0,1,4.66,5.51,27.25,27.25,0,0,1,3,6.42c.19.64.38,1.27.55,1.91s.29,1.32.45,2c0,.06.12.1.12,0A11.78,11.78,0,0,0,59.24,272.81Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.08,266.07c-2.77.85-4.83-1.31-4.12-4.7s4.28-7.15,5.62-6.14c.84-.84,2.69-.54,3.56,2.22S66.22,267.27,61.08,266.07Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.08,266.07c-2.77.85-4.83-1.31-4.12-4.7s4.28-7.15,5.62-6.14c.84-.84,2.69-.54,3.56,2.22S66.22,267.27,61.08,266.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,257.29a38.14,38.14,0,0,0-1.84,6.09,59.8,59.8,0,0,0-1.07,6.38,42.07,42.07,0,0,0-.55,8.08c0,1.15,0,2.31,0,3.46s0,2.39.11,3.57c0,.45.68.33.69-.08,0-2.08-.07-4.17-.09-6.24a14.44,14.44,0,0,1,0-1.74,86.92,86.92,0,0,1,1.13-12.48c.19-1.15.41-2.3.68-3.44s.63-2.37.94-3.55C62.78,257.29,62.73,257.23,62.7,257.29Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,257.29a38.14,38.14,0,0,0-1.84,6.09,59.8,59.8,0,0,0-1.07,6.38,42.07,42.07,0,0,0-.55,8.08c0,1.15,0,2.31,0,3.46s0,2.39.11,3.57c0,.45.68.33.69-.08,0-2.08-.07-4.17-.09-6.24a14.44,14.44,0,0,1,0-1.74,86.92,86.92,0,0,1,1.13-12.48c.19-1.15.41-2.3.68-3.44s.63-2.37.94-3.55C62.78,257.29,62.73,257.23,62.7,257.29Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.67,275.23c-.36,1.79-2.81,3.08-5.65,1.91s-8.43-8.55-5.88-9.36c-.14-1.34,7.59-2.44,11.42,2.27C57.34,273.48,54.67,275.23,54.67,275.23Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.67,275.23c-.36,1.79-2.81,3.08-5.65,1.91s-8.43-8.55-5.88-9.36c-.14-1.34,7.59-2.44,11.42,2.27C57.34,273.48,54.67,275.23,54.67,275.23Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.73,277.89a15.45,15.45,0,0,0-1.16-1.27c-.83-.82-1.7-1.59-2.6-2.33a35.52,35.52,0,0,0-6-3.85,31.69,31.69,0,0,0-3.61-1.64s0,.05,0,.06c1,.49,2.07,1,3.06,1.52a34.66,34.66,0,0,1,3,1.9,43.81,43.81,0,0,1,5.28,4.32c.47.45.91.92,1.38,1.37s1,.88,1.49,1.36c.07.07.19,0,.11-.06C59.37,278.81,59.07,278.34,58.73,277.89Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73,277.89a15.45,15.45,0,0,0-1.16-1.27c-.83-.82-1.7-1.59-2.6-2.33a35.52,35.52,0,0,0-6-3.85,31.69,31.69,0,0,0-3.61-1.64s0,.05,0,.06c1,.49,2.07,1,3.06,1.52a34.66,34.66,0,0,1,3,1.9,43.81,43.81,0,0,1,5.28,4.32c.47.45.91.92,1.38,1.37s1,.88,1.49,1.36c.07.07.19,0,.11-.06C59.37,278.81,59.07,278.34,58.73,277.89Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.38,273.07c0-1-5.14-1-7.52,1s-2.67,3.8-1.18,4.45c-.26,2.13,3.1,3.54,6.11.87S71.46,273.28,70.38,273.07Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.38,273.07c0-1-5.14-1-7.52,1s-2.67,3.8-1.18,4.45c-.26,2.13,3.1,3.54,6.11.87S71.46,273.28,70.38,273.07Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.36,275.74a12.43,12.43,0,0,0-5.61,4.93c-.08.13.11.37.19.23a14.61,14.61,0,0,1,5.43-5.13S65.39,275.73,65.36,275.74Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.36,275.74a12.43,12.43,0,0,0-5.61,4.93c-.08.13.11.37.19.23a14.61,14.61,0,0,1,5.43-5.13S65.39,275.73,65.36,275.74Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,281.76c-1.72,1.69.18,3.79,3,4.82a10,10,0,0,0,7.23-.33,5.5,5.5,0,0,0,1.62-1,17.44,17.44,0,0,0-1.42-3.42,7.16,7.16,0,0,0-7-3.24C61.76,279,61.47,280.53,62,281.76Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62,281.76c-1.72,1.69.18,3.79,3,4.82a10,10,0,0,0,7.23-.33,5.5,5.5,0,0,0,1.62-1,17.44,17.44,0,0,0-1.42-3.42,7.16,7.16,0,0,0-7-3.24C61.76,279,61.47,280.53,62,281.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.21,283a17.62,17.62,0,0,0-4.38-1.62c-1.5-.29-3.34-.3-4.55.76-.47.42-1.1,1.31-.72,1.95,0,.06.23.18.27.05a6.69,6.69,0,0,1,.39-1.17,2.28,2.28,0,0,1,.94-.88,5.48,5.48,0,0,1,3.17-.54,17.55,17.55,0,0,1,4.88,1.49S69.23,283,69.21,283Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.21,283a17.62,17.62,0,0,0-4.38-1.62c-1.5-.29-3.34-.3-4.55.76-.47.42-1.1,1.31-.72,1.95,0,.06.23.18.27.05a6.69,6.69,0,0,1,.39-1.17,2.28,2.28,0,0,1,.94-.88,5.48,5.48,0,0,1,3.17-.54,17.55,17.55,0,0,1,4.88,1.49S69.23,283,69.21,283Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.45,271.1c-.43,1.51,1.5,2.92,3.91,2.11a24.52,24.52,0,0,1,6.94-1.58c2,0,3.35-1.38,2.93-2.29s-.92-3.06-6.14-3.68-7.57,1.23-8.66,2.67S61.58,271.35,62.45,271.1Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.45,271.1c-.43,1.51,1.5,2.92,3.91,2.11a24.52,24.52,0,0,1,6.94-1.58c2,0,3.35-1.38,2.93-2.29s-.92-3.06-6.14-3.68-7.57,1.23-8.66,2.67S61.58,271.35,62.45,271.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.15,267.91a6.78,6.78,0,0,0-1.68-.15,10.88,10.88,0,0,0-4.7,1.09,11.44,11.44,0,0,0-4.84,3.53,11.69,11.69,0,0,0-1.54,2.87c-.07.2.31.31.39.13a21.22,21.22,0,0,1,1.31-2.5,7.62,7.62,0,0,1,2-2.08,15.82,15.82,0,0,1,5.53-2.54,10.8,10.8,0,0,1,1.77-.26,17.34,17.34,0,0,1,1.77.07C72.24,268.07,72.21,267.93,72.15,267.91Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.15,267.91a6.78,6.78,0,0,0-1.68-.15,10.88,10.88,0,0,0-4.7,1.09,11.44,11.44,0,0,0-4.84,3.53,11.69,11.69,0,0,0-1.54,2.87c-.07.2.31.31.39.13a21.22,21.22,0,0,1,1.31-2.5,7.62,7.62,0,0,1,2-2.08,15.82,15.82,0,0,1,5.53-2.54,10.8,10.8,0,0,1,1.77-.26,17.34,17.34,0,0,1,1.77.07C72.24,268.07,72.21,267.93,72.15,267.91Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,279.63c-.4-1.56-2.38-2.43-5-2.63a6.75,6.75,0,0,0-6.41,3.3c-1.35,2.3-1.91,4.14-1.09,4.44a45.88,45.88,0,0,0,6.52,1c2.24.2,5-.2,6.86-1.9S60.31,280,58.17,279.63Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,279.63c-.4-1.56-2.38-2.43-5-2.63a6.75,6.75,0,0,0-6.41,3.3c-1.35,2.3-1.91,4.14-1.09,4.44a45.88,45.88,0,0,0,6.52,1c2.24.2,5-.2,6.86-1.9S60.31,280,58.17,279.63Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.27,279.42a6.86,6.86,0,0,0-2.78-.13,11.83,11.83,0,0,0-2.63.61,16.92,16.92,0,0,0-2.61,1.17c-.43.24-.86.49-1.28.76a9.19,9.19,0,0,0-1.16.8s0,.06,0,.05c.42-.19.82-.46,1.22-.68l1.32-.72A19.35,19.35,0,0,1,53,280.19a12.88,12.88,0,0,1,2.74-.59,16.26,16.26,0,0,1,2.61.07C58.48,279.68,58.38,279.46,58.27,279.42Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.27,279.42a6.86,6.86,0,0,0-2.78-.13,11.83,11.83,0,0,0-2.63.61,16.92,16.92,0,0,0-2.61,1.17c-.43.24-.86.49-1.28.76a9.19,9.19,0,0,0-1.16.8s0,.06,0,.05c.42-.19.82-.46,1.22-.68l1.32-.72A19.35,19.35,0,0,1,53,280.19a12.88,12.88,0,0,1,2.74-.59,16.26,16.26,0,0,1,2.61.07C58.48,279.68,58.38,279.46,58.27,279.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.7,135.63h0a1.36,1.36,0,0,0,1.38-.13,4.32,4.32,0,0,0,1.95-3.37,1.37,1.37,0,0,0-.57-1.26h0l-24.23-15.33h0a1.86,1.86,0,0,0-2,.13,6.06,6.06,0,0,0-2.73,4.71,1.87,1.87,0,0,0,.87,1.8h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,132.13c0-1.24-.87-1.75-1.94-1.13a4.3,4.3,0,0,0-2,3.37c0,1.24.87,1.75,1.95,1.13A4.32,4.32,0,0,0,270,132.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.89,137.41a2.62,2.62,0,0,0,1.19-2,.85.85,0,0,0-.35-.77h0l-4.81-2.8h0a.84.84,0,0,0-.84.08,2.62,2.62,0,0,0-1.18,2,.83.83,0,0,0,.34.76l4.82,2.8h0A.8.8,0,0,0,272.89,137.41Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.89,137.41a2.62,2.62,0,0,0,1.19-2,.85.85,0,0,0-.35-.77h0l-4.81-2.8h0a.84.84,0,0,0-.84.08,2.62,2.62,0,0,0-1.18,2,.83.83,0,0,0,.34.76l4.82,2.8h0A.8.8,0,0,0,272.89,137.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.63,133.54c.18-.14.36-.28.55-.41l2.54,1.47a14.74,14.74,0,0,0-2.83,2.22l-2.32-1.35a2,2,0,0,1,.19-.22A14.85,14.85,0,0,1,270.63,133.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.17,131.79l-24.93-15.31a4.9,4.9,0,0,1,1-.8,1.86,1.86,0,0,1,2-.13h0l24.23,15.33a1.36,1.36,0,0,0-1.38.13A3.54,3.54,0,0,0,267.17,131.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.44,145c-.06,3.31,2.1,6.64,6.5,9.17,8.7,5,22.8,5,31.5,0,4.38-2.53,6.57-5.84,6.56-9.14,0-.45,0-2.91,0-3.45,0-.14,0-.29,0-.43s0-.14,0-.2a8.22,8.22,0,0,0-.4-1.87c0-.08-.06-.17-.1-.26a3.45,3.45,0,0,0-.14-.34,1.89,1.89,0,0,0-.11-.25c-.09-.19-.19-.38-.29-.57s-.2-.34-.31-.51-.15-.25-.24-.37l-.2-.27a12.47,12.47,0,0,0-1.25-1.42c-.18-.18-.37-.35-.57-.53a16.77,16.77,0,0,0-2.19-1.61c-.21-.13-.42-.26-.64-.38-8.64-5-22.75-5-31.5,0a20.71,20.71,0,0,0-2.24,1.48,14.86,14.86,0,0,0-1.78,1.63,10.48,10.48,0,0,0-1.12,1.43l-.19.29c-.06.1-.12.2-.17.3s-.11.2-.16.3l-.11.21a2.56,2.56,0,0,0-.11.24c-.1.22-.19.45-.27.67l-.09.26c-.09.31-.17.62-.23.93,0,.09,0,.17,0,.25s-.06.45-.07.68a2.81,2.81,0,0,0,0,.29v.23C267.43,142.55,267.45,144.61,267.44,145Zm42.05-3.42c0,2.51-1.88,5-5.3,7a32.36,32.36,0,0,1-29,0c-3.39-2-5.25-4.4-5.25-6.88s1.9-4.95,5.33-6.91a29.93,29.93,0,0,1,14.56-3.41,29.38,29.38,0,0,1,14.45,3.41C307.64,136.67,309.49,139.09,309.49,141.57Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.44,145c-.06,3.31,2.1,6.64,6.5,9.17,8.7,5,22.8,5,31.5,0,4.38-2.53,6.57-5.84,6.56-9.14,0-.45,0-2.91,0-3.45,0-.14,0-.29,0-.43s0-.14,0-.2a8.22,8.22,0,0,0-.4-1.87c0-.08-.06-.17-.1-.26a3.45,3.45,0,0,0-.14-.34,1.89,1.89,0,0,0-.11-.25c-.09-.19-.19-.38-.29-.57s-.2-.34-.31-.51-.15-.25-.24-.37l-.2-.27a12.47,12.47,0,0,0-1.25-1.42c-.18-.18-.37-.35-.57-.53a16.77,16.77,0,0,0-2.19-1.61c-.21-.13-.42-.26-.64-.38-8.64-5-22.75-5-31.5,0a20.71,20.71,0,0,0-2.24,1.48,14.86,14.86,0,0,0-1.78,1.63,10.48,10.48,0,0,0-1.12,1.43l-.19.29c-.06.1-.12.2-.17.3s-.11.2-.16.3l-.11.21a2.56,2.56,0,0,0-.11.24c-.1.22-.19.45-.27.67l-.09.26c-.09.31-.17.62-.23.93,0,.09,0,.17,0,.25s-.06.45-.07.68a2.81,2.81,0,0,0,0,.29v.23C267.43,142.55,267.45,144.61,267.44,145Zm42.05-3.42c0,2.51-1.88,5-5.3,7a32.36,32.36,0,0,1-29,0c-3.39-2-5.25-4.4-5.25-6.88s1.9-4.95,5.33-6.91a29.93,29.93,0,0,1,14.56-3.41,29.38,29.38,0,0,1,14.45,3.41C307.64,136.67,309.49,139.09,309.49,141.57Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.44,141.75h2.5c0,2.48,1.86,4.81,5.25,6.77a29.22,29.22,0,0,0,14,3.43v6a31.92,31.92,0,0,1-15.26-3.76c-4.4-2.53-6.56-5.86-6.5-9.17C267.45,144.61,267.43,142.55,267.44,141.75Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.44,141.75c0,3.24,2.21,6.47,6.5,8.94,8.7,5,22.8,5,31.5,0,4.37-2.52,6.56-5.82,6.56-9.12,0-.14,0-.29,0-.43s0-.14,0-.2a8.22,8.22,0,0,0-.4-1.87c0-.08-.06-.17-.1-.26a3.45,3.45,0,0,0-.14-.34,1.89,1.89,0,0,0-.11-.25c-.09-.19-.19-.38-.29-.57s-.2-.34-.31-.51-.15-.25-.24-.37l-.2-.27a12.47,12.47,0,0,0-1.25-1.42c-.18-.18-.37-.35-.57-.53a16.77,16.77,0,0,0-2.19-1.61c-.21-.13-.42-.26-.64-.38-8.64-5-22.75-5-31.5,0a20.71,20.71,0,0,0-2.24,1.48,15.74,15.74,0,0,0-1.78,1.63,10.48,10.48,0,0,0-1.12,1.43l-.19.29c-.06.1-.12.2-.17.3s-.11.2-.16.3l-.11.21a2.56,2.56,0,0,0-.11.24c-.1.22-.19.45-.27.67l-.09.26c-.09.31-.17.62-.23.93,0,.09,0,.17,0,.25s-.06.45-.07.68a2.81,2.81,0,0,0,0,.29Zm2.5-.11c0-2.5,1.9-4.95,5.33-6.91a29.93,29.93,0,0,1,14.56-3.41,29.38,29.38,0,0,1,14.45,3.41c3.36,1.94,5.21,4.36,5.21,6.84s-1.88,5-5.3,7a32.36,32.36,0,0,1-29,0C271.8,146.56,269.94,144.12,269.94,141.64Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.44,141.75c0,3.24,2.21,6.47,6.5,8.94,8.7,5,22.8,5,31.5,0,4.37-2.52,6.56-5.82,6.56-9.12,0-.14,0-.29,0-.43s0-.14,0-.2a8.22,8.22,0,0,0-.4-1.87c0-.08-.06-.17-.1-.26a3.45,3.45,0,0,0-.14-.34,1.89,1.89,0,0,0-.11-.25c-.09-.19-.19-.38-.29-.57s-.2-.34-.31-.51-.15-.25-.24-.37l-.2-.27a12.47,12.47,0,0,0-1.25-1.42c-.18-.18-.37-.35-.57-.53a16.77,16.77,0,0,0-2.19-1.61c-.21-.13-.42-.26-.64-.38-8.64-5-22.75-5-31.5,0a20.71,20.71,0,0,0-2.24,1.48,15.74,15.74,0,0,0-1.78,1.63,10.48,10.48,0,0,0-1.12,1.43l-.19.29c-.06.1-.12.2-.17.3s-.11.2-.16.3l-.11.21a2.56,2.56,0,0,0-.11.24c-.1.22-.19.45-.27.67l-.09.26c-.09.31-.17.62-.23.93,0,.09,0,.17,0,.25s-.06.45-.07.68a2.81,2.81,0,0,0,0,.29Zm2.5-.11c0-2.5,1.9-4.95,5.33-6.91a29.93,29.93,0,0,1,14.56-3.41,29.38,29.38,0,0,1,14.45,3.41c3.36,1.94,5.21,4.36,5.21,6.84s-1.88,5-5.3,7a32.36,32.36,0,0,1-29,0C271.8,146.56,269.94,144.12,269.94,141.64Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.94,141.64a5.44,5.44,0,0,0,.16,1.26c.52-2.06,2.32-4,5.17-5.66a29.93,29.93,0,0,1,14.56-3.41,29.38,29.38,0,0,1,14.45,3.41c2.79,1.6,4.54,3.55,5.05,5.58a4.82,4.82,0,0,0,.16-1.25c0-2.48-1.85-4.9-5.21-6.84a29.38,29.38,0,0,0-14.45-3.41,29.93,29.93,0,0,0-14.56,3.41C271.84,136.69,270,139.14,269.94,141.64Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.94,141.64a5.44,5.44,0,0,0,.16,1.26c.52-2.06,2.32-4,5.17-5.66a29.93,29.93,0,0,1,14.56-3.41,29.38,29.38,0,0,1,14.45,3.41c2.79,1.6,4.54,3.55,5.05,5.58a4.82,4.82,0,0,0,.16-1.25c0-2.48-1.85-4.9-5.21-6.84a29.38,29.38,0,0,0-14.45-3.41,29.93,29.93,0,0,0-14.56,3.41C271.84,136.69,270,139.14,269.94,141.64Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,142.29c.3,2.25,2.12,4.45,5.21,6.23a32.36,32.36,0,0,0,29,0c3.13-1.81,5-4,5.26-6.31-.29-2.26-2.1-4.44-5.17-6.22a29.48,29.48,0,0,0-14.45-3.4A29.93,29.93,0,0,0,275.27,136C272.12,137.79,270.27,140,270,142.29Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.66,293.74a5.12,5.12,0,0,0,2.39,4L347,330a5.23,5.23,0,0,0,4.78,0l87.29-50.39a4.49,4.49,0,0,0,0-7.94l-56-32.3a5.3,5.3,0,0,0-4.78,0l-87.28,50.39A5.12,5.12,0,0,0,288.66,293.74Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.66,293.74a5.12,5.12,0,0,0,2.39,4L347,330a5.23,5.23,0,0,0,4.78,0l87.29-50.39a4.49,4.49,0,0,0,0-7.94l-56-32.3a5.3,5.3,0,0,0-4.78,0l-87.28,50.39A5.12,5.12,0,0,0,288.66,293.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.05,292.53,347,324.84a5.3,5.3,0,0,0,4.78,0l87.29-50.4c1.32-.76,1.32-2,0-2.76l-56-32.3a5.3,5.3,0,0,0-4.78,0l-87.28,50.39C289.73,290.53,289.73,291.77,291.05,292.53Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.05,292.53,347,324.84a5.3,5.3,0,0,0,4.78,0l87.29-50.4c1.32-.76,1.32-2,0-2.76l-56-32.3a5.3,5.3,0,0,0-4.78,0l-87.28,50.39C289.73,290.53,289.73,291.77,291.05,292.53Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.4,325.41v5.17A4.85,4.85,0,0,1,347,330l-56-32.31a4.47,4.47,0,0,1-.24-7.78c-1.07.76-1,1.89.24,2.6l56,32.31A4.86,4.86,0,0,0,349.4,325.41Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.4,325.41v5.17A4.85,4.85,0,0,1,347,330l-56-32.31a4.47,4.47,0,0,1-.24-7.78c-1.07.76-1,1.89.24,2.6l56,32.31A4.86,4.86,0,0,0,349.4,325.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.28,163.65a4.12,4.12,0,0,0-4.36-.13l-87.28,50.39a5.3,5.3,0,0,0-2.39,4.14v68.36h0a4.11,4.11,0,0,0,2.28,3.71,3.47,3.47,0,0,0,3.53-.36h0l87.28-50.39a5.29,5.29,0,0,0,2.39-4.14V166.88A3.43,3.43,0,0,0,379.28,163.65Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.28,163.65a4.12,4.12,0,0,0-4.36-.13l-87.28,50.39a5.3,5.3,0,0,0-2.39,4.14v68.36h0a4.11,4.11,0,0,0,2.28,3.71,3.47,3.47,0,0,0,3.53-.36h0l87.28-50.39a5.29,5.29,0,0,0,2.39-4.14V166.88A3.43,3.43,0,0,0,379.28,163.65Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.72,166.88c0-1.52-1.07-2.14-2.39-1.38l-87.28,50.4a4.84,4.84,0,0,0-1.69,1.78l-3.41-2h0a4.87,4.87,0,0,1,1.69-1.79l87.28-50.39a4.14,4.14,0,0,1,4.36.12A3.47,3.47,0,0,1,380.72,166.88Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.72,166.88c0-1.52-1.07-2.14-2.39-1.38l-87.28,50.4a4.84,4.84,0,0,0-1.69,1.78l-3.41-2h0a4.87,4.87,0,0,1,1.69-1.79l87.28-50.39a4.14,4.14,0,0,1,4.36.12A3.47,3.47,0,0,1,380.72,166.88Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.67,288.38V220a4.9,4.9,0,0,1,.7-2.35h0l-3.41-2a4.79,4.79,0,0,0-.7,2.35v68.37a4.11,4.11,0,0,0,2.28,3.71,3.47,3.47,0,0,0,3.53-.36C289.74,290.53,288.67,289.91,288.67,288.38Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.67,288.38V220a4.9,4.9,0,0,1,.7-2.35h0l-3.41-2a4.79,4.79,0,0,0-.7,2.35v68.37a4.11,4.11,0,0,0,2.28,3.71,3.47,3.47,0,0,0,3.53-.36C289.74,290.53,288.67,289.91,288.67,288.38Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.34,218.65l84-48.48c.79-.45,1.44-.08,1.44.83v63.57a3.17,3.17,0,0,1-1.44,2.48l-84,48.48c-.79.46-1.44.09-1.44-.83V221.14A3.19,3.19,0,0,1,292.34,218.65Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.34,218.65l84-48.48c.79-.45,1.44-.08,1.44.83v63.57a3.17,3.17,0,0,1-1.44,2.48l-84,48.48c-.79.46-1.44.09-1.44-.83V221.14A3.19,3.19,0,0,1,292.34,218.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.34,218.65a3.19,3.19,0,0,0-1.44,2.49V283.6l83-47.93a3.18,3.18,0,0,0,1.43-2.48V170.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.43,290.18l80.21-46.31a2.5,2.5,0,0,1,2.26,0l2.92,1.64a.69.69,0,0,1,0,1.3l-80.22,46.3a2.5,2.5,0,0,1-2.26,0l-2.91-1.63A.69.69,0,0,1,298.43,290.18Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.43,290.18l80.21-46.31a2.5,2.5,0,0,1,2.26,0l2.92,1.64a.69.69,0,0,1,0,1.3l-80.22,46.3a2.5,2.5,0,0,1-2.26,0l-2.91-1.63A.69.69,0,0,1,298.43,290.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.31,294.82l80.21-46.31a2.29,2.29,0,0,1,2.06-.11l20.87,12.06c.52.29.43.82-.19,1.18l-80.11,46.25a2.31,2.31,0,0,1-2.07.11l-21-12C305.6,295.71,305.69,295.18,306.31,294.82Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.31,294.82l80.21-46.31a2.29,2.29,0,0,1,2.06-.11l20.87,12.06c.52.29.43.82-.19,1.18l-80.11,46.25a2.31,2.31,0,0,1-2.07.11l-21-12C305.6,295.71,305.69,295.18,306.31,294.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.74,288.38,337.33,287a.41.41,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.4,1.39a.41.41,0,0,0,.36,0l2.51-1.45C339.82,288.53,339.83,288.43,339.74,288.38Zm-8.74-1.7,2.41,1.39a.41.41,0,0,0,.36,0l2.51-1.45c.11-.07.12-.16,0-.21L333.9,285a.38.38,0,0,0-.36,0L331,286.47C330.92,286.53,330.91,286.63,331,286.68Zm8.12-4.68,2.4,1.38a.38.38,0,0,0,.36,0l4.25-2.45c.11-.06.12-.16,0-.21l-2.41-1.39a.41.41,0,0,0-.36,0l-4.25,2.46C339,281.85,339,281.94,339.12,282Zm-4.45,2.56,2.41,1.39a.41.41,0,0,0,.36,0l2.51-1.45c.11-.06.12-.16,0-.21l-2.4-1.39a.38.38,0,0,0-.36,0l-2.52,1.45C334.59,284.41,334.58,284.51,334.67,284.56Zm9.86-5.69,2.4,1.39a.38.38,0,0,0,.36,0l2.51-1.45c.11-.06.12-.16,0-.21l-2.41-1.39a.41.41,0,0,0-.36,0l-2.51,1.45C344.44,278.73,344.43,278.82,344.53,278.87Zm3.67-2.11,2.4,1.38a.38.38,0,0,0,.36,0l2.51-1.45c.11-.06.12-.16,0-.21l-2.41-1.39a.39.39,0,0,0-.36,0l-2.51,1.44C348.11,276.61,348.1,276.7,348.2,276.76Zm9.84,5-2.4-1.39a.39.39,0,0,0-.36,0l-2.52,1.45c-.1.06-.11.15,0,.21l2.41,1.38a.38.38,0,0,0,.36,0L358,282C358.13,281.92,358.14,281.83,358,281.77Zm3.67-2.12-2.4-1.39a.42.42,0,0,0-.36,0l-2.52,1.45c-.1.06-.11.15,0,.21l2.41,1.38a.38.38,0,0,0,.36,0l2.51-1.45C361.8,279.8,361.81,279.71,361.71,279.65Zm3.67-2.12-2.4-1.38a.38.38,0,0,0-.36,0l-2.52,1.45c-.1.06-.11.15,0,.21l2.41,1.39a.39.39,0,0,0,.36,0l2.51-1.45C365.47,277.68,365.48,277.59,365.38,277.53Zm3.67-2.12-2.4-1.38a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21l2.41,1.39a.39.39,0,0,0,.36,0l2.51-1.45C369.14,275.56,369.15,275.47,369.05,275.41Zm-25.64,10.85L341,284.87a.41.41,0,0,0-.36,0l-2.51,1.45c-.11.07-.12.16,0,.21l2.4,1.39a.38.38,0,0,0,.36,0l2.51-1.45C343.49,286.41,343.5,286.31,343.41,286.26Zm11-2.37L352,282.5a.41.41,0,0,0-.37,0l-2.31,1.33a.41.41,0,0,1-.37,0l-3.09-1.79a.39.39,0,0,0-.36,0l-2.9,1.67c-.11.06-.12.15,0,.21l5.83,3.37a.44.44,0,0,0,.37,0l5.6-3.24C354.46,284,354.47,283.94,354.37,283.89Zm-2.5-9.25,2.4,1.38a.38.38,0,0,0,.36,0l2.52-1.45c.1-.06.11-.15,0-.21L354.76,273a.39.39,0,0,0-.36,0l-2.51,1.45C351.78,274.49,351.77,274.58,351.87,274.64Zm3.67-2.12,2.4,1.38a.38.38,0,0,0,.36,0l2.52-1.45c.1-.06.11-.15,0-.21l-2.41-1.39a.42.42,0,0,0-.36,0l-2.51,1.45C355.45,272.37,355.44,272.46,355.54,272.52Zm36.8-13.33a.39.39,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21l2.4,1.38a.38.38,0,0,0,.36,0l2.51-1.45c.11-.06.12-.15,0-.21Zm-7.44-3.63,2.4,1.39a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21l-2.4-1.39a.44.44,0,0,0-.37,0l-2.51,1.45C384.81,255.42,384.81,255.51,384.9,255.56Zm5,1.09a.41.41,0,0,0-.37,0L387,258.12c-.11.06-.12.15,0,.21l2.4,1.38a.4.4,0,0,0,.37,0l2.51-1.45c.11-.06.11-.15,0-.21Zm6.37,7-2.41-1.39a.41.41,0,0,0-.36,0L391,263.75c-.11.06-.12.16,0,.21l2.4,1.39a.41.41,0,0,0,.36,0l2.52-1.45C396.33,263.83,396.34,263.73,396.25,263.68Zm1.26-3.51a.41.41,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.4,1.39a.38.38,0,0,0,.36,0l2.52-1.45c.1-.06.11-.16,0-.21Zm-16.28-2.49,2.4,1.39a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21l-2.4-1.39a.44.44,0,0,0-.37,0l-2.51,1.45C381.14,257.53,381.13,257.63,381.23,257.68Zm-18.35,10.6,2.4,1.39a.38.38,0,0,0,.36,0l2.52-1.45c.1-.06.11-.15,0-.21l-2.4-1.38a.4.4,0,0,0-.37,0l-2.51,1.45C362.79,268.13,362.78,268.22,362.88,268.28Zm14.68-8.48,2.4,1.39a.44.44,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21l-2.4-1.39a.44.44,0,0,0-.37,0l-2.51,1.45C377.47,259.65,377.46,259.75,377.56,259.8Zm-18.35,10.6,2.4,1.39a.42.42,0,0,0,.36,0l2.52-1.45c.1-.06.11-.15,0-.21l-2.41-1.38a.38.38,0,0,0-.36,0l-2.51,1.45C359.12,270.25,359.11,270.34,359.21,270.4Zm7.34-4.24,2.4,1.39a.41.41,0,0,0,.37,0l2.51-1.45c.1-.06.11-.15,0-.21l-2.4-1.38a.4.4,0,0,0-.37,0L366.57,266C366.46,266,366.45,266.11,366.55,266.16Zm3.67-2.12,2.4,1.39a.44.44,0,0,0,.37,0L375.5,264c.1-.07.11-.16,0-.21l-2.4-1.39a.4.4,0,0,0-.37,0l-2.51,1.45C370.13,263.89,370.12,264,370.22,264Zm3.67-2.12,2.4,1.39a.44.44,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21l-2.4-1.39a.4.4,0,0,0-.37,0l-2.51,1.45C373.8,261.77,373.79,261.87,373.89,261.92Zm2.5,9.26-2.4-1.39a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.41,1.39a.41.41,0,0,0,.36,0l2.51-1.45C376.48,271.32,376.49,271.23,376.39,271.18Zm-53.5,20.19,2.4,1.38a.4.4,0,0,0,.37,0l2.51-1.45c.11-.06.11-.16,0-.21l-2.4-1.39a.41.41,0,0,0-.37,0l-2.51,1.45C322.81,291.22,322.8,291.31,322.89,291.37Zm4.44-2.57,2.41,1.39a.41.41,0,0,0,.36,0l2.51-1.45c.11-.07.12-.16,0-.22l-2.4-1.38a.38.38,0,0,0-.36,0l-2.52,1.45C327.25,288.65,327.24,288.75,327.33,288.8Zm-8.11,4.69,2.4,1.38a.4.4,0,0,0,.37,0l2.51-1.45c.11-.06.11-.16,0-.21l-2.4-1.39a.44.44,0,0,0-.37,0l-2.51,1.45C319.13,293.34,319.13,293.43,319.22,293.49Zm32.69-12.14L349.5,280a.39.39,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21L349,283a.38.38,0,0,0,.36,0l2.51-1.45C352,281.5,352,281.41,351.91,281.35ZM318,297a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21l-2.4-1.39a.44.44,0,0,0-.37,0l-2.51,1.45c-.11.06-.12.16,0,.21Zm54.77-23.7-2.4-1.38a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.41,1.39a.41.41,0,0,0,.36,0l2.51-1.45C372.81,273.44,372.82,273.35,372.72,273.29Zm-45,26-2.4-1.39a.42.42,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21l2.41,1.38a.38.38,0,0,0,.36,0l2.51-1.45C327.8,299.43,327.81,299.34,327.71,299.28Zm.24-4.1-2.4-1.39a.41.41,0,0,0-.37,0l-2.51,1.45c-.1.06-.11.15,0,.21l2.4,1.38a.4.4,0,0,0,.37,0l2.51-1.45C328,295.33,328.05,295.24,328,295.18ZM321.38,299a.4.4,0,0,0,.37,0l2.51-1.45c.11-.06.12-.16,0-.21l-2.4-1.39a.41.41,0,0,0-.37,0L319,297.38c-.1.06-.11.15,0,.21Zm-3.54-.93-2.51,1.45c-.1.07-.11.16,0,.21l5.84,3.37a.38.38,0,0,0,.36,0l2.51-1.45c.11-.06.12-.15,0-.21L318.21,298A.44.44,0,0,0,317.84,298Zm8.48-4.69,2.4,1.38a.4.4,0,0,0,.37,0l2.51-1.45c.11-.06.12-.15,0-.21l-2.4-1.39a.42.42,0,0,0-.36,0l-2.52,1.45C326.24,293.2,326.23,293.29,326.32,293.35Zm27.63-16,2.4,1.39a.39.39,0,0,0,.36,0l2.52-1.45c.1-.06.11-.15,0-.21l-2.41-1.38a.38.38,0,0,0-.36,0L354,277.19C353.86,277.25,353.85,277.34,354,277.4Zm-25,18.38a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21l2.41,1.39a.42.42,0,0,0,.36,0l2.51-1.45c.11-.06.12-.15,0-.21Zm21.3-16.26,2.4,1.38a.38.38,0,0,0,.36,0l2.52-1.45c.1-.06.11-.15,0-.21l-2.41-1.39a.42.42,0,0,0-.36,0l-2.51,1.45C350.19,279.37,350.18,279.46,350.28,279.52Zm38.39-18.21a.41.41,0,0,0-.36,0l-2.51,1.45c-.11.07-.12.16,0,.22l2.4,1.38a.38.38,0,0,0,.36,0l2.51-1.45c.11-.06.12-.16,0-.21Zm-5.36-.86,2.4,1.38a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21l-2.4-1.39a.41.41,0,0,0-.37,0l-2.51,1.45C383.22,260.3,383.21,260.39,383.31,260.45Zm4.1,4.37L385,263.43a.41.41,0,0,0-.36,0l-2.51,1.45c-.11.07-.12.16,0,.21l2.4,1.39a.38.38,0,0,0,.36,0l2.51-1.45C387.49,265,387.5,264.87,387.41,264.82Zm-3.67,2.12-2.41-1.39a.41.41,0,0,0-.36,0L378.46,267c-.11.06-.12.16,0,.21l2.41,1.39a.38.38,0,0,0,.36,0l2.51-1.45C383.82,267.09,383.83,267,383.74,266.94Zm-3.68,2.12-2.4-1.39a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.41,1.39a.41.41,0,0,0,.36,0l2.51-1.45C380.15,269.21,380.16,269.11,380.06,269.06Zm-.42-6.49L382,264a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21l-2.4-1.39a.44.44,0,0,0-.37,0l-2.51,1.45C379.55,262.42,379.54,262.51,379.64,262.57ZM376,264.68l2.4,1.39a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21l-2.4-1.39a.44.44,0,0,0-.37,0L376,264.47C375.88,264.54,375.87,264.63,376,264.68Zm-14.68,8.48,2.4,1.39a.41.41,0,0,0,.36,0l2.52-1.45c.1-.07.11-.16,0-.22l-2.41-1.38a.38.38,0,0,0-.36,0L361.31,273C361.2,273,361.19,273.11,361.29,273.16ZM365,271l2.4,1.39a.44.44,0,0,0,.37,0l2.51-1.45c.1-.07.11-.16,0-.21l-2.4-1.39a.4.4,0,0,0-.37,0L365,270.83C364.87,270.89,364.86,271,365,271Zm-7.34,4.24,2.4,1.39a.39.39,0,0,0,.36,0l2.52-1.45c.1-.06.11-.15,0-.21l-2.41-1.38a.38.38,0,0,0-.36,0l-2.51,1.45C357.53,275.13,357.52,275.22,357.62,275.28Zm14.68-8.48,2.4,1.39a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21l-2.4-1.39a.44.44,0,0,0-.37,0l-2.51,1.45C372.21,266.65,372.2,266.75,372.3,266.8Zm-3.67,2.12,2.4,1.39a.44.44,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21l-2.4-1.39a.4.4,0,0,0-.37,0l-2.51,1.45C368.54,268.77,368.53,268.87,368.63,268.92Zm23.95-3.12-2.41-1.39a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.4,1.39a.41.41,0,0,0,.36,0l2.51-1.45C392.66,266,392.67,265.85,392.58,265.8Zm-1.24-11,2.51-1.45c.11-.06.12-.16,0-.21l-2.4-1.39a.41.41,0,0,0-.37,0l-2.51,1.44c-.1.07-.11.16,0,.22l2.4,1.38A.4.4,0,0,0,391.34,254.82Zm2.08,2.76,3.86-2.23c.11-.06.12-.15,0-.21l-2.4-1.39a.39.39,0,0,0-.36,0L390.67,256c-.11.06-.11.15,0,.21l2.4,1.38A.4.4,0,0,0,393.42,257.58Zm-6.83-4.83,3.09-1.78c.11-.07.12-.16,0-.22l-2.4-1.38a.38.38,0,0,0-.36,0l-3.09,1.78c-.11.07-.12.16,0,.22l2.4,1.38A.38.38,0,0,0,386.59,252.75Zm-5.13,0a.41.41,0,0,0-.37,0l-2.51,1.45c-.11.06-.12.15,0,.21l2.4,1.38a.38.38,0,0,0,.36,0l2.52-1.45c.1-.06.11-.15,0-.21Zm14.42,7.38,4.83-2.79c.11-.06.12-.15,0-.21l-2.4-1.38a.38.38,0,0,0-.36,0l-4.83,2.79c-.11.06-.12.15,0,.21l2.4,1.38A.38.38,0,0,0,395.88,260.12Zm5.17,1,3.1-1.78c.1-.07.11-.16,0-.22l-2.41-1.38a.38.38,0,0,0-.36,0l-3.09,1.78c-.11.07-.12.16,0,.21l2.4,1.39A.38.38,0,0,0,401.05,261.1Zm-46.88,7.4a.4.4,0,0,0-.37,0L351.29,270c-.11.06-.12.16,0,.21l2.4,1.39a.44.44,0,0,0,.37,0l2.51-1.45c.1-.07.11-.16,0-.21Zm7.34-4.24a.44.44,0,0,0-.37,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.4,1.39a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21Zm16.28-9.4a.44.44,0,0,0-.37,0l-2.51,1.45c-.11.07-.12.16,0,.22l2.4,1.38a.38.38,0,0,0,.36,0l2.52-1.45c.1-.06.11-.16,0-.21Zm-20,11.52a.4.4,0,0,0-.37,0L355,267.84c-.11.06-.12.16,0,.21l2.4,1.39a.44.44,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21Zm7.34-4.24a.44.44,0,0,0-.37,0l-2.51,1.45c-.11.07-.12.16,0,.21l2.4,1.39a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21Zm38.17,1.4a.41.41,0,0,0,.36,0l3.87-2.23c.1-.07.11-.16,0-.21l-2.4-1.39a.4.4,0,0,0-.37,0L401,261.94c-.11.06-.12.16,0,.21Zm-32.91-4.44a.41.41,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.4,1.39a.38.38,0,0,0,.36,0l2.52-1.45c.1-.06.11-.16,0-.21Zm3.67-2.12a.41.41,0,0,0-.36,0l-2.51,1.45c-.11.07-.12.16,0,.21l2.4,1.39a.38.38,0,0,0,.36,0l2.52-1.45c.1-.06.11-.16,0-.21ZM335.35,302.8a.44.44,0,0,0,.37,0l6.18-3.57c.1-.06.11-.16,0-.21l-2.4-1.39a.4.4,0,0,0-.37,0L333,301.2c-.11.06-.12.16,0,.21Zm8.11-4.69a.4.4,0,0,0,.37,0l2.51-1.45c.11-.06.12-.15,0-.21l-2.4-1.39a.41.41,0,0,0-.37,0l-2.51,1.45c-.1.06-.11.15,0,.21Zm45.45-30.19-2.41-1.39a.38.38,0,0,0-.36,0L383.63,268c-.11.06-.12.16,0,.21l2.4,1.39a.41.41,0,0,0,.36,0l2.51-1.45C389,268.06,389,268,388.91,267.92Zm-38.1,26a.39.39,0,0,0,.36,0l2.51-1.45c.11-.06.12-.15,0-.21l-2.4-1.38a.38.38,0,0,0-.36,0l-2.52,1.45c-.1.06-.11.15,0,.21Zm-19.13,11a.41.41,0,0,0,.37,0l2.51-1.44c.1-.07.11-.16,0-.22l-2.4-1.38a.4.4,0,0,0-.37,0l-2.51,1.45c-.11.06-.12.16,0,.21Zm-3.3,2.1,2.51-1.45c.1-.06.11-.15,0-.21L325.07,302a.42.42,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21L328,307A.41.41,0,0,0,328.38,307ZM364.52,286a.41.41,0,0,0,.37,0l3.09-1.78c.1-.06.11-.16,0-.21l-2.4-1.39a.41.41,0,0,0-.37,0l-3.09,1.78c-.11.06-.12.16,0,.21Zm-9.27,5.35a.38.38,0,0,0,.36,0l3.87-2.23c.1-.06.11-.16,0-.21l-2.4-1.39a.44.44,0,0,0-.37,0l-3.86,2.23c-.11.06-.12.16,0,.21ZM373,281.05a.44.44,0,0,0,.37,0l20.67-11.94c.1-.06.11-.15,0-.21l-2.41-1.38a.38.38,0,0,0-.36,0l-20.67,11.93c-.11.06-.12.16,0,.21Zm21.83-12.6a.39.39,0,0,0,.36,0l3.1-1.78c.1-.06.11-.16,0-.21l-2.41-1.39a.41.41,0,0,0-.36,0l-3.09,1.79c-.11.06-.12.16,0,.21ZM368.77,283.5a.4.4,0,0,0,.37,0l3.09-1.78c.1-.06.11-.16,0-.21l-2.4-1.39a.4.4,0,0,0-.37,0l-3.09,1.79c-.11.06-.12.15,0,.21ZM399.1,266a.38.38,0,0,0,.36,0l3.1-1.78c.1-.07.11-.16,0-.21l-2.41-1.39a.38.38,0,0,0-.36,0l-3.09,1.79c-.11.06-.12.15,0,.21Zm-38.83,22.42a.4.4,0,0,0,.37,0l3.09-1.79c.1-.06.11-.15,0-.21l-2.4-1.38a.4.4,0,0,0-.37,0l-3.09,1.78c-.11.07-.12.16,0,.21ZM347.13,296a.44.44,0,0,0,.37,0l2.51-1.45c.11-.06.12-.15,0-.21l-2.4-1.38a.38.38,0,0,0-.36,0l-2.52,1.45c-.1.06-.11.15,0,.21Zm-12.31,3.14-2.41-1.38a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.4,1.39a.39.39,0,0,0,.36,0l2.51-1.45C334.9,299.29,334.91,299.2,334.82,299.14Zm1.25-8.64-2.41-1.39a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.4,1.39a.41.41,0,0,0,.36,0l2.51-1.45C336.15,290.65,336.16,290.55,336.07,290.5Zm23.47-5.63-2.4-1.39a.41.41,0,0,0-.36,0l-7.34,4.24c-.11.06-.12.16,0,.21l2.41,1.39a.41.41,0,0,0,.36,0l7.34-4.24C359.63,285,359.64,284.92,359.54,284.87Zm-23.46,10.77a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.4,1.39a.41.41,0,0,0,.36,0l2.52-1.45c.1-.07.11-.16,0-.22Zm-1-.6-2.4-1.38a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21l2.41,1.39a.39.39,0,0,0,.36,0l2.51-1.45C335.14,295.19,335.15,295.1,335.05,295Zm28.16-12.29-2.4-1.39a.41.41,0,0,0-.36,0l-2.52,1.45c-.1.07-.11.16,0,.21l2.41,1.39a.38.38,0,0,0,.36,0l2.51-1.45C363.3,282.9,363.31,282.8,363.21,282.75Zm-19,8.2a.41.41,0,0,0-.37,0l-2.51,1.45c-.1.06-.11.15,0,.21l2.4,1.38a.4.4,0,0,0,.37,0l2.51-1.45c.11-.06.12-.15,0-.21Zm37.37-18.8-2.41-1.38a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21l2.41,1.39a.39.39,0,0,0,.36,0l2.51-1.45C381.65,272.3,381.66,272.21,381.57,272.15Zm-3.68,2.12-2.4-1.38a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21L375,276a.42.42,0,0,0,.36,0l2.51-1.45C378,274.42,378,274.33,377.89,274.27Zm7.35-4.24-2.41-1.38a.38.38,0,0,0-.36,0L380,270.11c-.11.06-.12.16,0,.21l2.4,1.39a.39.39,0,0,0,.36,0l2.51-1.44C385.32,270.18,385.33,270.09,385.24,270Zm-14.69,8.48-2.4-1.39a.39.39,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21l2.41,1.38a.38.38,0,0,0,.36,0l2.51-1.45C370.64,278.66,370.65,278.57,370.55,278.51Zm3.67-2.12-2.4-1.39a.42.42,0,0,0-.36,0L369,276.47c-.11.06-.12.15,0,.21l2.41,1.38a.38.38,0,0,0,.36,0l2.51-1.45C374.31,276.54,374.32,276.45,374.22,276.39Zm-7.34,4.24-2.4-1.39a.39.39,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21L364,282.3a.38.38,0,0,0,.36,0l2.51-1.45C367,280.78,367,280.68,366.88,280.63ZM315.16,292a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21l.64.37a.39.39,0,0,0,.36,0l2.51-1.45c.11-.06.12-.15,0-.21Zm18.25-11.56a.44.44,0,0,0-.37,0L330.53,282c-.11.06-.12.15,0,.21l2.4,1.38a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.15,0-.21Zm-7.34,4.24a.41.41,0,0,0-.37,0l-2.51,1.45c-.11.06-.12.15,0,.21l2.4,1.38a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21Zm11.82-6.82a.4.4,0,0,0-.37,0L335,279.36c-.11.06-.11.16,0,.21l2.4,1.39a.41.41,0,0,0,.37,0l2.51-1.45c.11-.06.11-.15,0-.21Zm-8.15,4.7a.41.41,0,0,0-.37,0l-2.51,1.45c-.11.06-.12.15,0,.21l2.4,1.38a.4.4,0,0,0,.37,0l2.51-1.45c.1-.06.11-.15,0-.21Zm15.49-8.94a.4.4,0,0,0-.37,0l-2.51,1.45c-.1.06-.11.16,0,.21l2.4,1.39a.44.44,0,0,0,.37,0l2.51-1.45c.11-.07.12-.16,0-.21Zm-3.67,2.12a.4.4,0,0,0-.37,0l-2.51,1.45c-.1.06-.11.16,0,.21l2.4,1.39a.44.44,0,0,0,.37,0l2.51-1.45c.11-.07.12-.16,0-.21Zm-19.06,12a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.16,0,.21l.64.37a.41.41,0,0,0,.36,0l2.51-1.45c.11-.06.12-.16,0-.21Zm-11,6.35a.39.39,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21l.64.37a.41.41,0,0,0,.37,0l2.51-1.45c.11-.06.12-.15,0-.21Zm3.29,1.9a.44.44,0,0,0-.37,0l-2.51,1.45c-.11.06-.12.16,0,.21l2.4,1.39a.44.44,0,0,0,.37,0l2.51-1.45c.1-.06.11-.16,0-.21Zm16.37,5.21-2.41-1.38a.38.38,0,0,0-.36,0l-2.51,1.45c-.11.06-.12.15,0,.21l2.4,1.39a.42.42,0,0,0,.36,0l2.51-1.45C331.23,301.41,331.24,301.32,331.15,301.26Zm-12.32-11.34a.38.38,0,0,0-.36,0L316,291.38c-.11.06-.12.15,0,.21l.64.37a.41.41,0,0,0,.36,0l2.51-1.45c.11-.07.12-.16,0-.21Zm30.07-18.38a.44.44,0,0,0-.37,0L346,273c-.1.06-.11.16,0,.21l2.4,1.39a.44.44,0,0,0,.37,0l2.51-1.45c.11-.06.12-.16,0-.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.2 295.54 359.75 295.86 374.25 304.23 400.04 289.33 400.58 289.03 385.53 280.34 359.2 295.54",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.71 289.53 385.53 281.35 360.08 296.05 374.25 304.23 399.71 289.53",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.71 289.53 385.53 281.35 360.08 296.05 374.25 304.23 399.71 289.53",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-tab--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.29,221.4l75-43.3c1.46-.84,2.65-.16,2.65,1.53v57.06a5.84,5.84,0,0,1-2.65,4.58l-75,43.31c-1.46.84-2.65.16-2.65-1.53V226A5.87,5.87,0,0,1,300.29,221.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.37,183.87a1.85,1.85,0,0,0,0-.23s0,0,0,0a.79.79,0,0,0-.06-.22,1.09,1.09,0,0,0-.14-.31.57.57,0,0,0-.08-.13s0-.07-.08-.09a.65.65,0,0,0-.16-.17h0a.72.72,0,0,0-.21-.12,1.77,1.77,0,0,0-1.67.21l-72.64,41.81c-1.37.79-2.48,2.72-2.48,5.48v56.3a1.67,1.67,0,0,0,.89,1.49l.11.07.13.07.21.08a1.65,1.65,0,0,0,.32,0,1.73,1.73,0,0,0,.82-.24l.06,0h0l2.36-1.37L377.9,246a5.48,5.48,0,0,0,2.49-4.29V184.18A3,3,0,0,0,380.37,183.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.57,182.54a1.77,1.77,0,0,0-1.67.21l-72.64,41.81a5.49,5.49,0,0,0-2.48,4.3v4.81l-3.07-1.8v-4.75a5.49,5.49,0,0,1,2.47-4.29L374.84,181a1.71,1.71,0,0,1,1.8-.15C377.08,181.14,379,182.26,379.57,182.54Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.38,184.16c0-1.56-1.11-2.2-2.48-1.41l-72.64,41.82a5.47,5.47,0,0,0-2.48,4.29v4.81L380.38,189Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.9,182.75l-72.64,41.81a5.17,5.17,0,0,0-1.75,1.84l-3.05-1.76a5,5,0,0,1,1.73-1.81L374.84,181a1.73,1.73,0,0,1,1.8-.14c.44.27,2.4,1.38,2.92,1.66A1.79,1.79,0,0,0,377.9,182.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.71,231.88v-4.76a5.13,5.13,0,0,1,.75-2.48l3.06,1.76a5,5,0,0,0-.74,2.46v4.81Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.49,226.92a2.45,2.45,0,0,0-.95,2c0,.8.42,1.21.95.91a2.5,2.5,0,0,0,.94-2C306.43,227,306,226.62,305.49,226.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.88,225a2.5,2.5,0,0,0-.95,2c0,.8.43,1.21.95.9a2.48,2.48,0,0,0,.94-2C309.82,225.06,309.4,224.65,308.88,225Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.27,223a2.5,2.5,0,0,0-.94,2c0,.8.42,1.2.94.9a2.48,2.48,0,0,0,.94-2C313.21,223.1,312.79,222.69,312.27,223Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.67,287.84l-.13-.07L301,286.31a2.64,2.64,0,0,1-1.29-1.92,2.17,2.17,0,0,1,0-.36V231.87l3.07,1.8v52.66a1.62,1.62,0,0,0,.77,1.41.24.24,0,0,0,.08.06h0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.56,217.56l-3.21,1.85a1.3,1.3,0,0,0-.58,1v1.18c0,.37.26.52.58.34l3.21-1.85a1.3,1.3,0,0,0,.58-1V217.9C375.14,217.53,374.88,217.37,374.56,217.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.56,222.25l-3.21,1.86a1.27,1.27,0,0,0-.58,1v1.18c0,.37.26.52.58.33l3.21-1.85a1.3,1.3,0,0,0,.58-1v-1.18C375.14,222.22,374.88,222.07,374.56,222.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.56,227l-3.21,1.85a1.3,1.3,0,0,0-.58,1V231c0,.37.26.52.58.34l3.21-1.86a1.27,1.27,0,0,0,.58-1v-1.17C375.14,226.91,374.88,226.76,374.56,227Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.56,231.64l-3.21,1.86a1.27,1.27,0,0,0-.58,1v1.17c0,.38.26.53.58.34l3.21-1.85a1.3,1.3,0,0,0,.58-1V232C375.14,231.61,374.88,231.46,374.56,231.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.56,238.77l-3.21,1.85a1.28,1.28,0,0,0-.58,1v1.18c0,.37.26.52.58.33l3.21-1.85a1.28,1.28,0,0,0,.58-1V239.1C375.14,238.73,374.88,238.58,374.56,238.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.56,196.63l-3.21,1.85a1.3,1.3,0,0,0-.58,1v1.18c0,.37.26.52.58.34l3.21-1.86a1.27,1.27,0,0,0,.58-1V197C375.14,196.59,374.88,196.44,374.56,196.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.56,201.32l-3.21,1.85a1.3,1.3,0,0,0-.58,1v1.18c0,.38.26.53.58.34l3.21-1.85a1.3,1.3,0,0,0,.58-1v-1.18C375.14,201.29,374.88,201.14,374.56,201.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.56,206l-3.21,1.85a1.28,1.28,0,0,0-.58,1v1.18c0,.37.26.52.58.33l3.21-1.85a1.28,1.28,0,0,0,.58-1v-1.18C375.14,206,374.88,205.83,374.56,206Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.56,210.71l-3.21,1.85a1.3,1.3,0,0,0-.58,1v1.18c0,.37.26.52.58.34l3.21-1.85a1.3,1.3,0,0,0,.58-1v-1.18C375.14,210.67,374.88,210.52,374.56,210.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,202.33,348.3,212.66a1.29,1.29,0,0,0-.59,1c0,.36.27.49.59.3l17.95-10.34a1.25,1.25,0,0,0,.59-1C366.84,202.27,366.58,202.14,366.25,202.33Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,217.74,338.74,233.6a1.26,1.26,0,0,0-.59,1c0,.35.27.48.59.29L366.28,219a1.28,1.28,0,0,0,.58-1C366.86,217.69,366.6,217.55,366.28,217.74Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,214l-7.64,4.42a1.27,1.27,0,0,0-.59,1c0,.35.27.48.59.3l7.64-4.42a1.27,1.27,0,0,0,.59-1C346.61,213.93,346.34,213.8,346,214Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,206l-6.45,3.69a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l6.45-3.7a1.23,1.23,0,0,0,.59-1C366.84,205.94,366.58,205.81,366.25,206Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,206l-6.45,3.69a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l6.45-3.7a1.23,1.23,0,0,0,.59-1C366.84,205.94,366.58,205.81,366.25,206Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,209.64l-7.08,4.11a1.23,1.23,0,0,0-.59,1c0,.36.26.49.59.3l7.08-4.1a1.25,1.25,0,0,0,.59-1C366.84,209.59,366.58,209.46,366.25,209.64Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,209.64l-7.08,4.11a1.23,1.23,0,0,0-.59,1c0,.36.26.49.59.3l7.08-4.1a1.25,1.25,0,0,0,.59-1C366.84,209.59,366.58,209.46,366.25,209.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51,211l-5.36,3.07a1.29,1.29,0,0,0-.59,1c0,.35.27.49.59.3l5.36-3.07a1.26,1.26,0,0,0,.59-1C358.1,211,357.84,210.82,357.51,211Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51,211l-5.36,3.07a1.29,1.29,0,0,0-.59,1c0,.35.27.49.59.3l5.36-3.07a1.26,1.26,0,0,0,.59-1C358.1,211,357.84,210.82,357.51,211Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.11,230.5l-21.73,12.42a1.29,1.29,0,0,0-.59,1c0,.35.27.49.59.3l21.73-12.42a1.26,1.26,0,0,0,.59-1C360.7,230.45,360.44,230.32,360.11,230.5Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.11,226.86l-21.73,12.39a1.29,1.29,0,0,0-.59,1c0,.36.27.49.59.3l21.73-12.4a1.23,1.23,0,0,0,.59-1C360.7,226.8,360.44,226.67,360.11,226.86Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,214.85l-6.33,3.6a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l6.33-3.6a1.29,1.29,0,0,0,.59-1C357.87,214.8,357.6,214.66,357.28,214.85Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,214.85l-6.33,3.6a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l6.33-3.6a1.29,1.29,0,0,0,.59-1C357.87,214.8,357.6,214.66,357.28,214.85Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.66,219.77l-9.93,5.86a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l9.93-5.86a1.26,1.26,0,0,0,.59-1C349.25,219.72,349,219.58,348.66,219.77Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.66,219.77l-9.93,5.86a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l9.93-5.86a1.26,1.26,0,0,0,.59-1C349.25,219.72,349,219.58,348.66,219.77Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,213.47,351,222.37a1.25,1.25,0,0,0-.59,1c0,.35.26.48.59.3l15.33-8.9a1.28,1.28,0,0,0,.58-1C366.86,213.42,366.6,213.28,366.28,213.47Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,213.47,351,222.37a1.25,1.25,0,0,0-.59,1c0,.35.26.48.59.3l15.33-8.9a1.28,1.28,0,0,0,.58-1C366.86,213.42,366.6,213.28,366.28,213.47Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.66,223.69l-9.93,5.86a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l9.93-5.87a1.23,1.23,0,0,0,.59-1C349.25,223.63,349,223.5,348.66,223.69Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.66,223.69l-9.93,5.86a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l9.93-5.87a1.23,1.23,0,0,0,.59-1C349.25,223.63,349,223.5,348.66,223.69Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,242.39l-7.08,4.1a1.26,1.26,0,0,0-.59,1c0,.36.26.49.59.3l7.08-4.1a1.25,1.25,0,0,0,.59-1C366.84,242.34,366.58,242.21,366.25,242.39Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,242.39l-7.08,4.1a1.26,1.26,0,0,0-.59,1c0,.36.26.49.59.3l7.08-4.1a1.25,1.25,0,0,0,.59-1C366.84,242.34,366.58,242.21,366.25,242.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,247.6,351,251.2a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l6.33-3.6a1.29,1.29,0,0,0,.59-1C357.87,247.55,357.6,247.41,357.28,247.6Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,247.6,351,251.2a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l6.33-3.6a1.29,1.29,0,0,0,.59-1C357.87,247.55,357.6,247.41,357.28,247.6Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.66,252.52l-9.93,5.86a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l9.93-5.86a1.26,1.26,0,0,0,.59-1C349.25,252.46,349,252.33,348.66,252.52Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.66,252.52l-9.93,5.86a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l9.93-5.86a1.26,1.26,0,0,0,.59-1C349.25,252.46,349,252.33,348.66,252.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,246.22,351,255.12a1.25,1.25,0,0,0-.59,1c0,.35.26.48.59.29l15.33-8.89a1.28,1.28,0,0,0,.58-1C366.86,246.17,366.6,246,366.28,246.22Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,246.22,351,255.12a1.25,1.25,0,0,0-.59,1c0,.35.26.48.59.29l15.33-8.89a1.28,1.28,0,0,0,.58-1C366.86,246.17,366.6,246,366.28,246.22Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.66,256.44l-9.93,5.86a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l9.93-5.87a1.23,1.23,0,0,0,.59-1C349.25,256.38,349,256.25,348.66,256.44Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.66,256.44l-9.93,5.86a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l9.93-5.87a1.23,1.23,0,0,0,.59-1C349.25,256.38,349,256.25,348.66,256.44Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.11,234.2l-21.73,12.5a1.29,1.29,0,0,0-.59,1c0,.36.27.49.59.3l21.73-12.5a1.26,1.26,0,0,0,.59-1C360.7,234.14,360.44,234,360.11,234.2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.11,237.85l-21.73,12.51a1.29,1.29,0,0,0-.59,1c0,.35.27.49.59.3l21.73-12.51a1.25,1.25,0,0,0,.59-1C360.7,237.8,360.44,237.67,360.11,237.85Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.11,241.51,338.38,254a1.26,1.26,0,0,0-.59,1c0,.35.27.48.59.29l21.73-12.5a1.26,1.26,0,0,0,.59-1C360.7,241.46,360.44,241.32,360.11,241.51Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.13,222.86l-2.73,1.59a1.25,1.25,0,0,0-.59,1c0,.35.26.48.59.3l2.73-1.59a1.27,1.27,0,0,0,.59-1C366.72,222.81,366.46,222.68,366.13,222.86Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.13,222.86l-2.73,1.59a1.25,1.25,0,0,0-.59,1c0,.35.26.48.59.3l2.73-1.59a1.27,1.27,0,0,0,.59-1C366.72,222.81,366.46,222.68,366.13,222.86Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.13,230.73l-2.73,1.58a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l2.73-1.59a1.26,1.26,0,0,0,.59-1C366.72,230.67,366.46,230.54,366.13,230.73Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.13,230.73l-2.73,1.58a1.26,1.26,0,0,0-.59,1c0,.35.26.49.59.3l2.73-1.59a1.26,1.26,0,0,0,.59-1C366.72,230.67,366.46,230.54,366.13,230.73Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.13,234.38,363.4,236a1.23,1.23,0,0,0-.59,1c0,.35.26.48.59.29l2.73-1.58a1.29,1.29,0,0,0,.59-1C366.72,234.33,366.46,234.19,366.13,234.38Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.13,234.38,363.4,236a1.23,1.23,0,0,0-.59,1c0,.35.26.48.59.29l2.73-1.58a1.29,1.29,0,0,0,.59-1C366.72,234.33,366.46,234.19,366.13,234.38Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.13,238l-2.73,1.58a1.26,1.26,0,0,0-.59,1c0,.36.26.49.59.3l2.73-1.58a1.29,1.29,0,0,0,.59-1C366.72,238,366.46,237.85,366.13,238Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.13,238l-2.73,1.58a1.26,1.26,0,0,0-.59,1c0,.36.26.49.59.3l2.73-1.58a1.29,1.29,0,0,0,.59-1C366.72,238,366.46,237.85,366.13,238Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,235.16l23-13.29c.86-.49,1.55-.09,1.55.9v43.4a3.43,3.43,0,0,1-1.55,2.68l-23,13.28c-.86.5-1.55.1-1.55-.89v-43.4A3.41,3.41,0,0,1,308,235.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,259l2.12-1.22c.43-.25.78-.07.78.4a1.7,1.7,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,310.16,259Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,259l2.12-1.22c.43-.25.78-.07.78.4a1.7,1.7,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,310.16,259Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,237.28l2.12-1.23c.43-.24.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3L310.16,239c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,310.16,237.28Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,237.28l2.12-1.23c.43-.24.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3L310.16,239c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,310.16,237.28Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,239.9l2.12-1.22c.43-.25.78-.07.78.39a1.68,1.68,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.08-.78-.39A1.68,1.68,0,0,1,313.14,239.9Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,239.9l2.12-1.22c.43-.25.78-.07.78.39a1.68,1.68,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.08-.78-.39A1.68,1.68,0,0,1,313.14,239.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,244.24l2.12-1.22c.43-.25.78-.07.78.4a1.7,1.7,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,313.14,244.24Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,244.24l2.12-1.22c.43-.25.78-.07.78.4a1.7,1.7,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,313.14,244.24Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,250.33l2.12-1.22c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3L310.16,252c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,310.16,250.33Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,250.33l2.12-1.22c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3L310.16,252c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,310.16,250.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,253l2.12-1.22c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.29l-2.12,1.23c-.43.24-.78.07-.78-.4A1.68,1.68,0,0,1,313.14,253Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,253l2.12-1.22c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.29l-2.12,1.23c-.43.24-.78.07-.78-.4A1.68,1.68,0,0,1,313.14,253Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,233.93l13-7.47c.43-.25.78-.08.78.39a1.68,1.68,0,0,1-.78,1.3l-13,7.47c-.43.25-.78.08-.78-.39A1.68,1.68,0,0,1,316,233.93Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,233.93l13-7.47c.43-.25.78-.08.78.39a1.68,1.68,0,0,1-.78,1.3l-13,7.47c-.43.25-.78.08-.78-.39A1.68,1.68,0,0,1,316,233.93Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,255.69l13-7.47c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-13,7.47c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,316,255.69Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,255.69l13-7.47c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-13,7.47c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,316,255.69Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,236.55l10-5.74c.43-.25.78-.07.78.4a1.66,1.66,0,0,1-.78,1.29l-10,5.75c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,318.94,236.55Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,236.55l10-5.74c.43-.25.78-.07.78.4a1.66,1.66,0,0,1-.78,1.29l-10,5.75c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,318.94,236.55Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,240.9l10-5.74c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-10,5.74c-.43.25-.78.07-.78-.4A1.7,1.7,0,0,1,318.94,240.9Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,240.9l10-5.74c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-10,5.74c-.43.25-.78.07-.78-.4A1.7,1.7,0,0,1,318.94,240.9Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,247l13-7.47c.43-.25.78-.08.78.39a1.68,1.68,0,0,1-.78,1.3l-13,7.47c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,316,247Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,247l13-7.47c.43-.25.78-.08.78.39a1.68,1.68,0,0,1-.78,1.3l-13,7.47c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,316,247Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,249.61l10-5.74c.43-.25.78-.07.78.4a1.66,1.66,0,0,1-.78,1.29l-10,5.75c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,318.94,249.61Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,249.61l10-5.74c.43-.25.78-.07.78.4a1.66,1.66,0,0,1-.78,1.29l-10,5.75c-.43.25-.78.07-.78-.4A1.68,1.68,0,0,1,318.94,249.61Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,267.8l2.12-1.23c.43-.24.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,310.16,267.8Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,267.8l2.12-1.23c.43-.24.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,310.16,267.8Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,261.71l2.12-1.22c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.4A1.7,1.7,0,0,1,313.14,261.71Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,261.71l2.12-1.22c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.4A1.7,1.7,0,0,1,313.14,261.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,264.45l13-7.47c.43-.25.78-.08.78.39a1.68,1.68,0,0,1-.78,1.3l-13,7.47c-.43.25-.78.08-.78-.39A1.68,1.68,0,0,1,316,264.45Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,264.45l13-7.47c.43-.25.78-.08.78.39a1.68,1.68,0,0,1-.78,1.3l-13,7.47c-.43.25-.78.08-.78-.39A1.68,1.68,0,0,1,316,264.45Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,258.37l10-5.75c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-10,5.74c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,318.94,258.37Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,258.37l10-5.75c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-10,5.74c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,318.94,258.37Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,276.47l2.12-1.23c.43-.24.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,310.16,276.47Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,276.47l2.12-1.23c.43-.24.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,310.16,276.47Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,270.38l2.12-1.22c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.4A1.7,1.7,0,0,1,313.14,270.38Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,270.38l2.12-1.22c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-2.12,1.22c-.43.25-.78.07-.78-.4A1.7,1.7,0,0,1,313.14,270.38Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,273.12l13-7.47c.43-.25.78-.08.78.39a1.68,1.68,0,0,1-.78,1.3l-13,7.47c-.43.25-.78.08-.78-.39A1.68,1.68,0,0,1,316,273.12Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,273.12l13-7.47c.43-.25.78-.08.78.39a1.68,1.68,0,0,1-.78,1.3l-13,7.47c-.43.25-.78.08-.78-.39A1.68,1.68,0,0,1,316,273.12Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,267l10-5.75c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-10,5.74c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,318.94,267Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,267l10-5.75c.43-.25.78-.07.78.4a1.68,1.68,0,0,1-.78,1.3l-10,5.74c-.43.25-.78.07-.78-.39A1.68,1.68,0,0,1,318.94,267Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-icons--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.84,176.36,313,163.58c.87-.51,1.57-.1,1.57.9v25.7A3.46,3.46,0,0,1,313,192.9l-22.11,12.79c-.87.5-1.58.09-1.58-.91v-25.7A3.48,3.48,0,0,1,290.84,176.36Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.84,176.36,313,163.58c.87-.51,1.57-.1,1.57.9v25.7A3.46,3.46,0,0,1,313,192.9l-22.11,12.79c-.87.5-1.58.09-1.58-.91v-25.7A3.48,3.48,0,0,1,290.84,176.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.73,177.53l-4-2.32a3.26,3.26,0,0,0-.46,1.55v25.7a1.11,1.11,0,0,0,.45,1c.29.17,3.73,2.14,4,2.31a1.14,1.14,0,0,1-.42-1v-25.7A3.18,3.18,0,0,1,289.73,177.53Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,163.43c-.56-.34-3.68-2.13-3.94-2.28a1.1,1.1,0,0,0-1.13.1L286.83,174a3.24,3.24,0,0,0-1.12,1.17l4,2.32a3.13,3.13,0,0,1,1.11-1.17L313,163.58A1.15,1.15,0,0,1,314,163.43Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,163.43c-.56-.34-3.68-2.13-3.94-2.28a1.1,1.1,0,0,0-1.13.1L286.83,174a3.24,3.24,0,0,0-1.12,1.17l4,2.32a3.13,3.13,0,0,1,1.11-1.17L313,163.58A1.15,1.15,0,0,1,314,163.43Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294,189.35l3.05,1.4a1,1,0,0,1,.28.21.58.58,0,0,1,.15.45v1.76a.86.86,0,0,1-.08.36.51.51,0,0,1-.21.24l-.06,0h-.08l-4.73-2.18a.77.77,0,0,1-.29-.19.78.78,0,0,1-.1-.45v-.88a1.52,1.52,0,0,1,.1-.56,4.12,4.12,0,0,1,.29-.53l4.73-7.63a.49.49,0,0,1,.08-.1l.06-.05a.18.18,0,0,1,.21,0,.38.38,0,0,1,.08.27v1.76a1.45,1.45,0,0,1-.15.63,5,5,0,0,1-.28.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.15,175.63a3,3,0,0,1,.21-.54,1,1,0,0,1,.39-.42l1-.58a.14.14,0,0,1,.2,0,.34.34,0,0,1,.09.27,1.91,1.91,0,0,1,0,.2L300.46,194a2.78,2.78,0,0,1-.19.52,1,1,0,0,1-.41.44l-.95.56a.17.17,0,0,1-.21,0,.34.34,0,0,1-.09-.27.88.88,0,0,1,0-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.59,178.92a1,1,0,0,1-.28-.21.6.6,0,0,1-.15-.45v-1.77a.94.94,0,0,1,.08-.36.61.61,0,0,1,.2-.24l.07,0h.08l4.72,2.17a.74.74,0,0,1,.29.2.71.71,0,0,1,.1.45v.87a1.42,1.42,0,0,1-.1.57,2.87,2.87,0,0,1-.29.53l-4.72,7.62-.08.11-.07,0a.14.14,0,0,1-.2,0,.35.35,0,0,1-.08-.26V186.4a1.45,1.45,0,0,1,.15-.63c.1-.21.19-.39.28-.54l3.05-4.91Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.12,157.16l22.12-12.78c.87-.5,1.57-.09,1.57.91V171a3.47,3.47,0,0,1-1.57,2.73l-22.12,12.78c-.86.51-1.57.1-1.57-.9v-25.7A3.53,3.53,0,0,1,324.12,157.16Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.12,157.16l22.12-12.78c.87-.5,1.57-.09,1.57.91V171a3.47,3.47,0,0,1-1.57,2.73l-22.12,12.78c-.86.51-1.57.1-1.57-.9v-25.7A3.53,3.53,0,0,1,324.12,157.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,158.34,319,156a3.22,3.22,0,0,0-.46,1.56v25.69a1.09,1.09,0,0,0,.45,1c.29.18,3.72,2.14,4,2.32a1.15,1.15,0,0,1-.43-1V159.89A3.26,3.26,0,0,1,323,158.34Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.29,144.24c-.56-.35-3.69-2.13-3.94-2.29a1.15,1.15,0,0,0-1.13.1l-22.11,12.79A3.3,3.3,0,0,0,319,156l4,2.33a3.33,3.33,0,0,1,1.11-1.18l22.12-12.78A1.15,1.15,0,0,1,347.29,144.24Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.29,144.24c-.56-.35-3.69-2.13-3.94-2.29a1.15,1.15,0,0,0-1.13.1l-22.11,12.79A3.3,3.3,0,0,0,319,156l4,2.33a3.33,3.33,0,0,1,1.11-1.18l22.12-12.78A1.15,1.15,0,0,1,347.29,144.24Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.64,176.66a1,1,0,0,1-.11.46.7.7,0,0,1-.25.32,2.36,2.36,0,0,1-1.28.37,1.34,1.34,0,0,1-1-.51,3.31,3.31,0,0,1-.64-1.41,10.74,10.74,0,0,1-.22-2.32A4.92,4.92,0,0,0,328,172c-.12-.37-.32-.56-.58-.57l-.23,0q-.39,0-.39-.54V169.8a1.6,1.6,0,0,1,.39-1l.23-.28a3,3,0,0,0,.58-1.25,7.28,7.28,0,0,0,.19-1.77,15,15,0,0,1,.22-2.59,9.87,9.87,0,0,1,.64-2.15,6.61,6.61,0,0,1,1-1.65,4.72,4.72,0,0,1,1.28-1.1.19.19,0,0,1,.25,0,.41.41,0,0,1,.11.33v1.37a1,1,0,0,1-.11.46.62.62,0,0,1-.25.31,2.56,2.56,0,0,0-1,1.56,11,11,0,0,0-.36,3.11,9.25,9.25,0,0,1-.08,1.35,7.23,7.23,0,0,1-.24,1.08,6.3,6.3,0,0,1-.33.85c-.12.24-.24.46-.36.65a1.88,1.88,0,0,1,.36.24,1.44,1.44,0,0,1,.33.46,3.27,3.27,0,0,1,.24.81,7.41,7.41,0,0,1,.08,1.25,7,7,0,0,0,.36,2.69c.23.51.57.64,1,.38a.19.19,0,0,1,.25,0,.42.42,0,0,1,.11.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.57,171.29a1.06,1.06,0,0,1,.11-.45.67.67,0,0,1,.26-.32,2.54,2.54,0,0,0,1-1.55,11.26,11.26,0,0,0,.35-3.1,9.12,9.12,0,0,1,.09-1.34,6.32,6.32,0,0,1,.23-1.09,5.66,5.66,0,0,1,.33-.84,4.41,4.41,0,0,1,.36-.65,1,1,0,0,1-.36-.24,1.38,1.38,0,0,1-.33-.47,2.72,2.72,0,0,1-.23-.81,7.08,7.08,0,0,1-.09-1.24,7.37,7.37,0,0,0-.35-2.71c-.24-.51-.57-.64-1-.39a.2.2,0,0,1-.26,0,.44.44,0,0,1-.11-.33v-1.37a1.14,1.14,0,0,1,.11-.46.68.68,0,0,1,.26-.31,2.31,2.31,0,0,1,1.27-.37,1.38,1.38,0,0,1,1,.51,3.42,3.42,0,0,1,.63,1.42,10.23,10.23,0,0,1,.22,2.33,4.85,4.85,0,0,0,.19,1.55c.13.37.32.57.58.58h.23c.26,0,.39.21.39.55v1.08a1.6,1.6,0,0,1-.39,1l-.23.28a3.09,3.09,0,0,0-.58,1.25,7.22,7.22,0,0,0-.19,1.77,14,14,0,0,1-.22,2.58,10.55,10.55,0,0,1-.63,2.14,7.07,7.07,0,0,1-1,1.64,4.66,4.66,0,0,1-1.27,1.1.21.21,0,0,1-.26,0,.46.46,0,0,1-.11-.34Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.41,137.94l22.11-12.78c.87-.5,1.58-.1,1.58.91v25.69a3.51,3.51,0,0,1-1.58,2.73l-22.11,12.78c-.87.5-1.57.09-1.57-.91V140.67A3.47,3.47,0,0,1,357.41,137.94Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.41,137.94l22.11-12.78c.87-.5,1.58-.1,1.58.91v25.69a3.51,3.51,0,0,1-1.58,2.73l-22.11,12.78c-.87.5-1.57.09-1.57-.91V140.67A3.47,3.47,0,0,1,357.41,137.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.3,139.12l-4-2.33a3.17,3.17,0,0,0-.47,1.55V164a1.12,1.12,0,0,0,.46,1c.29.17,3.72,2.14,4,2.31a1.12,1.12,0,0,1-.43-1v-25.7A3.22,3.22,0,0,1,356.3,139.12Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.57,125c-.56-.34-3.68-2.13-3.93-2.28a1.12,1.12,0,0,0-1.13.1L353.4,135.62a3.21,3.21,0,0,0-1.11,1.17l4,2.33a3.25,3.25,0,0,1,1.11-1.18l22.12-12.78A1.14,1.14,0,0,1,380.57,125Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.57,125c-.56-.34-3.68-2.13-3.93-2.28a1.12,1.12,0,0,0-1.13.1L353.4,135.62a3.21,3.21,0,0,0-1.11,1.17l4,2.33a3.25,3.25,0,0,1,1.11-1.18l22.12-12.78A1.14,1.14,0,0,1,380.57,125Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Gear--inject-168",
    d: "M376,143.59l-1.61-.09c-.12,0-.2-.16-.19-.35a8.28,8.28,0,0,0-.07-1.34.94.94,0,0,1,.1-.55l1.6-2.26a.58.58,0,0,0,0-.5l-.79-1.71c-.07-.15-.21-.2-.3-.11L373,138.55a.27.27,0,0,1-.36,0,2.66,2.66,0,0,0-.77-.47.37.37,0,0,1-.16-.39l.4-2.54c0-.18,0-.32-.16-.3l-1.87.22c-.12,0-.24.16-.29.32l-.78,2.65a.7.7,0,0,1-.28.39,7.67,7.67,0,0,0-1.19.79.24.24,0,0,1-.34-.1l-.87-1.34c-.09-.14-.23-.16-.32,0L364.14,140a.65.65,0,0,0-.06.52l.55,1.73a.79.79,0,0,1,0,.55,15.64,15.64,0,0,0-.79,1.65.59.59,0,0,1-.31.33l-1.78.49a.5.5,0,0,0-.27.36l-.64,2.88c0,.17,0,.32.13.32l1.61.08c.11,0,.2.17.19.36a9.72,9.72,0,0,0,.06,1.34.88.88,0,0,1-.1.55l-1.59,2.26a.53.53,0,0,0,0,.49l.79,1.71c.07.16.21.21.3.11l1.77-1.86a.25.25,0,0,1,.35,0,2.81,2.81,0,0,0,.78.46.37.37,0,0,1,.15.4l-.39,2.54c0,.18,0,.31.15.3l1.88-.22a.47.47,0,0,0,.29-.32l.78-2.65a.66.66,0,0,1,.28-.39,7.67,7.67,0,0,0,1.19-.79.22.22,0,0,1,.33.1l.88,1.34c.09.13.23.16.31.05l1.86-2.28a.62.62,0,0,0,.06-.51l-.56-1.73a.78.78,0,0,1,0-.55,15.64,15.64,0,0,0,.79-1.65.59.59,0,0,1,.31-.33l1.78-.49a.52.52,0,0,0,.27-.37l.64-2.87C376.17,143.74,376.11,143.59,376,143.59Zm-4.43,2.26c-.59,2.62-2.46,4.91-4.17,5.12s-2.62-1.76-2-4.39,2.45-4.92,4.17-5.12S372.16,143.22,371.57,145.85Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--programming-languages--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M412.46,195.32l52.16,30.05a2.85,2.85,0,0,1,1.3,2.24v29.12c0,.82-.58,1.16-1.3.74l-52.16-30a2.89,2.89,0,0,1-1.29-2.25V196.07C411.17,195.24,411.75,194.91,412.46,195.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.45,198.45l52.16,30.05a2.85,2.85,0,0,1,1.3,2.24v29.12a2.83,2.83,0,0,1-1.31,2.23l-2.14,1.21a2.88,2.88,0,0,1-2.59,0l-52.16-30.05a2.84,2.84,0,0,1-1.3-2.24V201.88a2.85,2.85,0,0,1,1.31-2.23l2.14-1.21A2.91,2.91,0,0,1,407.45,198.45Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.45,198.45l52.16,30.05a2.85,2.85,0,0,1,1.3,2.24v29.12a2.83,2.83,0,0,1-1.31,2.23l-2.14,1.21a2.88,2.88,0,0,1-2.59,0l-52.16-30.05a2.84,2.84,0,0,1-1.3-2.24V201.88a2.85,2.85,0,0,1,1.31-2.23l2.14-1.21A2.91,2.91,0,0,1,407.45,198.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.43,201.65c.1-.65.64-.89,1.28-.51l52.16,30a2.75,2.75,0,0,1,.91,1l4.72-2.73a2.54,2.54,0,0,0-.89-.92l-52.16-30.05a2.9,2.9,0,0,0-2.6,0l-2.13,1.21A2.88,2.88,0,0,0,401.43,201.65Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.43,201.65c.1-.65.64-.89,1.28-.51l52.16,30a2.75,2.75,0,0,1,.91,1l4.72-2.73a2.54,2.54,0,0,0-.89-.92l-52.16-30.05a2.9,2.9,0,0,0-2.6,0l-2.13,1.21A2.88,2.88,0,0,0,401.43,201.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.71,201.14l52.16,30a2.89,2.89,0,0,1,1.29,2.25v29.11c0,.83-.58,1.16-1.29.75l-52.16-30.05a2.85,2.85,0,0,1-1.3-2.24V201.88C401.41,201.06,402,200.72,402.71,201.14Z",
    style: {
      fill: "#10E2ED"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M415.64,226.65a6,6,0,0,1-.43,2.51,2.59,2.59,0,0,1-1.16,1.32,2.69,2.69,0,0,1-1.71.21,6.16,6.16,0,0,1-2-.79,10.21,10.21,0,0,1-2.13-1.63,11.62,11.62,0,0,1-1.68-2.11,10.74,10.74,0,0,1-1.11-2.41,8.81,8.81,0,0,1-.42-2.58.38.38,0,0,1,.11-.3.23.23,0,0,1,.28,0l2.3,1.32a1.16,1.16,0,0,1,.44.4,2.69,2.69,0,0,1,.22.68,4.93,4.93,0,0,0,.67,1.62,4,4,0,0,0,1.32,1.18c.68.39,1.19.46,1.53.2a2.07,2.07,0,0,0,.51-1.68v-6.67l-6.13-3.54a.89.89,0,0,1-.34-.39,1.2,1.2,0,0,1-.14-.53v-2.54a.45.45,0,0,1,.14-.37.29.29,0,0,1,.34,0l9,5.16a1,1,0,0,1,.34.39,1.09,1.09,0,0,1,.14.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.34,221a1.4,1.4,0,0,1,.55.58,3.45,3.45,0,0,1,.26.68l3.91,17.32a1.74,1.74,0,0,1,.07.4.35.35,0,0,1-.12.3.24.24,0,0,1-.28,0L426.48,239a1.32,1.32,0,0,1-.52-.5,1.61,1.61,0,0,1-.18-.5l-.51-2.27L420.5,233l-.5,1.7a.41.41,0,0,1-.19.28q-.15.12-.51-.09l-2.26-1.3a.9.9,0,0,1-.28-.32,1,1,0,0,1-.11-.44.88.88,0,0,1,.07-.31l3.91-12.81a.81.81,0,0,1,.26-.38c.12-.1.31-.08.55.06Zm-2.9,8.77,2.9,1.68-1.45-6.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.45,243a2.21,2.21,0,0,1-.95-1.51l-3.66-17.05c0-.13,0-.21,0-.24a.38.38,0,0,1,0-.1.36.36,0,0,1,.12-.31.24.24,0,0,1,.27,0l2.26,1.3a1.29,1.29,0,0,1,.51.5,1.47,1.47,0,0,1,.19.51l2.49,12,2.5-9.08a.41.41,0,0,1,.19-.28q.15-.12.51.09l2.26,1.3a.79.79,0,0,1,.27.32.91.91,0,0,1,.12.44.28.28,0,0,1,0,.09s0,.09,0,.19L436.77,244c-.17.54-.49.68-.95.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.83,234.6a1.34,1.34,0,0,1,.55.58,3.39,3.39,0,0,1,.26.67l3.91,17.32a1.74,1.74,0,0,1,.07.4.33.33,0,0,1-.12.3.22.22,0,0,1-.27,0l-2.26-1.3a1.29,1.29,0,0,1-.51-.5,1.55,1.55,0,0,1-.19-.51l-.51-2.27L444,246.54l-.51,1.69a.45.45,0,0,1-.19.29c-.1.07-.27,0-.51-.1l-2.26-1.3a.73.73,0,0,1-.27-.32.88.88,0,0,1-.12-.43.93.93,0,0,1,.07-.32l3.91-12.81a.81.81,0,0,1,.26-.37c.13-.11.31-.09.55,0Zm-2.9,8.77,2.9,1.68-1.45-6.58Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M412.46,153.81l52.16,30.05a2.84,2.84,0,0,1,1.3,2.24v29.11c0,.83-.58,1.16-1.3.75l-52.16-30.05a2.85,2.85,0,0,1-1.29-2.24V154.56C411.17,153.73,411.75,153.4,412.46,153.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.45,156.94,459.61,187a2.85,2.85,0,0,1,1.3,2.24v29.12a2.85,2.85,0,0,1-1.31,2.23l-2.14,1.21a2.91,2.91,0,0,1-2.59,0l-52.16-30.05a2.85,2.85,0,0,1-1.3-2.24V160.37a2.85,2.85,0,0,1,1.31-2.23l2.14-1.21A2.88,2.88,0,0,1,407.45,156.94Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.45,156.94,459.61,187a2.85,2.85,0,0,1,1.3,2.24v29.12a2.85,2.85,0,0,1-1.31,2.23l-2.14,1.21a2.91,2.91,0,0,1-2.59,0l-52.16-30.05a2.85,2.85,0,0,1-1.3-2.24V160.37a2.85,2.85,0,0,1,1.31-2.23l2.14-1.21A2.88,2.88,0,0,1,407.45,156.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.43,160.14c.1-.66.64-.89,1.28-.52l52.16,30a2.67,2.67,0,0,1,.91,1l4.72-2.73a2.54,2.54,0,0,0-.89-.92l-52.16-30.05a2.9,2.9,0,0,0-2.6,0l-2.13,1.21A2.85,2.85,0,0,0,401.43,160.14Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.43,160.14c.1-.66.64-.89,1.28-.52l52.16,30a2.67,2.67,0,0,1,.91,1l4.72-2.73a2.54,2.54,0,0,0-.89-.92l-52.16-30.05a2.9,2.9,0,0,0-2.6,0l-2.13,1.21A2.85,2.85,0,0,0,401.43,160.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.71,159.62l52.16,30a2.87,2.87,0,0,1,1.29,2.24V221c0,.82-.58,1.16-1.29.75l-52.16-30.05a2.85,2.85,0,0,1-1.3-2.24V160.37C401.41,159.55,402,159.21,402.71,159.62Z",
    style: {
      fill: "#10E2ED"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M414.33,173.38a.86.86,0,0,1,.32.39,1.24,1.24,0,0,1,.13.56V190.9a.56.56,0,0,1-.13.41.25.25,0,0,1-.32,0l-2.18-1.26a.86.86,0,0,1-.32-.39,1.3,1.3,0,0,1-.13-.56v-6.29L408,180.7V187a.53.53,0,0,1-.13.41.24.24,0,0,1-.32,0l-2.18-1.26a.78.78,0,0,1-.31-.37,1.27,1.27,0,0,1-.14-.58V168.64a.53.53,0,0,1,.14-.41.23.23,0,0,1,.31,0l2.18,1.26a.81.81,0,0,1,.32.39,1.31,1.31,0,0,1,.13.57v6.18l3.7,2.13v-6.18a.55.55,0,0,1,.13-.41.25.25,0,0,1,.32,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.51,180.41a.87.87,0,0,1,.31.38,1.33,1.33,0,0,1,.14.57v2.72a.55.55,0,0,1-.14.41.24.24,0,0,1-.31,0l-2.93-1.69V196a.53.53,0,0,1-.14.41.22.22,0,0,1-.31,0L421,195.15a.81.81,0,0,1-.32-.39,1.33,1.33,0,0,1-.14-.57V181l-2.93-1.69a.85.85,0,0,1-.31-.39,1.32,1.32,0,0,1-.14-.56v-2.72a.53.53,0,0,1,.14-.41.23.23,0,0,1,.31,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.16,198.25c-.09-.2-.17-.38-.23-.55l-1.56-5.14v8.49a.59.59,0,0,1-.13.41.24.24,0,0,1-.32,0l-2.18-1.26a.81.81,0,0,1-.32-.39,1.24,1.24,0,0,1-.13-.56V182.71a.57.57,0,0,1,.13-.42.25.25,0,0,1,.32,0l1.93,1.12a1.21,1.21,0,0,1,.5.57c.11.25.18.43.22.53l2.69,8.66,2.7-5.54a1.55,1.55,0,0,1,.22-.29c.11-.12.28-.12.5,0l1.93,1.12a.89.89,0,0,1,.32.38,1.31,1.31,0,0,1,.13.57V206a.53.53,0,0,1-.13.41.24.24,0,0,1-.32,0l-2.18-1.26a.86.86,0,0,1-.32-.39,1.31,1.31,0,0,1-.13-.57V195.7L436.23,199a1.05,1.05,0,0,1-.22.3c-.1.09-.23.08-.39,0l-1.07-.62A.89.89,0,0,1,434.16,198.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.21,209.09a.85.85,0,0,1,.31.39,1.32,1.32,0,0,1,.14.56v2.72a.53.53,0,0,1-.14.41.23.23,0,0,1-.31,0l-7.72-4.45a.85.85,0,0,1-.31-.39,1.25,1.25,0,0,1-.14-.56V191.23a.57.57,0,0,1,.14-.42.24.24,0,0,1,.31,0l2.19,1.26a.85.85,0,0,1,.31.39,1.32,1.32,0,0,1,.14.56v13.16Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-3--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-chart--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.17,26.55a.76.76,0,0,1,0-.16,0,0,0,0,1,0,0,.33.33,0,0,1,0-.15.62.62,0,0,1,.1-.22.26.26,0,0,1,0-.09s0,0,.05-.06a.68.68,0,0,1,.12-.12h0l.14-.08a1.23,1.23,0,0,1,1.15.14L349,71.46a3.76,3.76,0,0,1,1.72,3V128h0a1.17,1.17,0,0,1-1.76,1L269.87,83.28a3.77,3.77,0,0,1-1.71-3V26.76C268.16,26.69,268.17,26.62,268.17,26.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.8,27.52a1.16,1.16,0,0,1,1.24.1L345.22,73.3a3.77,3.77,0,0,1,1.7,3v2.46h0v50.67a2,2,0,0,1,0,.25A1.84,1.84,0,0,1,346,131l-1.81,1-.09.05a1.18,1.18,0,0,0,.62-1V81h0V77.5a3.81,3.81,0,0,0-1.71-3L263.86,28.85a1.23,1.23,0,0,0-1.15-.14Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.16,29.63a.78.78,0,0,1,0-.16,0,0,0,0,1,0,0,.42.42,0,0,1,0-.16.62.62,0,0,1,.1-.22.24.24,0,0,1,.06-.09.13.13,0,0,1,.05-.06.38.38,0,0,1,.11-.11h0l.15-.08a1.23,1.23,0,0,1,1.15.14L343,74.53a3.81,3.81,0,0,1,1.71,3V131h0a1.17,1.17,0,0,1-1.76,1L263.86,86.36a3.76,3.76,0,0,1-1.72-3V29.84A1.36,1.36,0,0,1,262.16,29.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1,29.37a.84.84,0,0,1,.38.13l79.17,45.68A3.06,3.06,0,0,1,344,77.5V131a.42.42,0,0,1-.42.42.37.37,0,0,1-.21-.06L264.23,85.71a3.05,3.05,0,0,1-1.34-2.31V29.84c0-.05,0-.1,0-.13v0l0,0v0l.07-.19v0l0,0h.08m0-.75a.83.83,0,0,0-.39.09l-.15.08h0a.38.38,0,0,0-.11.11.13.13,0,0,0-.05.06.24.24,0,0,0-.06.09.62.62,0,0,0-.1.22.42.42,0,0,0,0,.16,0,0,0,0,0,0,0,.78.78,0,0,0,0,.16,1.36,1.36,0,0,0,0,.21V83.4a3.76,3.76,0,0,0,1.72,3L343,132a1.17,1.17,0,0,0,1.76-1V77.5a3.81,3.81,0,0,0-1.71-3L263.86,28.85a1.64,1.64,0,0,0-.76-.23Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.86,28.85,343,74.53a3.67,3.67,0,0,1,1.2,1.27l2.17-1.26a3.31,3.31,0,0,0-1.19-1.24L266,27.61a1.23,1.23,0,0,0-1.24-.1c-.31.19-1.73,1-2.09,1.19A1.27,1.27,0,0,1,263.86,28.85Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.86,28.85,343,74.53a3.67,3.67,0,0,1,1.2,1.27l2.17-1.26a3.31,3.31,0,0,0-1.19-1.24L266,27.61a1.23,1.23,0,0,0-1.24-.1c-.31.19-1.73,1-2.09,1.19A1.27,1.27,0,0,1,263.86,28.85Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.59,122.92a.16.16,0,0,0,.15-.09.19.19,0,0,0-.06-.25L268.34,82a.17.17,0,0,0-.24.07.19.19,0,0,0,.06.25l70.34,40.6A.14.14,0,0,0,338.59,122.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.59,123.8a.18.18,0,0,0,.18-.18v-1.69a.18.18,0,0,0-.36,0v1.69A.18.18,0,0,0,338.59,123.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,117a.18.18,0,0,0,.18-.18v-1.7a.18.18,0,0,0-.36,0v1.7A.18.18,0,0,0,326.86,117Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.14,110.2a.19.19,0,0,0,.18-.18v-1.7a.18.18,0,0,0-.36,0V110A.19.19,0,0,0,315.14,110.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.42,103.39a.18.18,0,0,0,.18-.18v-1.69a.18.18,0,0,0-.36,0v1.69A.18.18,0,0,0,303.42,103.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,96.59a.18.18,0,0,0,.18-.18V94.72a.18.18,0,0,0-.36,0v1.69A.18.18,0,0,0,291.7,96.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,89.79a.18.18,0,0,0,.18-.18V87.92a.18.18,0,0,0-.36,0v1.69A.18.18,0,0,0,280,89.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.25,83a.18.18,0,0,0,.18-.18V81.12a.18.18,0,0,0-.36,0v1.69A.18.18,0,0,0,268.25,83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.59,105.82c-5.86-3.39-7.33,4.23-11.73,1.69s-1.46-17.77-8.79-22-5.86,10.16-13.19,5.93-4.39-31.3-11.72-35.53S287.3,73,280,68.7,277,43.22,268.25,38.14V78.75l70.34,40.6Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.25,45.79v33l70.34,40.6v-5.07l-5.18-5.23c-.1.26-.37.33-.69.15a1.62,1.62,0,0,1-.73-1.27.52.52,0,0,1,.19-.45l-4.77-7.55a.49.49,0,0,1-.54,0,1.51,1.51,0,0,1-.59-.68l-4.69,1.35a1.52,1.52,0,0,1,.15.6c0,.46-.33.65-.74.42a1.64,1.64,0,0,1-.73-1.27.64.64,0,0,1,.08-.33l-4.55-5.26c-.12.21-.37.26-.66.09a1.62,1.62,0,0,1-.73-1.26.56.56,0,0,1,.15-.42l-4.7-6.78a.46.46,0,0,1-.58,0,1.62,1.62,0,0,1-.73-1.27,1.11,1.11,0,0,1,0-.19l-4.44-3.85c-.08.33-.37.43-.71.24a1.63,1.63,0,0,1-.73-1.27.59.59,0,0,1,.08-.34l-4.56-5.25c-.11.2-.36.25-.65.09A1.45,1.45,0,0,1,297,74l-4.82,2.79a1.49,1.49,0,0,1,.21.72c0,.47-.33.65-.73.42a1.59,1.59,0,0,1-.73-1.27.58.58,0,0,1,0-.19l-4.44-3.85c-.08.33-.37.43-.71.23a1.6,1.6,0,0,1-.74-1.26c0-.27.11-.45.28-.5h0l-4.95-10A.58.58,0,0,1,280,61a1.62,1.62,0,0,1-.73-1.27h0l-4.39-2.53c0,.46-.33.65-.74.42a1.64,1.64,0,0,1-.73-1.27c0-.27.11-.45.27-.5l-4.92-10A.55.55,0,0,1,268.25,45.79Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.59,114.46a.18.18,0,0,0,.12,0,.19.19,0,0,0,0-.26l-5.17-5.23a.18.18,0,1,0-.26.26l5.18,5.23A.19.19,0,0,0,338.59,114.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.18,107.66a.15.15,0,0,0,.09,0,.18.18,0,0,0,.06-.25l-4.76-7.56a.18.18,0,0,0-.25-.06.18.18,0,0,0-.06.25l4.76,7.56A.21.21,0,0,0,332.18,107.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.59,100.75h.05l4.69-1.36a.18.18,0,0,0-.1-.34l-4.69,1.35a.17.17,0,0,0-.12.22A.17.17,0,0,0,321.59,100.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.35,100.17a.19.19,0,0,0,.12,0,.2.2,0,0,0,0-.26l-4.56-5.26a.18.18,0,0,0-.27.24l4.55,5.26A.2.2,0,0,0,320.35,100.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.56,93.31a.19.19,0,0,0,.1,0,.18.18,0,0,0,0-.25L310,86.26a.19.19,0,0,0-.25-.05.18.18,0,0,0,0,.25l4.69,6.77A.18.18,0,0,0,314.56,93.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.57,85.08a.18.18,0,0,0,.12-.32l-4.44-3.84a.18.18,0,0,0-.26,0,.19.19,0,0,0,0,.25L308.45,85A.19.19,0,0,0,308.57,85.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.77,79.86a.15.15,0,0,0,.11,0,.17.17,0,0,0,0-.25l-4.55-5.26a.18.18,0,0,0-.26,0,.19.19,0,0,0,0,.25l4.56,5.26A.17.17,0,0,0,302.77,79.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22,76.94l.09,0,4.82-2.78a.18.18,0,1,0-.18-.32l-4.82,2.79a.18.18,0,0,0-.07.25A.19.19,0,0,0,292.22,76.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,76.62a.16.16,0,0,0,.13-.06.18.18,0,0,0,0-.26l-4.43-3.84a.19.19,0,0,0-.26,0,.19.19,0,0,0,0,.25l4.44,3.85A.16.16,0,0,0,291,76.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.38,71.24l.08,0a.17.17,0,0,0,.08-.24L280.6,61a.18.18,0,1,0-.32.16l4.94,10A.18.18,0,0,0,285.38,71.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.24,59.89a.19.19,0,0,0,.16-.09.17.17,0,0,0-.07-.24L274.94,57a.19.19,0,0,0-.25.06.18.18,0,0,0,.07.25l4.39,2.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.66,56l.08,0a.18.18,0,0,0,.08-.24l-4.93-10a.2.2,0,0,0-.24-.08.19.19,0,0,0-.09.24l4.94,10A.18.18,0,0,0,273.66,56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.64,109.36a1.78,1.78,0,0,1-.83-1.43.69.69,0,0,1,.31-.63.71.71,0,0,1,.7,0h0a1.81,1.81,0,0,1,.82,1.43.68.68,0,0,1-.31.63.53.53,0,0,1-.28.07A.83.83,0,0,1,332.64,109.36Zm0-1.69a.34.34,0,0,0-.34,0,.34.34,0,0,0-.13.31,1.45,1.45,0,0,0,.65,1.12.38.38,0,0,0,.33,0,.36.36,0,0,0,.13-.32,1.46,1.46,0,0,0-.64-1.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.77,100.05a1.78,1.78,0,0,1-.82-1.42.67.67,0,0,1,.31-.63.65.65,0,0,1,.69,0h0a1.78,1.78,0,0,1,.83,1.42.67.67,0,0,1-.31.63.54.54,0,0,1-.28.08A.82.82,0,0,1,326.77,100.05Zm0-1.69a.32.32,0,0,0-.33,0,.36.36,0,0,0-.13.32,1.46,1.46,0,0,0,.64,1.11.34.34,0,0,0,.34.05.35.35,0,0,0,.13-.32,1.44,1.44,0,0,0-.65-1.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.91,101.74a1.78,1.78,0,0,1-.82-1.42.69.69,0,0,1,.3-.63.69.69,0,0,1,.7,0,1.81,1.81,0,0,1,.83,1.43.69.69,0,0,1-.31.63.53.53,0,0,1-.28.07A.82.82,0,0,1,320.91,101.74Zm-.33-1.74a.36.36,0,0,0-.13.32,1.43,1.43,0,0,0,.64,1.11.34.34,0,0,0,.34,0,.34.34,0,0,0,.13-.31,1.45,1.45,0,0,0-.65-1.12.46.46,0,0,0-.23-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.05,95a1.78,1.78,0,0,1-.82-1.42.68.68,0,0,1,.3-.63.66.66,0,0,1,.7,0h0a1.79,1.79,0,0,1,.83,1.42.67.67,0,0,1-.31.63.54.54,0,0,1-.28.08A.82.82,0,0,1,315.05,95Zm0-1.69a.34.34,0,0,0-.34-.05.37.37,0,0,0-.12.32,1.43,1.43,0,0,0,.64,1.11.34.34,0,0,0,.34,0c.08,0,.12-.16.12-.32a1.43,1.43,0,0,0-.64-1.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.19,86.52a1.81,1.81,0,0,1-.82-1.43.69.69,0,0,1,.3-.63.71.71,0,0,1,.7.05h0a1.8,1.8,0,0,1,.82,1.43.68.68,0,0,1-.3.63.55.55,0,0,1-.28.07A.87.87,0,0,1,309.19,86.52Zm0-1.7a.4.4,0,0,0-.34,0,.37.37,0,0,0-.12.32,1.43,1.43,0,0,0,.64,1.11.38.38,0,0,0,.34.06.37.37,0,0,0,.12-.32,1.47,1.47,0,0,0-.64-1.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.33,81.44a1.78,1.78,0,0,1-.82-1.42.62.62,0,0,1,1-.58h0a1.78,1.78,0,0,1,.82,1.42.68.68,0,0,1-.3.63.57.57,0,0,1-.28.08A.89.89,0,0,1,303.33,81.44Zm0-1.69a.34.34,0,0,0-.34,0c-.08,0-.12.16-.12.32a1.43,1.43,0,0,0,.64,1.11.34.34,0,0,0,.34.05.36.36,0,0,0,.12-.32,1.43,1.43,0,0,0-.64-1.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61,78.06a1.82,1.82,0,0,1-.83-1.43.69.69,0,0,1,.31-.63.71.71,0,0,1,.7,0,1.8,1.8,0,0,1,.82,1.43.69.69,0,0,1-.3.63.57.57,0,0,1-.29.07A.83.83,0,0,1,291.61,78.06Zm-.34-1.75a.37.37,0,0,0-.13.32,1.48,1.48,0,0,0,.65,1.12.27.27,0,0,0,.46-.27,1.43,1.43,0,0,0-.64-1.11.52.52,0,0,0-.24-.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75,73a1.78,1.78,0,0,1-.83-1.42.63.63,0,0,1,1-.58h0a1.78,1.78,0,0,1,.82,1.42.67.67,0,0,1-.31.63.54.54,0,0,1-.28.08A.85.85,0,0,1,285.75,73Zm0-1.69a.34.34,0,0,0-.34-.05.35.35,0,0,0-.13.32,1.44,1.44,0,0,0,.65,1.11.32.32,0,0,0,.33,0,.36.36,0,0,0,.13-.32,1.46,1.46,0,0,0-.64-1.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,57.75a1.78,1.78,0,0,1-.82-1.42.68.68,0,0,1,.31-.63.65.65,0,0,1,.69,0h0a1.78,1.78,0,0,1,.83,1.42.67.67,0,0,1-.31.63.54.54,0,0,1-.28.08A.82.82,0,0,1,274,57.75Zm0-1.69a.32.32,0,0,0-.33-.05.36.36,0,0,0-.13.32,1.46,1.46,0,0,0,.64,1.11.34.34,0,0,0,.34.05.35.35,0,0,0,.13-.32,1.44,1.44,0,0,0-.65-1.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.88,61.14a1.8,1.8,0,0,1-.82-1.43.68.68,0,0,1,.31-.63.69.69,0,0,1,.69.05h0a1.8,1.8,0,0,1,.83,1.43.68.68,0,0,1-.31.63.53.53,0,0,1-.28.07A.9.9,0,0,1,279.88,61.14Zm0-1.69a.36.36,0,0,0-.33-.06.37.37,0,0,0-.13.32,1.46,1.46,0,0,0,.64,1.11.38.38,0,0,0,.34.06.37.37,0,0,0,.13-.32,1.44,1.44,0,0,0-.65-1.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.16,46a1.8,1.8,0,0,1-.82-1.42.68.68,0,0,1,.3-.63.66.66,0,0,1,.7.05,1.79,1.79,0,0,1,.83,1.42.68.68,0,0,1-.31.63.54.54,0,0,1-.28.08A.92.92,0,0,1,268.16,46Zm-.34-1.74a.37.37,0,0,0-.12.32,1.43,1.43,0,0,0,.64,1.11.34.34,0,0,0,.34,0,.36.36,0,0,0,.12-.32,1.43,1.43,0,0,0-.64-1.11.52.52,0,0,0-.24-.08A.19.19,0,0,0,267.82,44.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.47,74.67a1.78,1.78,0,0,1-.82-1.42.62.62,0,0,1,1-.58h0a1.8,1.8,0,0,1,.82,1.42.68.68,0,0,1-.3.63.57.57,0,0,1-.28.08A.76.76,0,0,1,297.47,74.67Zm-.34-1.74a.36.36,0,0,0-.12.32,1.43,1.43,0,0,0,.64,1.11.34.34,0,0,0,.34,0c.08,0,.12-.16.12-.32a1.43,1.43,0,0,0-.64-1.11h0a.49.49,0,0,0-.24-.07A.16.16,0,0,0,297.13,72.93Zm.42-.11h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.65,108.23a5.89,5.89,0,0,0,3.28-1.48c1.73-1.25,3.53-2.53,6.57-.78l.18-.31c-3.25-1.87-5.22-.46-7,.79-1.52,1.09-2.83,2-4.77.9s-2.35-4.49-2.94-8.47c-.77-5.2-1.64-11.09-5.85-13.52-3.82-2.21-5.35.45-6.84,3a9.49,9.49,0,0,1-2.42,3.16c-1.08.74-2.33.65-3.92-.27-3.59-2.07-4.7-10-5.78-17.63s-2.21-15.74-5.95-17.9a3.18,3.18,0,0,0-2.77-.42c-1.94.73-3,3.88-4.08,6.94s-2.07,6-3.86,6.7a2.8,2.8,0,0,1-2.47-.43c-3.42-2-4.24-7.83-5.1-14-1-6.83-2-13.89-6.63-16.59l-.18.32c4.52,2.61,5.5,9.58,6.45,16.32.88,6.23,1.7,12.12,5.27,14.23a3.22,3.22,0,0,0,2.79.46c1.94-.72,3-3.87,4.07-6.92s2.08-6.06,3.87-6.73a2.82,2.82,0,0,1,2.46.4c3.59,2.07,4.7,10,5.78,17.64s2.21,15.73,5.94,17.89c1.71,1,3.12,1.07,4.32.26a9.91,9.91,0,0,0,2.52-3.28c1.46-2.53,2.84-4.92,6.35-2.9,4.06,2.34,4.92,8.14,5.67,13.26.61,4.07,1.13,7.59,3.12,8.74A3.81,3.81,0,0,0,328.65,108.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.74,54.39c-.63-.37-1.14-.07-1.14.66a2.52,2.52,0,0,0,1.14,2c.63.37,1.15.07,1.15-.66A2.53,2.53,0,0,0,292.74,54.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.61,73a.18.18,0,0,0,.15-.1.18.18,0,0,0-.06-.24L305,65.93l-1.44-4.16a.16.16,0,0,0-.08-.1l-5.86-3.38a.19.19,0,0,0-.25.06.18.18,0,0,0,.07.25l5.8,3.35,1.44,4.17a.24.24,0,0,0,.08.09L316.52,73A.16.16,0,0,0,316.61,73Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.28,70.11a1.68,1.68,0,0,0-.78-1.3l-8.7-5c-.43-.25-.78-.07-.78.39a1.68,1.68,0,0,0,.78,1.3l8.7,5C315.93,70.75,316.28,70.57,316.28,70.11Z",
    style: {
      fill: "#10E2ED"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bar-graph--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.81,419.92,66,412a.17.17,0,0,1,0-.3l11-6.38a.17.17,0,0,1,.17,0l13.82,8a.18.18,0,0,1,.08.15.16.16,0,0,1-.08.14L80,419.92a.11.11,0,0,1-.08,0Zm-2.68-14.3L66.42,411.8l13.48,7.78,10.71-6.18Z",
    style: {
      fill: "#10E2ED"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "79.9 418.18 79.9 375.16 88.19 370.37 88.19 413.4 79.9 418.18",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.9 418.18 79.9 375.16 88.19 370.37 88.19 413.4 79.9 418.18",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.9 418.18 68.84 411.8 68.84 368.78 79.9 375.16 79.9 418.18",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.84 368.78 77.13 363.99 88.19 370.37 79.9 375.16 68.84 368.78",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.84 368.78 77.13 363.99 88.19 370.37 79.9 375.16 68.84 368.78",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.84,368.78,80,374.93l3.62-2,4.56-2.54-4.47,2.68-3.67,2.19c.09,1.24.11,37.88.09,39.13a34.79,34.79,0,0,1-.24,3.81,32.49,32.49,0,0,1-.25-3.81c0-1.21,0-37.81.09-39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.54,431.89l-13.82-8a.16.16,0,0,1-.08-.14.16.16,0,0,1,.08-.15l11-6.38a.17.17,0,0,1,.17,0l13.82,8a.18.18,0,0,1,0,.3l-11.05,6.38-.09,0Zm-2.68-14.31-10.71,6.19,13.47,7.78,10.71-6.19Z",
    style: {
      fill: "#10E2ED"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "100.62 430.15 100.62 404.12 108.91 399.34 108.91 425.36 100.62 430.15",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.62 430.15 100.62 404.12 108.91 399.34 108.91 425.36 100.62 430.15",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.62 430.15 89.57 423.77 89.57 397.74 100.62 404.12 100.62 430.15",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.62 430.15 89.57 423.77 89.57 397.74 100.62 404.12 100.62 430.15",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.57 397.74 97.86 392.95 108.91 399.34 100.62 404.12 89.57 397.74",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.57 397.74 97.86 392.95 108.91 399.34 100.62 404.12 89.57 397.74",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.48,404.33l-10.91-6.59,11.16,6.16,3.63-2,4.55-2.53L104.44,402c-1.22.73-2.44,1.47-3.67,2.19,0,1.29.08,7.52.09,8.81s0,7.92,0,9.24,0,2.63-.08,3.95-.08,2.63-.17,3.95c-.08-1.32-.14-2.64-.17-3.95s-.06-2.64-.07-3.95,0-7.93,0-9.24S100.44,405.57,100.48,404.33Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.26,443.85l-13.82-8a.18.18,0,0,1,0-.3l11.06-6.38a.17.17,0,0,1,.17,0l13.81,8a.16.16,0,0,1,.09.15.15.15,0,0,1-.09.14l-11,6.38a.13.13,0,0,1-.08,0Zm-2.68-14.3-10.71,6.18,13.48,7.78,10.71-6.18Z",
    style: {
      fill: "#10E2ED"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "121.35 442.11 121.35 430.05 129.64 425.26 129.64 437.33 121.35 442.11",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.35 442.11 121.35 430.05 129.64 425.26 129.64 437.33 121.35 442.11",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.35 442.11 110.29 435.73 110.29 423.67 121.35 430.05 121.35 442.11",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.35 442.11 110.29 435.73 110.29 423.67 121.35 430.05 121.35 442.11",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.29 423.67 118.58 418.88 129.64 425.26 121.35 430.05 110.29 423.67",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.29 423.67 118.58 418.88 129.64 425.26 121.35 430.05 110.29 423.67",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.29,423.67l11.17,6.15,3.62-2,4.56-2.54-4.48,2.68-3.66,2.19c.08.75.11,8.87.09,9.63a13.28,13.28,0,0,1-.24,2.35,12.51,12.51,0,0,1-.25-2.35c0-.72,0-8.8.08-9.52Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.09,408l-13.82-8a.16.16,0,0,1-.08-.14.16.16,0,0,1,.08-.15l11-6.38a.19.19,0,0,1,.18,0l13.81,8a.17.17,0,0,1,0,.3L59.26,408l-.09,0Zm-2.68-14.31L45.7,399.84l13.47,7.78,10.72-6.19Z",
    style: {
      fill: "#10E2ED"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "59.17 406.22 59.17 343.9 67.47 339.12 67.46 401.43 59.17 406.22",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.17 406.22 59.17 343.9 67.47 339.12 67.46 401.43 59.17 406.22",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.17 406.22 48.12 399.83 48.12 337.52 59.17 343.9 59.17 406.22",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.17 406.22 48.12 399.83 48.12 337.52 59.17 343.9 59.17 406.22",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.12 337.52 56.41 332.74 67.47 339.12 59.17 343.9 48.12 337.52",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.12 337.52 56.41 332.74 67.47 339.12 59.17 343.9 48.12 337.52",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,344.11l-10.91-6.59,11.17,6.16c1.2-.68,2.41-1.35,3.62-2l4.55-2.54L63,341.8c-1.22.73-2.44,1.46-3.67,2.18,0,1.47.08,2.93.09,4.39s0,47.42,0,48.91,0,3-.08,4.47-.08,3-.17,4.47c-.08-1.49-.13-3-.17-4.47s-.06-3-.07-4.47,0-47.42,0-48.91S59,345.53,59,344.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pie-chart--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.68,125.06a.8.8,0,0,0,0-.15.06.06,0,0,0,0,0,.42.42,0,0,0,0-.15.62.62,0,0,0-.1-.22.41.41,0,0,0,0-.09l0-.06a.63.63,0,0,0-.12-.11h0a.67.67,0,0,0-.14-.09,1.27,1.27,0,0,0-1.15.15L37,149.08a3.78,3.78,0,0,0-1.71,3v53.54h0a1.17,1.17,0,0,0,1.75,1L80,181.8a3.8,3.8,0,0,0,1.71-3V125.28C81.69,125.2,81.68,125.13,81.68,125.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.14,127.32a1.2,1.2,0,0,0-1.24.1l-43,24.79a3.75,3.75,0,0,0-1.71,3v2.46h0v50.68a2.18,2.18,0,0,0,0,.25,1.83,1.83,0,0,0,.9,1.32L44,211.56l.08.05a1.19,1.19,0,0,1-.61-1V160.5h0V157a3.78,3.78,0,0,1,1.71-3l43-24.79a1.23,1.23,0,0,1,1.15-.14C89,129,86.45,127.51,86.14,127.32Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.89,130.07a.76.76,0,0,0,0-.16s0,0,0,0a.76.76,0,0,0,0-.16.91.91,0,0,0-.11-.22.41.41,0,0,0,0-.09l0-.06-.11-.11h0l-.14-.08a1.23,1.23,0,0,0-1.15.14l-43,24.79a3.78,3.78,0,0,0-1.71,3v53.54h0a1.17,1.17,0,0,0,1.76,1l43-24.79a3.78,3.78,0,0,0,1.71-3V130.28C89.9,130.21,89.89,130.13,89.89,130.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,129.81a.13.13,0,0,1,.08,0h0v0l.07.2v0l0,0h0a.76.76,0,0,1,0,.15v53.56a3,3,0,0,1-1.34,2.31l-43,24.79a.42.42,0,0,1-.63-.36V157a3,3,0,0,1,1.34-2.31l43-24.79a.86.86,0,0,1,.39-.13m0-.75a1.61,1.61,0,0,0-.76.23l-43,24.79a3.78,3.78,0,0,0-1.71,3v53.54a1.17,1.17,0,0,0,1.76,1l43-24.79a3.78,3.78,0,0,0,1.71-3V130.28c0-.07,0-.15,0-.21a.76.76,0,0,0,0-.16s0,0,0,0a.76.76,0,0,0,0-.16.91.91,0,0,0-.11-.22.41.41,0,0,0,0-.09l0-.06-.11-.11h0l-.14-.08a.86.86,0,0,0-.39-.09Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.19,129.29l-43,24.79a3.5,3.5,0,0,0-1.2,1.27l-3.28-1.89a3.34,3.34,0,0,1,1.19-1.25l43-24.79a1.2,1.2,0,0,1,1.24-.1c.3.19,2.83,1.63,3.19,1.82A1.25,1.25,0,0,0,88.19,129.29Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.19,129.29l-43,24.79a3.5,3.5,0,0,0-1.2,1.27l-3.28-1.89a3.34,3.34,0,0,1,1.19-1.25l43-24.79a1.2,1.2,0,0,1,1.24-.1c.3.19,2.83,1.63,3.19,1.82A1.25,1.25,0,0,0,88.19,129.29Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pie-chart--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.12,170.21,67.3,168l8.07,9.68,3.81,2.2h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.12 170.21 67.31 168.01 81.67 155.58 85.48 157.78 71.12 170.21",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.18,179.89l-8.06-9.68,14.36-12.43C86.74,164.2,84.32,172.69,79.18,179.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.86,189.81l-.12-.06.12.06Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.41,169l-12.19-4C48.7,175,49.54,184.53,55,187.6h0l3.72,2.15c-5.4-3.12-6.2-12.64-1.71-22.53l8.38,2.72Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.41,169l-12.19-4C48.7,175,49.54,184.53,55,187.6h0l3.72,2.15c-5.4-3.12-6.2-12.64-1.71-22.53l8.38,2.72Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93,165.38l-3.81-2.2a34.65,34.65,0,0,1,8.19-10.57c4.1-3.55,8.36-5.27,12-4.85a8,8,0,0,1,3,1L81.24,151a4.64,4.64,0,0,0,.08,3.16l-2.69,2.33L66.31,167.14Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93,165.38l-3.81-2.2a34.65,34.65,0,0,1,8.19-10.57c4.1-3.55,8.36-5.27,12-4.85a8,8,0,0,1,3,1L81.24,151a4.64,4.64,0,0,0,.08,3.16l-2.69,2.33L66.31,167.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.87 186.01 66.87 170.57 70.68 172.77 70.68 188.21 66.87 186.01",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.87 186.01 66.87 170.57 70.68 172.77 70.68 188.21 66.87 186.01",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2,190.4c-6.69-2.18-8-12.45-3.17-23.18l12.2,4v17.87C65.86,190.83,62.9,191.27,60.2,190.4Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2,190.4c-6.69-2.18-8-12.45-3.17-23.18l12.2,4v17.87C65.86,190.83,62.9,191.27,60.2,190.4Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.29,165.5l-.36-.12a34.64,34.64,0,0,1,8.19-10.56c4.11-3.56,8.36-5.28,12-4.86,3.42.4,5.89,2.66,7,6.39l-2.69,2.33L70.12,169.34Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.29,165.5l-.36-.12a34.64,34.64,0,0,1,8.19-10.56c4.11-3.56,8.36-5.28,12-4.86,3.42.4,5.89,2.66,7,6.39l-2.69,2.33L70.12,169.34Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.68,188.21V172.77L78,181.51A27.23,27.23,0,0,1,70.68,188.21Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.41 168.98 69.22 171.18 57.03 167.22 53.22 165.02 65.41 168.98",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.41 168.98 69.22 171.18 57.03 167.22 53.22 165.02 65.41 168.98",
    style: {
      opacity: 0.55
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.9,332.59s-2.59,5.54-2.9,7.77-1,3-.79,5.6c0,.56.23,1.69.27,2.14a.67.67,0,0,1-.68.78c-1.05.13-2.6-1.9-3.23-4a59.86,59.86,0,0,1-1.4-7.44,3.09,3.09,0,0,1,.47-1.6,5.2,5.2,0,0,1,.54-.81c.43-1,.77-2.89,1.17-4.2Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,339.38a2.33,2.33,0,0,0-.34.74,8.59,8.59,0,0,0,1.24,2.66,3.67,3.67,0,0,1,.54,2.71,6.33,6.33,0,0,0,1.23,4.26,10.26,10.26,0,0,0,4.89,3.73c2.43.95,3.42-.21,3.42-.21s.88-1.12.46-1.64S414,339.38,414,339.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.18,335a.45.45,0,0,0-.42.18c-.08.08-.64,1.15-1.07,1.7a7.79,7.79,0,0,0-1.73,2.5c.42,1.86,2.05,3.26,2.16,5s0,3.73,2.48,6,5.25,2.74,6.3,2.26,1-1.53-.17-3.63-1.88-6.87-1.88-6.87a16.14,16.14,0,0,1-.09-2,12.83,12.83,0,0,1,.36-1.91,1.39,1.39,0,0,0-.05-.88,1.56,1.56,0,0,0-.7-.56,6.55,6.55,0,0,0-1.34-.56,2.29,2.29,0,0,0-1.44.05c-.33.14-.6.38-.94.49a1.3,1.3,0,0,1-1.3-.33,1.05,1.05,0,0,1-.25-1.22A2.45,2.45,0,0,1,417.18,335Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.17,348.61a4.35,4.35,0,0,1,4.08-1.76c2.86.23,3.72,1.73,4.09,2.61.43,1,.81,2.88-.42,3.31s-2.78.17-5-1.15A6.08,6.08,0,0,1,417.17,348.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.43,340.22a.34.34,0,0,0,.26,0c.46-.19,2.84-.48,4.09.86.19-.13.18-.38,0-.76a5.38,5.38,0,0,0-4.31-.62.27.27,0,0,0-.14.37A.37.37,0,0,0,418.43,340.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.93,342.75a.87.87,0,0,0-.09-.78,5.47,5.47,0,0,0-4.12-.49.28.28,0,0,0-.15.37.3.3,0,0,0,.12.13.36.36,0,0,0,.27,0A4.56,4.56,0,0,1,422.93,342.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.77,346.63a1.61,1.61,0,0,0-.28-1.05,5.39,5.39,0,0,0-4.25-.57.27.27,0,0,0,0,.49.27.27,0,0,0,.26,0C420,345.33,422.59,345,423.77,346.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,343.74a.27.27,0,0,0,.26,0c.45-.18,2.78-.47,4,.82a1,1,0,0,0-.16-.85,5.41,5.41,0,0,0-4.12-.48.27.27,0,0,0-.15.36A.27.27,0,0,0,419,343.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.65,338.11s.51,5.77,1.17,9.82c.48,2.94,2.85,4,4.91,5.79.44.38,1.44,1.07,1.8,1.38a.68.68,0,0,1,.07,1.07c-.69.86-4,1.52-6.08.42s-4.18-3.8-5.45-4.75c-.48-.36-.93-.73-1.37-1.12s-.38-.82-.48-1.3c-.05-.24-.33-1.42-.33-1.42-.41-1.12-1.48-4-2-5.29Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.94,353.51a2.38,2.38,0,0,0,.17.82,8.74,8.74,0,0,0,2.66,1.46,3.81,3.81,0,0,1,2.09,1.92,6.66,6.66,0,0,0,3.62,2.8,10.92,10.92,0,0,0,6.35.18c2.61-.65,2.47-2.2,2.47-2.2s0-1.45-.66-1.63S419.94,353.51,419.94,353.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.89,348c-.07,0-.12.09-.17.4,0,.11.17,1.32.15,2a7.66,7.66,0,0,0,.07,3.08c1.49,1.29,3.7,1.49,4.85,2.85s2.24,3.1,5.74,3.53,5.79-.62,6.37-1.63-.38-1.9-2.29-3.05a40,40,0,0,1-5.55-4.64,11.75,11.75,0,0,1-.79-.93,3.74,3.74,0,0,1-.7-2.09c0-.34-.08-.63-.44-.75a1.63,1.63,0,0,0-.54-.06,7.47,7.47,0,0,0-2.38.48,7.27,7.27,0,0,0-1.1.5c-.27.16-.68.33-.81.63a.79.79,0,0,0,0,.43,9.19,9.19,0,0,0,.31,1.38c0,.07.05.14,0,.2-.11.23-.88-.69-1-.8a1.76,1.76,0,0,0-.85-.57.9.9,0,0,1-.68-.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.24,359.24a4.37,4.37,0,0,1,2.33-3.87c2.53-1.49,3.68-.57,4.51-.06,1,.6,2.71,1.84,1.95,2.92s-2,1.65-4.67,1.87A6.33,6.33,0,0,1,428.24,359.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.18,351.57a.31.31,0,0,0,.23-.14c.27-.43,2.08-2.08,3.94-1.71.08-.21-.09-.42-.48-.61a5.48,5.48,0,0,0-4,2,.26.26,0,0,0,.1.38A.39.39,0,0,0,424.18,351.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.48,351a.89.89,0,0,0-.56-.59,5.57,5.57,0,0,0-3.73,2,.26.26,0,0,0,.1.38.39.39,0,0,0,.18,0,.3.3,0,0,0,.23-.14A4.69,4.69,0,0,1,429.48,351Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.53,353.7a1.6,1.6,0,0,0-.86-.69,5.57,5.57,0,0,0-3.9,2,.27.27,0,0,0,.11.39.37.37,0,0,0,.18,0,.31.31,0,0,0,.23-.14C428.57,354.88,430.57,353.07,432.53,353.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.77,354.17A.33.33,0,0,0,427,354a4.62,4.62,0,0,1,3.87-1.72,1,1,0,0,0-.65-.6,5.6,5.6,0,0,0-3.74,2,.28.28,0,0,0,.1.39A.41.41,0,0,0,426.77,354.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.92,301.91s10.83,5.82,16,11.17c1.84,1.91,3,3.59,1,8.53-1.5,3.8-3.79,8.94-6.18,13.86l-23-27.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.75,335.47l-14.58-23.21.51-.08c2.75-1.19,3.89-4.91,3.89-4.91a6.4,6.4,0,0,1-1.21,4.74c1.55,1.14,5,3.73,10.42,7.78a5.69,5.69,0,0,1,2.7,4.66c0,3.71-.16,7.73-.16,7.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.94,301.91h0l-22.48,3.3a20.18,20.18,0,0,0,2.78,10.22c1.47,2.21,3.1,3.55,8.82,6.59,5.34,2.82,10.11,5.18,11.33,5.84.92.5.9,3,1.38,5.37a87.35,87.35,0,0,0,3.89,12.17,9.91,9.91,0,0,0,7.64-1.84S425.41,332.63,425,329c-.52-4.32-.49-5.39-2.63-7.5-1.83-1.8-12.66-9.34-12.66-9.34S414.84,306.94,412.94,301.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.42,304.78c.11,3.69.61,6.5,3.27,9.23,1.7-1.14,1.35-2.2.72-4.1-.18-.57-.4-1.22-.58-2a19.16,19.16,0,0,1-.57-3.59h.09l.22,0a19.82,19.82,0,0,0,.56,3.57c.18.72.39,1.36.58,1.93.63,1.9,1,3.17-.8,4.42a18.52,18.52,0,0,0,2.15,1.79c4,2.85,9.57,6.19,12.91,8.18,1.17.7,2.09,1.25,2.57,1.56,1.94,1.24,2.1,2.31,2.13,5.57,0,4.09,2.45,10.12,3.64,14.21H420c-1.2-4.17-3.68-10.29-3.62-14.21.05-3.31-.25-4.19-2-5.31-.47-.3-1.39-.85-2.56-1.55-3.35-2-8.95-5.34-12.93-8.19-4.87-3.49-5.63-6.77-5.77-11.46Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.12,295.89c-1.72-1.62-7.48-6.2-7.48-6.2s-2.26-9.05-3-11c-1.15-3-4.16-4.42-7.85-4l1.23,6.92s2.37,8.48,2.78,10a4.55,4.55,0,0,0,2.32,3c1.64,1.11,8,4.51,8,4.51l.3.23a1.34,1.34,0,0,1,.42.65,3,3,0,0,1,.12.78c.05.9-.09,1.14-.06,2.11s.24,1,.56,1.83.36,1.28.64,1.33.69-.56.73-1.2a9.26,9.26,0,0,0-.3-1.63c0-.23.16-.6.75-.2a11,11,0,0,1,1.86,3,21.7,21.7,0,0,0,1,2.36c.42.57.63,0,.87-.51s1.06-1,1.39-1.83a5.63,5.63,0,0,0-.19-3.71,14.43,14.43,0,0,0-2-4.21C426.52,297.41,425.85,296.59,425.12,295.89Z",
    style: {
      fill: "#c8856a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M406.13,274.62a7.77,7.77,0,0,1,7.34,1.92c1.41,1.53,1.51,2.37,2.4,5.57s1.53,5.8,1.53,5.8-1.79,2.69-7.08,2.55l-3.26-10.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.37,290.42c0,.45,0,.93,0,1.43,0-.5,0-1,0-1.43,0,.51,0,1.07,0,1.64v-1.64l0-.56v-.05l0-.47v-.13a.25.25,0,0,0,0-.08c0-.06,0-.12,0-.17.06-.76.12-1.51.23-2.22.32-3.05.2-6.64,2.92-8.52,2.15-.93,4.07-1.65,7.11-2.87a12.08,12.08,0,0,1,7.09-.63,6.25,6.25,0,0,1,3.72,1.37c3.08,2.69,3.56,7.14,3.65,11l.25,7.85c.14,2.58-.05,5.28,1.06,7.66,0,.08.07.16,0,.27l0,.1a12.07,12.07,0,0,1-5.35,5.34c-4.42,2.48-14.61,4.36-19.34,2.49a84.49,84.49,0,0,1-1-10.19C389.66,297.61,389.21,293.36,389.37,290.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.1,275.21a16.84,16.84,0,0,1,2.59.25h.08a5.41,5.41,0,0,1,3.26,1.19c2.83,2.47,3.3,6.66,3.39,10.44l.25,7.87c0,.53,0,1.06.06,1.59a16.36,16.36,0,0,0,1,6.09l0,0,0,.19a11.42,11.42,0,0,1-4.93,4.76c-3.15,1.77-9.26,3.16-13.9,3.16a14.62,14.62,0,0,1-4.41-.57,61.23,61.23,0,0,1-.74-7.29c-.05-.8-.1-1.6-.16-2.38s-.11-1.78-.18-2.77c-.14-1.89-.29-4-.3-5.77h0V292h0v-1.51l-.74,0h0l.74,0c0-.12,0-.23,0-.34v-.26l0-.47V289c.06-.86.13-1.55.22-2.19.05-.44.09-.89.12-1.34.22-2.54.44-5.18,2.43-6.6,1.42-.62,2.74-1.14,4.41-1.8l2.61-1a10.87,10.87,0,0,1,4.11-.84m-14.72,15.21h0m14.72-16a11.59,11.59,0,0,0-4.39.89c-3,1.22-5,1.94-7.11,2.87-2.72,1.88-2.6,5.47-2.92,8.52-.11.71-.17,1.46-.23,2.22,0,.05,0,.11,0,.17a.25.25,0,0,1,0,.08v.13l0,.47v.05l0,.56v1.64c0-.57,0-1.13,0-1.64,0,.45,0,.93,0,1.43,0-.5,0-1,0-1.43-.16,2.94.29,7.19.45,10.17a84.49,84.49,0,0,0,1,10.19,14.25,14.25,0,0,0,5.07.76c5,0,11.1-1.47,14.27-3.25A12.07,12.07,0,0,0,415.5,303l0-.1c.08-.11,0-.19,0-.27-1.11-2.38-.92-5.08-1.06-7.66l-.25-7.85c-.09-3.84-.57-8.29-3.65-11a6.25,6.25,0,0,0-3.72-1.37,16.27,16.27,0,0,0-2.7-.26Zm-14.73,16h0Zm0,0h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.08,274c-.09-1.81-1.89-4.34-2.5-6a7.49,7.49,0,0,1-.65-4.18,2.84,2.84,0,0,1,1.45-2.05,3.87,3.87,0,0,1,3.41-4.46,14.65,14.65,0,0,0,1.76-.27c.7-.2.92-.72,1.51-1.11a2,2,0,0,1,3,.75,2.09,2.09,0,0,1,2.48-.24,1.66,1.66,0,0,1,1,2,1.75,1.75,0,0,1,2.49,1.26c0,.58-.16,1,.15,1.58a.87.87,0,0,0,1.42.27c0,.82-.35,1.39-1.21,1.24a1.8,1.8,0,0,1,0,1.54,1.66,1.66,0,0,1-1.63,1,2.92,2.92,0,0,1-.54,1.17,2.89,2.89,0,0,1-1.12.8,18.91,18.91,0,0,1-4.3.62l-1.72.14c-.1,0-.6,0-.67.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.94,270.93a1.91,1.91,0,0,0,2.38-.22l-.43,5.65a6.1,6.1,0,0,0,6.3,3.73c1.72-.2,2.09-1.35,1-2.66l.07-1.31a11.47,11.47,0,0,0,1.6.1,3.61,3.61,0,0,0,3.17-2.48,16,16,0,0,0,.89-5.95,5.11,5.11,0,0,1,.1-1.46,7,7,0,0,0-.06-3.19c-1.38-1.41-4.87-2.26-8.41-.65a3.76,3.76,0,0,1-2.32,4.05c0,.54-.09,1.88-1,1.75-.62-.09-.57-.88-1.13-1.65a1.78,1.78,0,0,0-2.75-.19A3.42,3.42,0,0,0,395.94,270.93Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.19,265.73l-4.31.64a1.8,1.8,0,0,1,.52.75l3.74-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92,265.61l-.27,0a7.48,7.48,0,0,0-2.74.1c-.88.28-1.19.6-1.68.6s-.84-.32-1.78-.6a8.82,8.82,0,0,0-2.93-.09l-.3,0a.53.53,0,0,0-.34.53,1.15,1.15,0,0,0,.26.61.71.71,0,0,1,.09.24,12.11,12.11,0,0,0,.31,1.71,2.1,2.1,0,0,0,.37.63l.19.18.11.08a1.74,1.74,0,0,0,.33.18l.06,0,.09,0,.09,0a1.34,1.34,0,0,0,.3,0h.29a2.07,2.07,0,0,0,2.07-1.3c.3-.65.23-1.56.79-1.56h.1c.42.11.37.94.63,1.55a2.32,2.32,0,0,0,.41.67l.09.1.05.05.06.05.05,0,.05,0,0,0,0,0a1.81,1.81,0,0,0,.49.21h0a2.25,2.25,0,0,0,.6.07,1.71,1.71,0,0,0,1.72-1.21,12,12,0,0,0,.3-1.71.56.56,0,0,1,.1-.22,1.2,1.2,0,0,0,.24-.62A.56.56,0,0,0,411.92,265.61Zm-5.8,2.4a2,2,0,0,1-.43.91h0a1.68,1.68,0,0,1-1.35.53,1.45,1.45,0,0,1-1.28-.67l0-.07,0-.06,0-.06,0-.06v0l0,0,0-.06h0a.76.76,0,0,1-.06-.2h0a.52.52,0,0,1,0-.11,1.62,1.62,0,0,1,0-.19v-.07c-.08-.45-.17-1.33,0-1.53a2.3,2.3,0,0,1,1.67-.31h.1l.41.08.15,0a3.09,3.09,0,0,1,.4.14l.13.05.13.07,0,0,0,0a.71.71,0,0,1,.27.23A2.14,2.14,0,0,1,406.12,268Zm5.3-.2a1.9,1.9,0,0,1-.83,1.46,1.62,1.62,0,0,1-2-.52h0l0,0,0-.05v0a.43.43,0,0,0,0-.07l0-.09,0,0v-.08c0-.13-.07-.24-.09-.34a2.27,2.27,0,0,1,0-1.36,2.32,2.32,0,0,1,1.47-.66l.41,0h.48l.21,0H411l.06,0,.1.05h0a.83.83,0,0,1,.22.15C411.59,266.48,411.5,267.36,411.42,267.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.6,268.13l.3,3,2.23-.84c-.07-.13-.16-.27-.23-.42l-.14-.27-.18-.36c-.21-.37-.41-.74-.6-1.06-.06-.11-.15-.25-.24-.39s-.38-.58-.52-.76C406.8,267.07,406.74,267.6,406.6,268.13Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.91,272.26a.43.43,0,1,1-.41-.45A.43.43,0,0,1,405.91,272.26Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.24,276.12c-2.17-.36-4.34-1-5.3-2.76a13.78,13.78,0,0,1-1-2.78,10.84,10.84,0,0,0,.55,3.39c.43,1.09,2.29,2.43,5.71,3.14Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.58,267.71A.62.62,0,1,1,405,267,.62.62,0,0,1,405.58,267.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.51,264.6l-1.42.55a.78.78,0,0,1,.45-1A.73.73,0,0,1,405.51,264.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.24,265.17l-1.37-.69a.74.74,0,0,1,1-.36A.8.8,0,0,1,410.24,265.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.12,267.74a.62.62,0,0,1-.71.54.63.63,0,0,1-.52-.74.64.64,0,0,1,.72-.54A.64.64,0,0,1,410.12,267.74Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.76,311.14v.3a1.23,1.23,0,0,1-.6,1.06L411.82,325a1.22,1.22,0,0,1-.61.17,1.27,1.27,0,0,1-.62-.16l-11.7-6.66a1.22,1.22,0,0,1-.61-1.05v-.42h0a.14.14,0,0,0,.08.13l12.85,7.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.2,324.32v.82a1.22,1.22,0,0,0,.61-.17l21.34-12.47a1.19,1.19,0,0,0,.6-1.06v-.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.38,317a.13.13,0,0,1-.06-.1.11.11,0,0,1,.06-.1l21.95-12.82a.59.59,0,0,1,.36-.09.72.72,0,0,1,.32.08l12.66,7.22L411.2,324.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.69,303.88a.65.65,0,0,1,.3.09l12.58,7.17L411.2,324.21l-12.79-7.3a.09.09,0,0,1,0-.06,0,0,0,0,1,0-.05l22-12.83a.69.69,0,0,1,.34-.09m0-.09a.64.64,0,0,0-.38.1l-21.95,12.82a.16.16,0,0,0,0,.28l12.84,7.33,22.56-13.18L421,303.88a.67.67,0,0,0-.34-.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.08 323.25 404.22 319.33 424.17 307.68 431.07 311.57 411.08 323.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.07 311.57 430.81 311.72 424.17 307.98 404.48 319.48 404.22 319.33 424.17 307.68 431.07 311.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.07 311.57 430.81 311.72 424.17 307.98 404.48 319.48 404.22 319.33 424.17 307.68 431.07 311.57",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.66 312.28 407.79 312.36 411.15 314.27 417.1 310.8 417.23 310.73 413.73 308.74 407.66 312.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.66 312.28 407.79 312.36 411.15 314.27 417.1 310.8 417.23 310.73 413.73 308.74 407.66 312.28",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.79 312.36 411.15 314.27 417.1 310.8 413.73 308.88 407.79 312.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.61,299.5c1.32-5.21,2-9.9,3.33-13.83.76-2.33,1-5.54,5.61-7,2.88,2.22,2.41,8.36,1.93,9.88l-3.05,11.94s.83,1,3.57,3.72c2.34,2.29,3.47,3.13,6.15,3.55s2.92.25,4.3.91c.73.36,2.4,1.18,3,1.49s1.57,1.41,2.51,2.15-.27,1.12-1,.89a9.33,9.33,0,0,1-2.08-1.11,10.81,10.81,0,0,0-1.79-.76,11,11,0,0,1,.31,2.13c0,.38,0,.86-.3,1.13a2.88,2.88,0,0,1-.82.3.59.59,0,0,1-.17.37,1,1,0,0,1-.7.15,3.82,3.82,0,0,1-.39-.08.71.71,0,0,1-.45.55,3.15,3.15,0,0,1-1.66,0l-.85-.49c-.26-.15-.49-.23-.59-.41s.26-.65.58-.69a3,3,0,0,1,1.05.11,3.5,3.5,0,0,1-.27-.92c-.27-.47-2.35-.08-4.18-.47-1.37-.29-2.36-1.59-2.93-2a78,78,0,0,1-8.18-5.61C383,302.73,382.91,302.29,383.61,299.5Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.57,310.12a4.6,4.6,0,0,1,.53,1.19l.36.13C406.26,310.91,406,310.28,405.57,310.12Zm-1.22.42a1.64,1.64,0,0,1,.3.47,3.24,3.24,0,0,1,.19.52,6.49,6.49,0,0,1,.21,1.1c.06.37.1.74.15,1.11a8.6,8.6,0,0,1,.09,1.13,4.35,4.35,0,0,0,.08-1.14,11,11,0,0,0-.1-1.14,4.86,4.86,0,0,0-.27-1.11A2,2,0,0,0,404.35,310.54Zm-.66,1.45a2.1,2.1,0,0,0-.54-1,1.47,1.47,0,0,1,.23.49,3.46,3.46,0,0,1,.14.53c.08.36.15.72.21,1.09.13.72.24,1.45.3,2.19a5.23,5.23,0,0,0,.05-1.12,10.49,10.49,0,0,0-.13-1.11A7.87,7.87,0,0,0,403.69,312Zm-2.63,2.27a2.1,2.1,0,0,1,.46.08,3.76,3.76,0,0,1,.37.16.44.44,0,0,0,.12.3.64.64,0,0,0,.3.22,1.81,1.81,0,0,1-.17-.29.83.83,0,0,1,0-.15.66.66,0,0,1,0-.13l0-.08-.09,0a1.23,1.23,0,0,0-.43-.11A.86.86,0,0,0,401.06,314.26Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64,278.22c-3,1.21-4.18,1.86-5.29,5.25-1.34,4.11-2.87,10.37-2.87,10.37a7.08,7.08,0,0,0,4,2.25c3,.76,4.33,0,4.33,0s1.5-5.22,2.08-7.39S395.88,280.1,392.64,278.22Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M411.55,324.5a1.45,1.45,0,0,0,1.25-.1L434,312a1.43,1.43,0,0,0,.7-1L437,297.05a1,1,0,0,0,0-.24,1.46,1.46,0,0,0-.43-1l-22.08,12.9a1.12,1.12,0,0,0-.52.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.2,324.32l.15.09.2.09L414,309.43a1.12,1.12,0,0,1,.52-.75l22.08-12.9a1.29,1.29,0,0,0-.3-.22l-22.12,12.92a1.06,1.06,0,0,0-.52.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.2,309l-.35-.2a1.12,1.12,0,0,0-.2.46l-2.45,15.09.15.09.2.09L414,309.43A1,1,0,0,1,414.2,309Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.49,311.6a4.7,4.7,0,0,1,2.13-2.78c1-.6,1.73-.33,1.58.61a4.68,4.68,0,0,1-2.13,2.77C424,312.8,423.33,312.53,423.49,311.6Z",
    style: {
      fill: "#10E2ED"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.91,438l-3.24-5.75L375.81,436l7.79,8.41s3.66-.5,4.17-2.44S386,438.55,384.91,438Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.25,440.08a3.13,3.13,0,0,1,.87.87c.26.35.26,2.09.53,2.89a20,20,0,0,0,.88,2,5.88,5.88,0,0,1,.55,5,8.09,8.09,0,0,1-3.32,5.12,3.17,3.17,0,0,1-1.44.42s-1.61-.53-1.41-1.48S389.25,440.08,389.25,440.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.44,443.55c.05.3.49.73.67,1a8,8,0,0,1,1.15,2.84c1.14,4.52-.58,6.92,2,8.53.73.41,2.2.22,4.32-2.75,1.08-1.52,1.6-4.57,1.09-5.92s-1.16-2.22-1.49-3.26-.27-3-.89-3.88a4.32,4.32,0,0,0-1.48-1.17c-.45-.24-1.42-.55-1.87-.78s-.72-.51-1-.18l.54.62c.85,1.07.64,1.24.64,1.83a9.4,9.4,0,0,0,.38,1.87c-.6-.69-.86-1.31-1.48-1.17s-.69.11-1.54,1S382.38,443.29,382.44,443.55Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.44,443.55c.05.3.49.73.67,1a8,8,0,0,1,1.15,2.84c1.14,4.52-.58,6.92,2,8.53.73.41,2.2.22,4.32-2.75,1.08-1.52,1.6-4.57,1.09-5.92s-1.16-2.22-1.49-3.26-.27-3-.89-3.88a4.32,4.32,0,0,0-1.48-1.17c-.45-.24-1.42-.55-1.87-.78s-.72-.51-1-.18l.54.62c.85,1.07.64,1.24.64,1.83a9.4,9.4,0,0,0,.38,1.87c-.6-.69-.86-1.31-1.48-1.17s-.69.11-1.54,1S382.38,443.29,382.44,443.55Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.54,453.14c1.08-1.52,1.6-4.57,1.09-5.92a11.44,11.44,0,0,0-.58-1.3c0,.09.05.18.07.26l.09.53a4,4,0,0,1-.14,2.08c-.23.58-.76,2-1.53,2.1-.43,0-.82-.37-1-.85-.08-.2-.22-.75-.22-.75a6.7,6.7,0,0,0-2,.9c-1.08.79-1,.95-1,.95a3.07,3.07,0,0,1,.07,1,2.26,2.26,0,0,1-.37,1,2,2,0,0,1-.27.24,3,3,0,0,0,1.47,2.54C387,456.3,388.42,456.11,390.54,453.14Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.26,447.36a15.76,15.76,0,0,1,.45,3.63c.47,1.15.83,1.1.86.5a36,36,0,0,0-1.59-5.14C384.09,446.69,384.18,447,384.26,447.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72,439.92a2.64,2.64,0,0,0-.52-1.66,2.23,2.23,0,0,1-.3-.13c-.5-.25-.72-.51-1-.18l.54.62c.85,1.07.64,1.24.64,1.83a9.4,9.4,0,0,0,.38,1.87,33.72,33.72,0,0,1,1.31,4.47c.3,1.86,0,3.13.25,3.23s.8-.14.83-1.65a15.52,15.52,0,0,0-1.27-5.17A8,8,0,0,1,386.72,439.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.45,449.41l-.09.06a4.5,4.5,0,0,0-2.92,1.88.19.19,0,0,1-.26,0,.2.2,0,0,1,0-.27,4.82,4.82,0,0,1,3.12-2,.18.18,0,0,1,.23.13A.17.17,0,0,1,388.45,449.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.14,447.86a.15.15,0,0,1-.09.06A5,5,0,0,0,385,450a.18.18,0,0,1-.27,0,.2.2,0,0,1,0-.27,5.42,5.42,0,0,1,3.27-2.18.19.19,0,0,1,.19.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1,446.14a.21.21,0,0,1-.1.06,5.76,5.76,0,0,0-3.43,2.31.21.21,0,0,1-.3,0,.21.21,0,0,1,0-.29,6.05,6.05,0,0,1,3.65-2.45.2.2,0,0,1,.26.14A.21.21,0,0,1,388.1,446.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.79,444.68a.21.21,0,0,1-.1.06,5.57,5.57,0,0,0-3.36,2.26.21.21,0,0,1-.29,0,.21.21,0,0,1,0-.29,6,6,0,0,1,3.57-2.4.21.21,0,0,1,.25.15A.21.21,0,0,1,387.79,444.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.18,443.28a.2.2,0,0,1-.09.06,5.51,5.51,0,0,0-3.36,2.25.2.2,0,0,1-.29,0,.21.21,0,0,1,0-.29,5.94,5.94,0,0,1,3.57-2.39.2.2,0,0,1,.25.14A.21.21,0,0,1,387.18,443.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.31 438.5 379.56 441.85 377.42 443.32 380.14 447.96 387.07 444.26 383.31 438.5",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.25,416.09s-15.21-.91-21.27-.6-6.31,4.84-4.88,7.75c3.65,7.43,14,16.41,14,16.41s3.39-1.74,4.33-4.78l-2.59-5.28,7.6,2.06.82-1.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.41,425.05a51.87,51.87,0,0,1,3.35,5.06l-1.91-.52c-2.35-5-2.86-6.44-6.36-8.67A11.32,11.32,0,0,1,379.41,425.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.25,416.09,412.31,420s2.53,8.09.88,13-6.45,6.67-8.78,7a25.36,25.36,0,0,1-7.24-.45,18.53,18.53,0,0,1-3.78,2.45c-1.91.86-10.29,4.81-10.29,4.81a7.75,7.75,0,0,1-2.44-6.16l8.61-10Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1,446.72s-.48-.19-1.19-1.42c2.18-.62,9.33-3.78,11.63-4.88,4.1-2,5.31-3.88,5.31-3.88s.08,1.24-1.68,2.92a18.53,18.53,0,0,1-3.78,2.45C391.48,442.77,383.1,446.72,383.1,446.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.6,438.46c2.1.24,7.68-1,9.33-5.08s.82-8.56.24-12.53l.68.13,1.9.14c.24,2.31.71,8.06-.56,11.84-1.65,4.92-6.45,6.67-8.78,7a25.36,25.36,0,0,1-7.24-.45l1-1.77A13.76,13.76,0,0,0,401.6,438.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.35,431.63s.37-.49,1.15-1.49a6.18,6.18,0,0,1,5.47-2.92c3.43,0,10,.28,10,.28l-9.32-1.16c-2.39-.29-4,.06-5.26,1.32s-3.29,3.63-3.29,3.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.75,427a6.83,6.83,0,0,1-1.82-4.68s-.68,3.16.73,5.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61,446.19a7.38,7.38,0,0,0-3.36,2.48,2.6,2.6,0,0,0-.13,3.25c.78,1.19,2.19,2.56,3.78,2.4a8.73,8.73,0,0,0,4-1.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,447c0,.49-2,1.58-4.15,2.72-2.3,1.22-2.84,2-4.71,3-2.14,1.17-3,1.27-4.68.87s-3.92-2.73-2.56-5c1.11-1.88,2.62-2.44,4.93-3.16a43,43,0,0,0,5.39-2c1.66-.73,3-2,3.36-1.57-.24.13-1.95,1.29-1.61,1.57.09.15.34.09.77-.1a.7.7,0,0,1,.6-.06,1.18,1.18,0,0,1,.46.5c.29.5.34.8.59,1.32.14.3.08.13.22.43a3.4,3.4,0,0,1,.41,1.18c0,.19-.15.26-.29.36s-.35.23-.49.34-.14.19-.11.26.36.05.49,0,.33-.12.48-.19S381.6,447.21,382,447Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,447c0,.49-2,1.58-4.15,2.72-2.3,1.22-2.84,2-4.71,3-2.14,1.17-3,1.27-4.68.87s-3.92-2.73-2.56-5c1.11-1.88,2.62-2.44,4.93-3.16a43,43,0,0,0,5.39-2c1.66-.73,3-2,3.36-1.57-.24.13-1.95,1.29-1.61,1.57.09.15.34.09.77-.1a.7.7,0,0,1,.6-.06,1.18,1.18,0,0,1,.46.5c.29.5.34.8.59,1.32.14.3.08.13.22.43a3.4,3.4,0,0,1,.41,1.18c0,.19-.15.26-.29.36s-.35.23-.49.34-.14.19-.11.26.36.05.49,0,.33-.12.48-.19S381.6,447.21,382,447Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.85,452.34c-.3.18-2.25,1.19-2.9.66s.85-1.59.85-1.59.18-1.51-1.72-3.63c-.3.25-1.61.3-1.63-.47s2.13-1.8,2.16-1.82c-2.21.7-3.65,1.28-4.73,3.1-1.36,2.29.84,4.63,2.56,5s2.54.3,4.68-.87C373.33,452.62,373.67,452.47,373.85,452.34Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,451.27c-.81.31-.21,1,1,.74,1.8-.45,3.26-1.54,5.26-2.27,2.14-1.14,4.32-2.21,4.15-2.75-.38.16-1.2.55-1.2.55l-.58.25a41,41,0,0,1-5.18,2.58C373.46,450.87,372.4,451,371.58,451.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.21,448.06a14.09,14.09,0,0,1,2.31-1.6c1.44-.74,3.9-2.32,5.41-3.29.47-.29,1.61-1.31,1.63-1.32-.27-.28-1.2,0-2.12.67s-1.48,1-2.4,1.57c-1.78,1.18-3.82,2-4.83,2.72S369.47,448.53,370.21,448.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.09,447.86l.05.07a6.64,6.64,0,0,1,1.57,3.6.22.22,0,0,0,.22.19.17.17,0,0,0,.16-.21,6.87,6.87,0,0,0-1.72-3.88.17.17,0,0,0-.26,0A.21.21,0,0,0,370.09,447.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.51,446.72a.15.15,0,0,0,0,.06A9,9,0,0,1,373.5,451a.21.21,0,0,0,.22.19.18.18,0,0,0,.15-.22,9.3,9.3,0,0,0-2.07-4.5.18.18,0,0,0-.27,0A.21.21,0,0,0,371.51,446.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.93,450.81a.21.21,0,0,0,.18.13.18.18,0,0,0,.18-.21,10.93,10.93,0,0,0-2.11-5.14.18.18,0,0,0-.27,0,.23.23,0,0,0,0,.29,10.79,10.79,0,0,1,2,4.85A.19.19,0,0,0,374.93,450.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.25,449.89a.21.21,0,0,0,.18.12.19.19,0,0,0,.18-.2,7.76,7.76,0,0,0-2.2-4.87.16.16,0,0,0-.26,0,.23.23,0,0,0,0,.29,7.53,7.53,0,0,1,2,4.55A.29.29,0,0,0,376.25,449.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,449.07a.19.19,0,0,0,.17.12.17.17,0,0,0,.18-.2,8.13,8.13,0,0,0-2.25-4.89.18.18,0,0,0-.27,0,.23.23,0,0,0,0,.3A7.86,7.86,0,0,1,378,449,.3.3,0,0,0,378,449.07Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.29,393.94c-1.5,1.13-9.12,8.38-9.12,8.38-.81-2.18-2.42-6.53-2.73-7.46-.52-1.35-1.29-3.72-1.42-4a13.2,13.2,0,0,0-4.57-5c-.31-.23-.62-.46-.94-.68a4.83,4.83,0,0,1-.45-.34c-.13-.12-.24-.21-.43-.1a.6.6,0,0,0-.26.38,1.87,1.87,0,0,0,.29,1.5,8.84,8.84,0,0,0,1,1.2c.27.3-.18.34-.4.33a8.14,8.14,0,0,1-3.34-1.63,14.38,14.38,0,0,0-1.7-1.19,2.06,2.06,0,0,0-1.24-.22c-.29,0-.54.18-.45.54a1.47,1.47,0,0,0,.39.55,1.56,1.56,0,0,1,.55,1.16,3.24,3.24,0,0,0,0,.93,11.57,11.57,0,0,0,.49,1.08,8.8,8.8,0,0,1,.09,1,3,3,0,0,0,.68,1,9.53,9.53,0,0,0,1.85,1.68,10.54,10.54,0,0,0,2.49,1.4c.64.28,1.67.23,2.14,1.29s.56,2.19,1.11,6.32c.4,3.06.68,5.62,3.37,9.24,1.07,1.44,2.9,1.05,4.7-.38l9.49-7.6a14.66,14.66,0,0,0,3.51-10.6S395.26,392.47,393.29,393.94Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.17,402.32c.79,1.89,1.26,4.58.55,6.27,1.52-2.15,1-5.12.22-7Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.43,392.54a7.73,7.73,0,0,0-4.66,1,11.9,11.9,0,0,0-2,1.72s-1.43,7.31,2,9.2l3.61-2.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.43,390.54a1.21,1.21,0,0,1,.73-.13,3.84,3.84,0,0,1,.68.09,3.53,3.53,0,0,1,1.27.55,2.56,2.56,0,0,1,.88,1,2,2,0,0,1,.22.57,2.07,2.07,0,0,1-.08.7s-.07.08-.09,0a1.53,1.53,0,0,0-.11-.27l-.13-.31a3.27,3.27,0,0,0-.24-.5,2.72,2.72,0,0,0-.82-.87,3.66,3.66,0,0,0-1.2-.51,5.21,5.21,0,0,0-.57-.09l-.4-.05c-.07,0-.13,0-.16-.08A.08.08,0,0,1,374.43,390.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415,407.53c-.51-7.56-.94-9-2.3-11.09-1.67-.72-4.54-1.87-6.36-2.49a38.9,38.9,0,0,0-7.88-1.41c-1.62,1.55-5.65,5.19-7,8.34-.92,2.1-1.15,5.36.75,7.24a56,56,0,0,1-1.44,7.86s.9,5.06,7.52,6.85c7.1,1.92,15.8.76,15.8.76A79.61,79.61,0,0,0,415,407.53Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,407.53c-.51-7.56-.94-9-2.3-11.09-1.67-.72-4.54-1.87-6.36-2.49a38.9,38.9,0,0,0-7.88-1.41c-1.62,1.55-5.65,5.19-7,8.34-.92,2.1-1.15,5.36.75,7.24a56,56,0,0,1-1.44,7.86s.9,5.06,7.52,6.85c7.1,1.92,15.8.76,15.8.76A79.61,79.61,0,0,0,415,407.53Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.19,409.72a6.43,6.43,0,0,0,5.56,2.14,5.16,5.16,0,0,0,4.77-3.44,4.65,4.65,0,0,1-4.65,4.53A5.59,5.59,0,0,1,397.19,409.72Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.33,428.9v.42a1.17,1.17,0,0,1-.59,1l-11.24,6.47a1.22,1.22,0,0,1-1.17,0L367.71,424.9a1.17,1.17,0,0,1-.59-1v-.29l21.79,12.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.12,423.59l12.22-7a.7.7,0,0,1,.71,0l21.21,12.24a.16.16,0,0,1,0,.27l-12.35,7.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.03 435.14 395.62 431.34 376.34 420.21 369.71 423.99 389.03 435.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.27 424.56 392.15 424.63 388.92 426.5 383.17 423.18 383.05 423.11 386.4 421.18 392.27 424.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.15 424.63 388.92 426.5 383.17 423.18 386.4 421.31 392.15 424.63",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,436.18V437a1.19,1.19,0,0,1-.58-.15L367.71,424.9a1.17,1.17,0,0,1-.59-1v-.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.91,436.18V437a1.19,1.19,0,0,1-.58-.15L367.71,424.9a1.17,1.17,0,0,1-.59-1v-.29Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.58,436.35a1.41,1.41,0,0,1-1.2-.09l-20.53-11.85a1.41,1.41,0,0,1-.68-1L363.92,410a1.77,1.77,0,0,1,0-.23,1.37,1.37,0,0,1,.41-1l21.33,12.32a1,1,0,0,1,.5.72Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.58,436.35a1.41,1.41,0,0,1-1.2-.09l-20.53-11.85a1.41,1.41,0,0,1-.68-1L363.92,410a1.77,1.77,0,0,1,0-.23,1.37,1.37,0,0,1,.41-1l21.33,12.32a1,1,0,0,1,.5.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,436.18l-.14.08a.66.66,0,0,1-.19.09l-2.43-14.5a1,1,0,0,0-.5-.72l-21.33-12.32a1.51,1.51,0,0,1,.28-.22L386,420.93a1,1,0,0,1,.5.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,424a4.52,4.52,0,0,0-2.07-2.66c-1-.57-1.67-.31-1.52.59a4.51,4.51,0,0,0,2.07,2.66C376.49,425.14,377.17,424.88,377,424Z",
    style: {
      fill: "#10E2ED"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.31,415.19a119.51,119.51,0,0,0-2-13.36c-.45-2.29-1.52-4-4.65-5.1-3.09,1.85-2.64,7.9-2.35,9.46l1.44,8.72s-2.59,1.73-5.47,3.39-4.92,2.45-7.6,2.55-3.22.06-4.65.55c-.77.26-2.51.87-3.11,1.12s-1.71,1.2-2.72,1.82.13,1.13.84,1a9.1,9.1,0,0,0,2.18-.84,11,11,0,0,1,1.84-.54,11.17,11.17,0,0,0-.55,2.06c0,.38-.15.84.16,1.14a2.82,2.82,0,0,0,.77.4.61.61,0,0,0,.13.38,1,1,0,0,0,.67.23,2.09,2.09,0,0,0,.39,0,.69.69,0,0,0,.39.59,3.1,3.1,0,0,0,1.62.19l.9-.38c.27-.12.51-.17.63-.33s-.18-.68-.49-.75a3.06,3.06,0,0,0-1,0,3.74,3.74,0,0,0,.37-.87c.32-.43,2.33.2,4.17,0,1.38-.13,2.48-1.35,3.12-1.57,4.08-1.46,7.84-2.08,12-4.16C420.11,419,419.58,418,419.31,415.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.68,424c.25-.5.63-1.09,1-1.2a4.88,4.88,0,0,0-.67,1.11Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.42,427.54a4.74,4.74,0,0,1,.06-1.13,8.44,8.44,0,0,1,.24-1.11,4.75,4.75,0,0,1,.39-1.07,2,2,0,0,1,.75-.84,1.47,1.47,0,0,0-.35.43,3.75,3.75,0,0,0-.25.49,7.13,7.13,0,0,0-.33,1.05c-.11.36-.19.72-.29,1.08S393.47,427.17,393.42,427.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.61,428.12a5.06,5.06,0,0,1,.09-1.1,10.12,10.12,0,0,1,.25-1.09,8.18,8.18,0,0,1,.39-1,2.18,2.18,0,0,1,.65-.9,1.38,1.38,0,0,0-.29.46,4.34,4.34,0,0,0-.2.5c-.12.35-.24.7-.34,1.05C395,426.7,394.76,427.4,394.61,428.12Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.66,427.44a1.72,1.72,0,0,0-.46,0c-.15,0-.26.09-.45.14l.08-.12a.51.51,0,0,1-.05.22.48.48,0,0,1-.12.16.61.61,0,0,1-.32.18,2.47,2.47,0,0,0,.21-.27.78.78,0,0,0,.05-.14.32.32,0,0,0,0-.13v-.08l.09,0a1.31,1.31,0,0,1,.43-.06A1,1,0,0,1,397.66,427.44Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.35,385l.28-1.24a4.73,4.73,0,0,1-1.09-6c1.92-3.46,6-3.89,8.67-3.37,3.76.71,5.94,2.4,6,4.9.64.05,1.64,1.06,1.91,1.91,1.55,4.89-4.12,7.82-5.87,11.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.82,373.13l.09,0a1.67,1.67,0,0,1,1.32,1.5,1.78,1.78,0,0,1,1.92,2.7.27.27,0,0,0-.06.17c0,.08.07.12.13.16a1,1,0,0,0,1.31-.33.94.94,0,0,1-.27,1.06,1.83,1.83,0,0,1-1.08.42,1.31,1.31,0,0,1,.63,1.41,1.82,1.82,0,0,1-1,1.24.92.92,0,0,0-.45-1.11,1.28,1.28,0,0,1-.41,1.47,1.31,1.31,0,0,1-1.52,0c.12.47-.35.88-.8,1.06a2,2,0,0,1-1,.15,1.11,1.11,0,0,1-.84-.58,1.13,1.13,0,0,1-.64.16c-.33,0-.81-1-.81-1a3.16,3.16,0,0,1-2.35-.38,2,2,0,0,1-.66-1.31,6.29,6.29,0,0,1,0-1.5,1.37,1.37,0,0,1-1.13-1.7,1.72,1.72,0,0,1,1.82-1.15,1.42,1.42,0,0,1,.58-1.76,3.21,3.21,0,0,1,2-.36c.44,0,1,.16,1.12.58A2.11,2.11,0,0,1,413.82,373.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.54,390a2.28,2.28,0,0,0,2.17-1.15c1-1.39,1-2.37.52-3.24a1.77,1.77,0,0,0-2.26-.75c-.82.49-.86.9-1.18,1.46s-1,.73-1.21-1.59c-.2-2.16.05-4.4-1-5.41-1.53-1.5-3.6-1.16-4.26-.32a1.93,1.93,0,0,0-2.71-.81,4.06,4.06,0,0,0-2.1,2.32,3.58,3.58,0,0,0-.06,1.26,4.16,4.16,0,0,1-.26,1.81c-.64,1.74-.83,5.2.44,7,.7,1,1.94,1.38,3.5,1.49l-.2,2.12a7.94,7.94,0,0,0-2,5.39,13.91,13.91,0,0,0,5.79-1.51,6.52,6.52,0,0,0,3.23-2.92l.52-6S408.5,389.89,409.54,390Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.08,381.88l1.6-.4a.79.79,0,0,0-1-.61A.87.87,0,0,0,398.08,381.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.28,383.23a.65.65,0,0,0,.59.72.66.66,0,1,0,.13-1.31A.65.65,0,0,0,398.28,383.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.69,383.8a.66.66,0,1,0,1.32.12.67.67,0,0,0-.6-.72A.67.67,0,0,0,402.69,383.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.57,382l1.56.82a.85.85,0,0,0-.34-1.18A.92.92,0,0,0,403.57,382Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.21,379.6c.34.49.58,1,.4,2.65a8.41,8.41,0,0,0,.27,3.33,2.25,2.25,0,0,0,1.64,1.64,3.26,3.26,0,0,0,1.64-.06,1.86,1.86,0,0,0,1.23-1.63,2,2,0,0,1-.69.42,2.11,2.11,0,0,1-.61.1,1.83,1.83,0,0,1-1.48-1,8.1,8.1,0,0,1-.54-3.21c-.14-1.33-.27-2.83-1.41-3.57-1.35-.87-3.9-.7-4.31.71A2.79,2.79,0,0,1,406.21,379.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.6,387.35l-2.32.54a1.19,1.19,0,0,0,1.54.86A1.13,1.13,0,0,0,402.6,387.35Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.16,388.76a1.27,1.27,0,0,1,1.35-1l.11,0a1.06,1.06,0,0,1-.8,1A1.34,1.34,0,0,1,401.16,388.76Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.45 382.46 400.46 386.58 398.45 385.34 401.45 382.46",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.16,392.14a8.35,8.35,0,0,0,4.41-1,6.26,6.26,0,0,0,2.27-2.33,5,5,0,0,1-1.87,3.05,8.27,8.27,0,0,1-4.89,1.08Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412.67,396.46c2.76,1,4,1.6,4.77,5.86-5.63.87-7,4.87-7,4.87s-.24-1.17-.56-3S410,397.79,412.67,396.46Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters-3--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-168"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "173.29 170.53 174.6 169.82 173.27 169.5 173.29 170.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.64,172.52s-16-6.58-16.19-5.5a1.51,1.51,0,0,0,0,.64l0-.06.37,2a4.69,4.69,0,0,0,2.49.94l0-1a8.26,8.26,0,0,1,1.42.69c1,.64,1.73,1.79,2.85,3.12.82,1,2.23,1.38,4.31,1.6,2.23.24,4.18-.26,4.71-.89A1.58,1.58,0,0,0,186.64,172.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.19,172.17a18,18,0,0,0-1.53-1.41,28.82,28.82,0,0,0-2.35-1.87,9,9,0,0,1-1.16-.9,11.52,11.52,0,0,1-.82-.89,16.81,16.81,0,0,1-1.83-2.82,4.53,4.53,0,0,1-.57-2.42,55.83,55.83,0,0,1,.43-7.08l-7.6.12c.26,1.2.41,3.25.58,4.62a7.6,7.6,0,0,1-.41,4.66,6.05,6.05,0,0,0-.55,1.88,3,3,0,0,0,1.81,2.45c.79.4,1.68.56,2.45,1a7.7,7.7,0,0,1,2,1.87,8.09,8.09,0,0,0,1.78,1.91,6.91,6.91,0,0,0,2.6.8,13.89,13.89,0,0,0,3.46,0C186.14,173.93,187.34,173.29,186.19,172.17Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.25,171c-.71-.55-1.7-1.33-2.9-2.22a3,3,0,0,0-2.44.32,5.12,5.12,0,0,0-2.63,3.09,3.41,3.41,0,0,0,2,1.62c2.75,1.09,7.58.53,7.58-.73C186.84,172.31,186.1,171.7,185.25,171Zm-14.18-7.31s-.15.42-.53,1.24a2.3,2.3,0,0,0,.11,2.42,3.58,3.58,0,0,0,2.44,1.53A5,5,0,0,0,171.07,163.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.82,166.56c.44.72-.14,3.43,0,5.36.09,1.75.55,4.8,0,6.53-.64,2.05-1.94,4.43-4.35,2.51a6.81,6.81,0,0,1-2.55-5.25c-.14-1.75.56-4.18,1.16-6.33.7-2.51,1-3.85,1-3.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.87,153.64c-.17,4.09.3,7,.33,9.57a19.1,19.1,0,0,1-.37,3.54c-.35,1.67-.93,4-1.17,5.07a6.69,6.69,0,0,0-.08,4.16,1.84,1.84,0,0,0,.17.38c.73,1.4,2.58,2.46,3.18,2.29a1,1,0,0,0,1,.36l.2,0a1,1,0,0,0,.2-.08,2,2,0,0,0,1-1.28c0-.12.07-.24.1-.37a13.15,13.15,0,0,0,.08-4.29c-.05-.95,0-2.16.09-3.69a69.8,69.8,0,0,1,1-8.65c.4-1.6.89-3.62,1.41-5.77Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29,173.79c1.47-.65,5.71-.74,6.38,1.33,0,1.94,0,3.26-1.19,4.95-1.64,2.25-3.76-.13-4.58-1.65A7.76,7.76,0,0,1,152.29,173.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.4,100.28c-2.07,3.71-3.73,6.83-4.27,16.61-.61,11-.52,15.25-.57,16.58s-.91,3.78-1.64,10.34,0,22.48,0,22.48.51,1.07,3,1.31a6.35,6.35,0,0,0,3.68-.59s3.68-20.89,4.58-24.84,3.56-16.93,3.56-16.93l1.44,10.56a32.63,32.63,0,0,0-.07,9.38c.66,5.76,1.9,16.79,1.9,16.79a8.05,8.05,0,0,0,3.42,1.25,5.84,5.84,0,0,0,3.75-.81s2.24-22.85,2.29-29.38-.46-22.82-2.44-32.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,112.7l-2.16,12.54,1.44,10.56-.57-10.7,1.92-10.29c1.58-.36,5.18-2.22,6.18-4.91C174.33,112.42,170,112.7,170,112.7Zm-7.3-7.39c.28-1.06.58-2.1.92-3.16a15.83,15.83,0,0,0-1.44,3,29.68,29.68,0,0,0-1,3.17c-.25,1.07-.47,2.16-.62,3.25a21.37,21.37,0,0,0-.24,3.3c.27-1.07.52-2.14.77-3.2s.5-2.13.77-3.19S162.38,106.36,162.66,105.31Zm-1.58-.81c.36-.64.72-1.28,1-2a11.86,11.86,0,0,0-1.5,1.67,15.46,15.46,0,0,0-1.23,1.87,15.19,15.19,0,0,0-.94,2,9.08,9.08,0,0,0-.52,2.19l1-2c.35-.65.69-1.29,1-1.93S160.72,105.15,161.08,104.5Zm-1.62,41.91c-.63,3.4-1.23,6.8-1.77,10.21q1.22-5,2.31-10.1c.73-3.38,1.42-6.75,2.11-10.15s1.09-6.84,1.45-10.27.64-6.88.88-10.33c-.51,3.42-1,6.84-1.41,10.26s-.95,6.84-1.6,10.21S160.09,143,159.46,146.41Zm18-17c.06,1.5.14,3,.1,4.48s-.14,3-.23,4.49l-.26,4.51q-.27,4.5-.42,9,.56-4.49,1-9c.27-3,.52-6,.65-9s-.23-6-.48-9-.59-6-1-9l.5,9C177.3,126.37,177.38,127.87,177.44,129.37Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207,80.86c.05-.33-.07-.86-.53-.8a.74.74,0,0,0-.29.12c-1,.58-1.81,1.28-2.75,1.87a4.59,4.59,0,0,1-1.42.74c-.69.11,0-.76.18-1a5.55,5.55,0,0,0,.4-.72,2.62,2.62,0,0,0,.11-1.36.43.43,0,0,0,0-.16.3.3,0,0,0-.34-.08.81.81,0,0,0-.3.22c-.43.44-.84.89-1.3,1.29s-1.05.8-1.55,1.24c-.72.64-1.32,1.4-2,2a8.44,8.44,0,0,1-2.54,1.37c-2.42,1.05-6.89,2.24-9.7,3.07,0,0-5.29-5.33-7.07-6.94a11.07,11.07,0,0,0-4.25-2.16l-.5,8.71s5.75,4.47,8.05,6.42A4.81,4.81,0,0,0,185,96.2a15.56,15.56,0,0,0,4.38-1.82c2.62-1.32,6-3.41,8-4.63,1.22-.75,2.61-.78,4-1.14a8.85,8.85,0,0,0,3.58-2,5.59,5.59,0,0,0,1-1.19,2.45,2.45,0,0,0,.41-1.33.83.83,0,0,1,.32-.81,1.47,1.47,0,0,0,.38-1A8.88,8.88,0,0,1,207,80.86Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.05,105.2c-.75-.94.75-3.42.49-6.51-.13-1.59-.89-6.19-.89-6.19s3.1-4.43,2.19-12l4.57-1.37,6.76-.3,3.37.75a26.33,26.33,0,0,1,3.9,4.53c2,3,2.29,6.15.14,8.49,0,.46.27,7.56.85,9.29s.43,2.73-.43,3.45C174.78,109,164.78,110.06,157.05,105.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.13,79.36l3.17.7A25.72,25.72,0,0,1,177,84.41c2,3,2.06,5.82.18,7.87a.54.54,0,0,0-.13.3c0,.44.25,7.61.88,9.49s.17,2.52-.28,2.9l-.06.06c-1.6,1.82-5.06,3-9,3a21.48,21.48,0,0,1-11.2-3.15,4.33,4.33,0,0,1,.19-2,13.58,13.58,0,0,0,.44-4.19c-.11-1.42-.72-5.13-.87-6,.57-.89,2.9-5.07,2.21-11.73l4.11-1.23,6.64-.29m0-.51-6.76.3-4.57,1.37c.91,7.55-2.19,12-2.19,12s.76,4.6.89,6.19c.26,3.09-1.24,5.57-.49,6.51a22,22,0,0,0,11.56,3.28c4.13,0,7.69-1.2,9.39-3.12.86-.72,1-1.84.43-3.45s-.88-8.83-.85-9.29c2.15-2.34,1.85-5.54-.14-8.49a26.33,26.33,0,0,0-3.9-4.53l-3.37-.75Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.35,63.71a3.71,3.71,0,0,0-1.15,2.71,14.35,14.35,0,0,0,2.26,6.63,13.07,13.07,0,0,0,2.64,3.61c1.18,1,3,1.16,4.47,1.23.44,0,.88.14,1.18-.19a3.3,3.3,0,0,0,.52-1.18,15.2,15.2,0,0,1,1.19-2.67,6.67,6.67,0,0,1,1.1-1.71,1.75,1.75,0,0,1,.52-.28,6.22,6.22,0,0,0,2.44-1,2,2,0,0,0,.42-2.22,2.07,2.07,0,0,0,2.51-.08,1.13,1.13,0,0,1-1.12-.82c-.18-.74.42-1.42.7-2.13a2.67,2.67,0,0,0,0-2,2.72,2.72,0,0,0-1.47-1.42c-.65-.25-1.35-.12-2-.35s-1.06-1-1.55-1.54a4.72,4.72,0,0,0-1.91-1.37,3.41,3.41,0,0,0-2.88.21,5.73,5.73,0,0,1-.62.38,5.15,5.15,0,0,1-2.41.06,3.46,3.46,0,0,0-2.73,1.1,4.13,4.13,0,0,0-.86,1.8,1.24,1.24,0,0,1-.22.54,1.34,1.34,0,0,1-.31.22A3.51,3.51,0,0,0,160.35,63.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.55,74.32a2.23,2.23,0,0,1-2-.77c-1.06-1.17-1.16-2.35-.67-3.15a1.64,1.64,0,0,1,2.11-.62A2.52,2.52,0,0,1,163,71.16c.29.55,1,.12.77-2,1.46-.69,1.22-3.13,2-4.13a3.27,3.27,0,0,1,3.93-.79A2.64,2.64,0,0,1,172.5,64c1,.53,1.64,1.63,2,5.43s-.32,6.45-1.21,7.27a4.41,4.41,0,0,1-3.12.87v1.45s3.93,4.1-1.08,3.73a7.85,7.85,0,0,1-5.68-3.21l0-5.87S163.29,74.18,162.55,74.32Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.78,73.63a1.12,1.12,0,0,1-2.2-.44Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.58,73.56a1.11,1.11,0,0,0,.88,1,1.08,1.08,0,0,0,.4,0A1.14,1.14,0,0,0,168.58,73.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.51,69.62a.64.64,0,1,1-1.22-.38.65.65,0,0,1,.8-.45A.67.67,0,0,1,168.51,69.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.54,68.1l-1.35-.72a.74.74,0,0,1,1-.33A.8.8,0,0,1,173.54,68.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,69.65a.66.66,0,0,0,.83.4.65.65,0,0,0,.37-.84.66.66,0,0,0-.83-.41A.67.67,0,0,0,172,69.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,67l-1.43.78a.78.78,0,0,1,.29-1.1A.87.87,0,0,1,168,67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.19 71.1 170.23 72.19 169.6 68.33 172.19 71.1",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16,77.61c-2-.08-4.59-.77-5.29-2A3.89,3.89,0,0,0,167.74,78a11.37,11.37,0,0,0,2.41.42Z",
    style: {
      fill: "#9a4a4d"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M189.79,101.66a14.62,14.62,0,0,1-3.66-.12.31.31,0,0,0-.25.07,3.22,3.22,0,0,0-.24.36l-.35.4c-.16.16-2.13,2.62-2.1,2.64l.93.48s3,3.32,4.9,2.1c.43-.28.94-.14,1.38-.33a2.43,2.43,0,0,0,.53-.31h0Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.17,107a9.65,9.65,0,0,1-4.22-2.61.78.78,0,0,1-.26-.64.77.77,0,0,1,.24-.38l.78-.83a5.14,5.14,0,0,0,.86-1.12,1.28,1.28,0,0,0,.17-.85c-.07-.29-.16-.43-.46-.45-.1,0-.33.13-.64.39A19.85,19.85,0,0,1,184,102a7.28,7.28,0,0,1-3.5,1.17h0c-2.78-.52-12.72-4.37-12.72-4.37s-3.49-9.17-4.55-11.36-2.55-5.65-4.41-6.88c-3.73,1.43-5.26,5.35-3.49,9.37s4,9.18,5.4,12c1.29,2.52,1.86,3.32,4.19,4,5.68,1.58,13,2,16.37,3.07a12.31,12.31,0,0,0,4.75.16,3.46,3.46,0,0,0,.95-.22c.28-.12.53-.31.82-.43a12.51,12.51,0,0,1,1.5-.33,2.55,2.55,0,0,0,1.28-.74s.32-.33.32-.4A1.11,1.11,0,0,1,190.17,107Z",
    style: {
      fill: "#b16668"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M186.6,109a1.78,1.78,0,0,1-1-.11c-.43-.35-.87-.49-1.19-1a3.7,3.7,0,0,0-.37-.49,2.42,2.42,0,0,0-.87-.49c-.3-.11-.57-.27-.88-.37-.15,0-.39-.06-.46.12a2.13,2.13,0,0,0-.47-.43c-.19-.12-.65-.27-.78,0a.53.53,0,0,0,0,.25c0,.5,0,1-.07,1.51a1.59,1.59,0,0,0,0,.38,1.11,1.11,0,0,0,.6.64,2.15,2.15,0,0,0,.5.19c.21,0,.43,0,.64.06.44.09.81.43,1.26.45a7.83,7.83,0,0,0,.83-.1,5.23,5.23,0,0,1,.68.07A6.61,6.61,0,0,0,186.6,109Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.78,102.77l-.61.28c-.53.28-1,.69-1.47,1a3,3,0,0,1-1,.48c-.25,0-.83.12-.93-.23a.44.44,0,0,1,.08-.33c.21-.4.44-.78.69-1.16a3.26,3.26,0,0,1,.81-1,7.33,7.33,0,0,1,1.34-.74,3.62,3.62,0,0,1,.63-.22,3.47,3.47,0,0,1,1.2,0l2,.28-.49.35-.74.43A16.64,16.64,0,0,1,182.78,102.77Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.81,177.47a8.75,8.75,0,0,0,1.08,4.16,2.73,2.73,0,0,0,3.1,1.06,4.71,4.71,0,0,0,3.41-2.9,9,9,0,0,0-.06-4.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.8,163.9c.5,0,.69,2.51,1,5,.35,2.67,1.17,4.15,1.46,5.94.39,2.49.24,3.62-.6,5.15s-4.14,3.14-5.66,1c-1.24-1.75-1.32-3.7-1.25-6.2s.16-4.4,0-6.36-.28-3.69.16-3.9c0,.27.07.62.11.89s.1,1.22.38,1.23a3.37,3.37,0,0,0,0-.71.83.83,0,0,1,.13-.6.93.93,0,0,1,.56-.27,14.67,14.67,0,0,1,1.5-.26,6.34,6.34,0,0,1,.76,0,4.13,4.13,0,0,1,.93,0,.49.49,0,0,1,.28.25,1.36,1.36,0,0,1,0,.29,1.79,1.79,0,0,0,.07.51c0,.07.07.16.14.15s.08-.1.08-.16c0-.3,0-.52-.06-.87,0-.16,0-.38,0-.54S228.81,164.05,228.8,163.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.42,175.49a.18.18,0,0,1-.16.2.18.18,0,0,1-.19-.16.18.18,0,1,1,.35,0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.23,173.77a.18.18,0,0,1-.16.2.19.19,0,0,1-.2-.16.18.18,0,0,1,.16-.2A.19.19,0,0,1,229.23,173.77Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,172.14a.18.18,0,1,1-.19-.16A.18.18,0,0,1,229,172.14Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.86,170.54a.18.18,0,1,1-.19-.16A.18.18,0,0,1,228.86,170.54Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.26,170.89a.18.18,0,0,1-.16.2.17.17,0,0,1-.19-.16.17.17,0,0,1,.15-.2A.18.18,0,0,1,225.26,170.89Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.44,172.51a.18.18,0,0,1-.16.2.18.18,0,0,1-.19-.16.18.18,0,1,1,.35,0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,174.13a.18.18,0,0,1-.15.2.17.17,0,0,1-.2-.16.19.19,0,0,1,.16-.2A.18.18,0,0,1,225.62,174.13Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.81,175.86a.17.17,0,0,1-.15.2.18.18,0,0,1,0-.36A.17.17,0,0,1,225.81,175.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.31 176.65 225.79 164.62 226.44 164.6 227.31 176.65",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.25,175.6h0a6.27,6.27,0,0,0-3.55.35.09.09,0,0,1-.12,0,.09.09,0,0,1,0-.13,6.39,6.39,0,0,1,3.66-.36.09.09,0,0,1,.07.11A.08.08,0,0,1,229.25,175.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.06,173.88H229a5,5,0,0,0-3.53.35s-.09,0-.12,0a.1.1,0,0,1,0-.12,5.16,5.16,0,0,1,3.69-.36.1.1,0,0,1,0,.12A.07.07,0,0,1,229.06,173.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.88,172.25h0a5,5,0,0,0-3.53.36.1.1,0,0,1-.12,0,.11.11,0,0,1,0-.13,5.08,5.08,0,0,1,3.68-.35.09.09,0,0,1,0,.12S228.91,172.25,228.88,172.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.7,170.65h0a5,5,0,0,0-3.53.35.08.08,0,0,1-.12,0,.1.1,0,0,1,0-.12,5.14,5.14,0,0,1,3.68-.36.09.09,0,0,1,.05.12S228.73,170.64,228.7,170.65Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "212.62 170.06 210.47 169.31 211.12 167.81 212.47 169.02 212.62 170.06"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.71,166.06s.13,1.42.16,1.86-1.79,1.9-2.25,2.14l-.15-1a8.18,8.18,0,0,0-1,1.72,8.37,8.37,0,0,1-1.72,2.73,10.37,10.37,0,0,1-6,2.11,6.63,6.63,0,0,1-4.36-.87,1.6,1.6,0,0,1-.75-1.71C198.75,172.39,214.71,166.06,214.71,166.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.34,161.41l-.06-.82c-.43,0-.44,1.19-1,2.26a21.67,21.67,0,0,1-3.14,4.39c-2.3,2.27-4.36,3.72-5.38,4.74-1.37,1.37,1.17,3.4,5,3.06,1.88-.16,5.2-1.24,6.11-2.41s1.43-3,2.16-3.81,2.32-1.74,2.76-2.76a7.19,7.19,0,0,0-.12-2.94c-.17-1-.25-2.54-.8-2.39l0,.51a2.84,2.84,0,0,1-2.23,1.5C210.78,162.9,208.52,163,208.34,161.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.32,162.82a2,2,0,0,1-1.84-.92l0,0a1.89,1.89,0,0,1-.44,1.6c-.65.83-4.77,6.7-4.77,6.7s3.85-4.85,4.59-5.77c1.09-1.35,1.45-1.52,2.48-1.59Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.42,164.37a.22.22,0,0,0,.26.2.23.23,0,0,0,.2-.26.24.24,0,0,0-.27-.21A.24.24,0,0,0,209.42,164.37Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.33,165.67a.24.24,0,0,0,.27.21.24.24,0,0,0,.19-.27.22.22,0,0,0-.26-.2A.23.23,0,0,0,208.33,165.67Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25,167a.23.23,0,0,0,.26.2.24.24,0,0,0,.2-.27.23.23,0,0,0-.26-.2A.24.24,0,0,0,207.25,167Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.17,168.28a.23.23,0,0,0,.26.2.24.24,0,1,0-.26-.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.08,169.58a.25.25,0,0,0,.27.21.24.24,0,0,0-.07-.48A.24.24,0,0,0,205.08,169.58Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.66,164.43a.05.05,0,0,0,.05,0,.09.09,0,0,0,0-.13,3.78,3.78,0,0,0-2.66-1h0a.08.08,0,0,0-.08.1.1.1,0,0,0,.1.09,3.61,3.61,0,0,1,2.51.93A.08.08,0,0,0,209.66,164.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.57,165.73a.07.07,0,0,0,.06,0,.09.09,0,0,0,0-.13,3.73,3.73,0,0,0-2.66-1h0a.1.1,0,0,0-.09.1.11.11,0,0,0,.1.09,3.64,3.64,0,0,1,2.52.93A.1.1,0,0,0,208.57,165.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.49,167a.09.09,0,0,0,.06,0,.11.11,0,0,0,0-.14,3.77,3.77,0,0,0-2.65-1h0a.11.11,0,0,0-.08.11.09.09,0,0,0,.1.08,3.69,3.69,0,0,1,2.52.93A.09.09,0,0,0,207.49,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.41,168.34a.09.09,0,0,0,.06,0,.09.09,0,0,0,0-.13,3.73,3.73,0,0,0-2.66-1h0a.08.08,0,0,0-.08.1.1.1,0,0,0,.1.09,3.63,3.63,0,0,1,2.51.93A.08.08,0,0,0,206.41,168.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.32,169.64a.06.06,0,0,0,.06,0,.09.09,0,0,0,0-.13,3.78,3.78,0,0,0-2.66-1h0a.11.11,0,0,0-.09.1.1.1,0,0,0,.11.09,3.63,3.63,0,0,1,2.51.93A.07.07,0,0,0,205.32,169.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.38,107.89c1,14.94,1.48,31.59,1.48,31.59a88.36,88.36,0,0,1,.47,9.07c0,5.44-.29,18.74-.29,18.74a7.15,7.15,0,0,1-7,.6s-2.7-14.71-3.92-22.6c-1-6.31-2.29-14.41-2.29-14.41l-1.11,7.54a50,50,0,0,1,.4,8.81c-.21,3.17-1.33,15.24-1.33,15.24s-4.39,3.67-7.82.15c0,0-1.63-20.18-1.85-24-.43-7.49-.17-21,0-30.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.81,130.88l-1.89-12.95s-3.56-.41-5.44-2.05a7.16,7.16,0,0,0,4.62,3l1.79,11.75-.19,7.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.57,79.59c-2.78,1.12-3.06,2.66-4.22,9.6-1.13,6.78-1.38,8.6-1.38,8.6s-11.75,3.6-13.18,3.87l1.14,5.29,7.64-1.21c5.71-.9,8.41-1.51,9.75-2.93s3-15.35,3-15.35Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.5,79.32c-2,.8-2.79,1.3-3.64,4.82-.71,2.93-3,13.4-3,13.4L191,101.19s.94.47,1.11,2.59a8.93,8.93,0,0,1-.15,3s8.57-1.09,12.05-1.82,4.54-1.2,5.07-2.9c.27-.86,1.89-9.26,2.18-11s.46-3.93.46-3.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-168",
    d: "M220.59,77.36c1.44.27,3.18.62,3.18.62,3.66,1.56,4.25,1.79,5,2.11a24.69,24.69,0,0,1,.74,11.71,64.7,64.7,0,0,0-1.07,9.18c0,4.17.06,7.5.06,7.5s-4,3.86-14.18,3.26c-8-.48-9.24-3.26-9.24-3.26s.16-10.77.27-16.65c.15-7.73,1.43-11.13,3.13-12.51L213.26,77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214,57.62c.44-.07.88-.11,1.33-.14a8.28,8.28,0,0,1,3.76.53,4.35,4.35,0,0,1,2.52,2.72,3.14,3.14,0,0,1,2.08,1.78,7,7,0,0,1,.46,4,12.14,12.14,0,0,1-2,4.29c-.17.27-2.34,3.31-2.12,3.48l-4.36-3.35-3.61-2.76L210.54,67a1.84,1.84,0,0,0-.95-.43,2.2,2.2,0,0,1-1.21-.68,1.73,1.73,0,0,1-.3-1.91,1,1,0,0,1-1-.83.75.75,0,0,0,.94-.28,3.34,3.34,0,0,0,.38-1,5.67,5.67,0,0,1,2.74-3.27A9.09,9.09,0,0,1,214,57.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,72.8a4,4,0,0,0,2.64,2.6,5.33,5.33,0,0,0,1.71.19l0,1.43a4.53,4.53,0,0,0-.21,3.14,7.68,7.68,0,0,0,.59,2c.81-.53,1.36-1.63,1.92-1.86a17.52,17.52,0,0,0,4.88-2.89l-.11-5.71a1.59,1.59,0,0,0,2.1.11,2.64,2.64,0,0,0,1-3.41c-.77-1.3-2.21-1.38-2.78-.5-.31.47-.3,1.15-.79,1.09-1.12-.14-.95-2.19-.82-3.1a.43.43,0,0,0,0-.25.44.44,0,0,0-.21-.17,3,3,0,0,1-1.29-1.69,6.7,6.7,0,0,1-.28-2.14,15,15,0,0,1-3,1.42,18.35,18.35,0,0,1-3.55.64c-.41,0-1,0-1.27.29a2.21,2.21,0,0,0-.57,1.33c-.14,1,0,2-.14,3A11.43,11.43,0,0,0,209,72.8Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.17,65.17l-1.36.49a.77.77,0,0,1,.45-1A.71.71,0,0,1,211.17,65.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.52,65.09l1.31.64a.77.77,0,0,0-.35-1A.71.71,0,0,0,215.52,65.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.34,75.59c1.44,0,4.42-.93,5.21-1.7a5.79,5.79,0,0,0,1.17-2.36,7.88,7.88,0,0,1-.8,2.91c-.62.87-2.14,1.22-3,1.42a19.8,19.8,0,0,1-2.54.27Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.67,66.08a1,1,0,0,0,.25.58.59.59,0,0,1,.1.21,9.27,9.27,0,0,0,.33,1.58,1.71,1.71,0,0,0,1.74,1.1,2.8,2.8,0,0,0,.61-.06,1.74,1.74,0,0,0,.94-.51,2.29,2.29,0,0,0,.42-.61c.28-.56.25-1.33.67-1.43h.11c.58,0,.48.85.78,1.44a2,2,0,0,0,2.06,1.18,1.93,1.93,0,0,0,1.91-1.1,9.63,9.63,0,0,0,.4-1.58.61.61,0,0,1,.11-.23,1.14,1.14,0,0,0,.3-.57.45.45,0,0,0-.32-.49l-.31,0a10.19,10.19,0,0,0-3.05.09,9.47,9.47,0,0,1-1.87.57c-.5,0-.81-.3-1.72-.57a8.89,8.89,0,0,0-2.85-.09l-.29,0A.5.5,0,0,0,207.67,66.08Zm6.34.47a.74.74,0,0,1,.28-.22,3.89,3.89,0,0,1,1.46-.41,2.46,2.46,0,0,1,1.71.29c.21.18.08,1,0,1.42a2.23,2.23,0,0,1-.38.88,1.57,1.57,0,0,1-1.32.61,1.73,1.73,0,0,1-1.36-.48h0a1.72,1.72,0,0,1-.42-.83A1.86,1.86,0,0,1,214,66.55Zm-5.46-.34a.7.7,0,0,1,.23-.14,2.83,2.83,0,0,1,1.47-.14,2.51,2.51,0,0,1,1.51.62,2.39,2.39,0,0,1-.29,1.94,1.59,1.59,0,0,1-1.41.63,1.56,1.56,0,0,1-.69-.15,1.77,1.77,0,0,1-.85-1.34C208.44,67.22,208.34,66.39,208.55,66.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.12,65.65l3.33,1.67a1.23,1.23,0,0,0-.63.38l-2.75-1.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.38,67.6l-.45,2.77-2-.87.11-.13L212.2,68l.85-1A.93.93,0,0,1,213.38,67.6Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.07,71.06l-2.13.68a1.1,1.1,0,0,0,1.39.76A1.16,1.16,0,0,0,215.07,71.06Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.33,72.5a.61.61,0,0,1-.13,0,1,1,0,0,1,.91-1.08A1.15,1.15,0,0,1,214.33,72.5Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.83,67.1c-.13.31.09.43.39.55s.58.21.71-.11a.59.59,0,1,0-1.1-.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.9,66.88a1.32,1.32,0,0,0-.44-.18,1,1,0,0,0-.45,0,1.27,1.27,0,0,0-.48.11s0,0,0,0a2.69,2.69,0,0,1,.43,0,1.82,1.82,0,0,1,.51.09,2,2,0,0,1,.57.25l.19.11s0,0,0,0A1.1,1.1,0,0,0,210.9,66.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.2,67.33c.09.33-.14.42-.45.51s-.6.14-.7-.18a.6.6,0,1,1,1.15-.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.15,67a1.76,1.76,0,0,1,.46-.14,1.42,1.42,0,0,1,.46,0,1.49,1.49,0,0,1,.46.16s0,0,0,0a3,3,0,0,0-.41-.06,3,3,0,0,0-.52,0,2.74,2.74,0,0,0-.6.19l-.19.1s0,0,0,0A1.22,1.22,0,0,1,215.15,67Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tie--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.7,82.55a10.14,10.14,0,0,1-1.17-2.69l1.21-1.37.52,3.18Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.7,82.55a10.14,10.14,0,0,1-1.17-2.69l1.21-1.37.52,3.18Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "214.31 81.67 216.4 80.09 218.26 81.22 215.02 83.07 214.31 81.67",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "214.31 81.67 216.4 80.09 218.26 81.22 215.02 83.07 214.31 81.67"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.12,101.22c.35-4.18-.88-15.54-.84-17l-1.11,0c-.67,1.81-2.24,13.58-2.2,16.44,0,1.38,1.54,3.79,2,3.86S215.05,102.11,215.12,101.22Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.09,84.4c0-.08.06-.19.08-.26h0l1.11,0h0c0,.13,0,.29,0,.47A2,2,0,0,1,213.09,84.4Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.31,81.66a5,5,0,0,0-1.05,0,2.5,2.5,0,0,0-.56.88,4.29,4.29,0,0,0,.51,1.61,1.32,1.32,0,0,0,1.14.1,3,3,0,0,0,.67-1.19A2.09,2.09,0,0,0,214.31,81.66Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.13,81.65h.18a6.89,6.89,0,0,1,1.28-1.13c.3-.15,1.53,2,1.76,2.57s.19.56,1,.07a28.93,28.93,0,0,0,3.85-2.87,4.41,4.41,0,0,0,1.6-2.32s-2.81-2.52-3.31-2.45l0,1.21c-.1.77-4.46,2.32-4.88,2.71A15.67,15.67,0,0,0,214.13,81.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.07,82.42c.11.32.91-2.39,1.4-2.33.24,0,.54.85,1,1.56h.08a9.2,9.2,0,0,1-.32-2.28,20,20,0,0,1,.1-2.24l0-.69a2.62,2.62,0,0,0-1.23.92,4,4,0,0,0-1,1.93A9.33,9.33,0,0,0,211.07,82.42Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.89,97.21a19,19,0,0,1,.38,5.58,35.94,35.94,0,0,1-.8,4.54c-.52,2.77-1.89,7.83-1.85,8.56a12.39,12.39,0,0,1,0,2.11,8.43,8.43,0,0,1-.54,2.43c-.2.55-.33,1.14-.56,1.66a6.63,6.63,0,0,1-.74,1c-.27.37-.36.84-.7,1.16a5.4,5.4,0,0,1-1.77,1c-.24.36-.64,1.13-.91,1.47-.69.87-.87-.53-.86-1a7.13,7.13,0,0,1,.27-1.52,35,35,0,0,0,.8-3.79c0-.22.29-1.16-.08-1.15a.44.44,0,0,0-.3.18c-.25.3-.42.66-.64,1a5.52,5.52,0,0,1-.59.69,1.92,1.92,0,0,1-.59.48c-.24.11-1.12.19-1.17-.22a.41.41,0,0,1,.05-.19c.17-.43.38-.85.56-1.28a12,12,0,0,0,.49-1.3,10.65,10.65,0,0,1,1.52-3.71c1.46-2.08,1.58-14.26,1.58-14.26l-2.14-8.36a17.4,17.4,0,0,1-1.27-7,6.13,6.13,0,0,1,2.5-4.54c3.11,1.19,3.85,1.6,4.7,4.43S236.58,95.17,236.89,97.21Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.32,99.37c-.1-.72-.63-4.49-1.82-10-.86-3.93-1.17-5.64-2.27-6.83-.85-.94-3-1.81-4.44-2.46a9.37,9.37,0,0,0-2,5.79,27.43,27.43,0,0,0,1.18,7.38l2.29,7.66-.66,11.15c1.47-.54,4.54.86,5.33,2.3,0,0,1.74-6.79,2.27-9.49A16.62,16.62,0,0,0,237.32,99.37Z",
    style: {
      fill: "#455a64"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177,425.61c0,4.6-.34,8.62.09,11.55,0,.25-2.43,1.21-4.11.92s-2.13-.88-2.13-1.06c0-.61-.62-1.43-.68-2-.4-3.86-1-6.62-1.27-9.36Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.42,445.27a1.67,1.67,0,0,1-.37,1.74,7.84,7.84,0,0,1-5.63,1.14c-2.78-.39-3.55-.95-4.64-1.87a8.79,8.79,0,0,0-3.36-2.18,12.1,12.1,0,0,1-3.3-1.11c-.37-.36-.28-1.92-.28-1.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.05,434.32a.51.51,0,0,0-.48.37c-.1.43-.21,1.68-.41,2.38a16.93,16.93,0,0,0-.28,4.54c.14.8,2.54,1.34,3.75,1.81a11.54,11.54,0,0,1,3.37,2.15,8.64,8.64,0,0,0,5.11,1.91c2.15,0,4.58-.61,5.15-1.57.71-1.18.84-2.33-2.32-3.81-.59-.28-2.43-1.37-3.14-1.83a13.13,13.13,0,0,1-2.18-1.67,10.45,10.45,0,0,1-.8-.83,2.47,2.47,0,0,1-.42-.88,10.52,10.52,0,0,1-.17-1.78.28.28,0,0,0-.06-.15.34.34,0,0,0-.14-.09,3.73,3.73,0,0,0-1.56-.1,6.25,6.25,0,0,0-1.58.32,1.36,1.36,0,0,0-.73.43,1.17,1.17,0,0,0-.15.58,3.82,3.82,0,0,1,0,.59.29.29,0,0,1-.09.2c-.11.1-.28,0-.37-.07a8.18,8.18,0,0,1-.84-1c-.14-.19-.81-.31-1-.46a5,5,0,0,1-.54-.35C170,434.81,170.05,434.57,170.05,434.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,445.57a17.14,17.14,0,0,0-1.45-1.13h0s3.36,1.36,4.9.38a1.3,1.3,0,0,0,.52-1.67c0-.25,2.41-1.29,3.36-1.38h0l.61.33c3.16,1.48,3,2.63,2.32,3.81-.57,1-2.34,1.68-5.12,1.64A9,9,0,0,1,176,445.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.72,442.41c2,.8,1.11,1.15.56,1.22s-3.32-1.55-5.32-3.14-3.9-3.42-4.67-4c-.29-.22-.6-.5-.88-.76.06-.43.11-.81.16-1,.08-.36.52-.46.52-.46l.08.75a1.55,1.55,0,0,0,.54.32,2.37,2.37,0,0,1,1,.51,8.18,8.18,0,0,0,.84,1A22.51,22.51,0,0,0,179.72,442.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.14,443.34A.18.18,0,0,1,180,443a4.78,4.78,0,0,1,3.66-1.33.18.18,0,0,1,.16.21.19.19,0,0,1-.21.17,4.42,4.42,0,0,0-3.31,1.19A.2.2,0,0,1,180.14,443.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.43,442.37a.21.21,0,0,1-.12-.05.17.17,0,0,1,0-.26,4.79,4.79,0,0,1,3.62-1.41.19.19,0,0,1,.18.21.2.2,0,0,1-.22.17,4.44,4.44,0,0,0-3.28,1.27A.2.2,0,0,1,178.43,442.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.86,441.26a.2.2,0,0,1-.13,0,.19.19,0,0,1,0-.27,4.78,4.78,0,0,1,3.66-1.33.19.19,0,1,1-.05.38,4.46,4.46,0,0,0-3.31,1.2A.22.22,0,0,1,176.86,441.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.47,440.27a.28.28,0,0,1-.13,0,.19.19,0,0,1,0-.27,4.78,4.78,0,0,1,3.59-1.48.19.19,0,1,1,0,.38,4.46,4.46,0,0,0-3.25,1.33A.25.25,0,0,1,175.47,440.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,439.09a.17.17,0,0,1-.12,0,.18.18,0,0,1,0-.26,4.91,4.91,0,0,1,3.94-1.49.19.19,0,0,1,0,.38,4.56,4.56,0,0,0-3.59,1.34A.17.17,0,0,1,174,439.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.73,427.15l8.44-.39-2,10.49-.58,2.56c-.27,1.86-4.68,2.36-5.74-.52l0-2.52C151.82,434.45,151.79,430.6,151.73,427.15Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.13,449.82a8.88,8.88,0,0,1-.87,4.33,2.82,2.82,0,0,1-3.18,1.29c-1.31-.26-3-1.06-3.45-2.68a10.36,10.36,0,0,1-.22-4.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.85,436.77c-.44.17-.43,2.77-.61,5.34-.19,2.76-.64,3.61-.82,5.87-.21,2.58,0,3.43,1,4.93s4.23,2.88,5.69.58c1.19-1.87,1.12-3.59.88-6.15a53.55,53.55,0,0,1-.28-6.1c0-1.93.92-3.8.45-4a7.61,7.61,0,0,1-.25,1.45,2.61,2.61,0,0,1-.24.73c-.23.37-.38-.21-.39-.43,0-.38.09-.69-.22-1a2.28,2.28,0,0,0-.82-.42,5.58,5.58,0,0,0-1-.23,10,10,0,0,0-2.05,0,1,1,0,0,0-.77.37.48.48,0,0,0-.07.2c0,.26,0,.51,0,.77,0,.07,0,.25-.09.3s-.18,0-.19,0S151.83,437.22,151.85,436.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.49,447.09c0,.37-.18,2.7.51,3.11s1-1.5,1-1.5a6.42,6.42,0,0,1,4.19.35c-.11.41.34,1.7,1,1.39s.76-2.84.76-2.88c.22,2.46.26,4.11-.9,5.93-1.46,2.3-4.71.93-5.69-.58s-1.19-2.35-1-4.93C150.44,447.72,150.45,447.33,150.49,447.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.25,448.85c0,.93-.81.65-1-.65-.29-1.94.11-3.84,0-6.09.18-2.57.08-5.27.61-5.34,0,.44.18,2.2.18,2.2a52.24,52.24,0,0,0-.29,6.15C151.89,446.85,152.21,447.92,152.25,448.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.94,449a16.42,16.42,0,0,0,.52-2.93c.1-1.72.9-4.87,1.17-6.76.07-.58.51-2.08.51-2.1.34.14.07,1.23-.13,2.4s-.35,1.88-.46,3c-.35,2.23-.3,4.58-.54,5.87S155.81,450,155.94,449Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.16,449.08l-.08,0a6.29,6.29,0,0,0-4.11-.23.18.18,0,0,1-.24-.12.19.19,0,0,1,.12-.25,6.61,6.61,0,0,1,4.4.24.2.2,0,0,1,.1.26A.22.22,0,0,1,156.16,449.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.6,447.21l-.06,0a8.52,8.52,0,0,0-4.8-.31.21.21,0,0,1-.25-.13.22.22,0,0,1,.14-.25,8.64,8.64,0,0,1,5.06.33.19.19,0,0,1,.1.26A.2.2,0,0,1,156.6,447.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.39,445.39a.19.19,0,0,1-.17-.12.2.2,0,0,1,.11-.26c2.34-.92,5.53,0,5.63.09a.19.19,0,0,1,.09.26.2.2,0,0,1-.26.1s-3.14-.94-5.31-.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.7,443.71a.19.19,0,0,1-.17-.12.2.2,0,0,1,.1-.26,7.35,7.35,0,0,1,5.43.29.2.2,0,0,1,.08.27.2.2,0,0,1-.27.08,7.06,7.06,0,0,0-5.09-.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.76,441.68a.21.21,0,0,1-.17-.12.2.2,0,0,1,.1-.26c2.41-1,5.36.29,5.47.34a.2.2,0,0,1,.08.27.18.18,0,0,1-.26.08s-2.89-1.29-5.13-.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,399.84l1.31,10.1s-.12,3.46.05,6.8a143.75,143.75,0,0,0,2.33,14.82,7.38,7.38,0,0,0,7.31.06s.73-17.65,1-22.33-.4-23.67-.63-31.1l-22.77.07s-.45,4-.86,10-1.33,22-1.33,22c-2.15,7.22-1.37,10.65-.8,22.93,3.47,2.43,7.62.38,7.62.38s2.07-10.39,3.27-15.72,2.15-12.11,3.48-17.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,389.78l.66,9.1c0,1.46.36,4.64.39,6.1s.14,3.46.12,6,0,9.75.08,12.67c.44-3.23.48-10.5.48-14.29a101.86,101.86,0,0,0-.65-10.51C175.09,394.62,174.77,392.67,174.4,389.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,389.61c-.85,5.77-2.09,16.06-2.52,19.37s-2.12,14-2.44,17.31c.58-3.3,2.65-13.9,3.11-17.23S161.67,395.93,162,389.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.79,389.33,166,399.84l1.31,10.1-.32-9.67,2.12-9.89a7.8,7.8,0,0,0,5-5.23C172.06,388.41,167.79,389.33,167.79,389.33Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.85,362.9c-.91.67-1.88,1.74-3.44,3a53.82,53.82,0,0,1-6.22,4.57c-2.27,1.25-3.37,1.74-6.05-1.21a77.54,77.54,0,0,1-6.68-9l.38-10.58a8.66,8.66,0,0,1,5,4.31c2.58,4.24,4.34,7,5.84,9.42,0,0,6.65-3.64,7.52-4.22a3.55,3.55,0,0,0,1.39-1.82,15.84,15.84,0,0,1,.72-1.84c.28-.63.39-.87.72-1.67s.59-2.15.7-2.45.7-.29,1.11.55a3.37,3.37,0,0,1,.15,1.64c0,.5-.21,1.09-.06,1.18a10,10,0,0,0,1.57-.41,3.81,3.81,0,0,1,2.12-.18.92.92,0,0,1,.61,1.24,1.22,1.22,0,0,1-.43.47,1,1,0,0,1,.75.25,1.08,1.08,0,0,1,0,1.37.62.62,0,0,1,.59.56c.07.46,0,.92-.46,1.09,0,0,.38.1.4.32a1.09,1.09,0,0,1-.39,1,3.57,3.57,0,0,1-1.33.28s-.08.16-.52.38a12.72,12.72,0,0,1-1.5.76A9.12,9.12,0,0,0,195.85,362.9Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.66,363.4a5.14,5.14,0,0,0-2.33,3.34,3.94,3.94,0,0,1,2-3.81Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.85,349.62a7.38,7.38,0,0,1,3.4,2.12,53.67,53.67,0,0,1,3.61,5.45l2.06,3.26s-.07,4-5.21,6l-4.42-6.1Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.29,359.69a2.11,2.11,0,0,0,.6-.18,5.25,5.25,0,0,1,.57-.13l1.18-.22q-.6,0-1.2.09a4.21,4.21,0,0,0-.6.11,2.17,2.17,0,0,1-.55.15,1.18,1.18,0,0,1-.53-.15,1.23,1.23,0,0,1-.47-.3.74.74,0,0,1-.1-.26.27.27,0,0,1,.06-.24.63.63,0,0,1,.35-.21,1.87,1.87,0,0,0,.41.09,1.82,1.82,0,0,0,.67-.14l.62-.25c.41-.17.81-.35,1.21-.54-.42.12-.84.27-1.26.41a4.15,4.15,0,0,1-1.23.35,1.73,1.73,0,0,1-.61-.16,2.86,2.86,0,0,1-.55-.33.51.51,0,0,1-.25-.51.46.46,0,0,1,.17-.3l.15,0c.25,0,.51,0,.77-.07a2.84,2.84,0,0,0,.76-.2,6.5,6.5,0,0,0,1.32-.79,5.38,5.38,0,0,1-.67.36c-.23.11-.46.22-.7.31a2.67,2.67,0,0,1-.73.17c-.25,0-.51,0-.77,0l-.38.05c-.12,0-.16,0-.21-.13a.62.62,0,0,1,.16-.62,2.35,2.35,0,0,1,1.26-.76h0v0a1,1,0,0,1,.17-.29,3.07,3.07,0,0,1,.25-.26,3.11,3.11,0,0,0-.28.23,1.42,1.42,0,0,0-.2.28,2.32,2.32,0,0,0-1.35.73,1.58,1.58,0,0,0-.2.36.58.58,0,0,0,0,.43.45.45,0,0,0,.15.19h0a2.88,2.88,0,0,1-.24,2.38,3,3,0,0,1-1.19,1.09,3.31,3.31,0,0,0,1.35-.84,2.76,2.76,0,0,0,.68-1.09l.14.21v.1a.87.87,0,0,0,.1.31,1.22,1.22,0,0,0,.51.37,1.79,1.79,0,0,0,.37.15.31.31,0,0,0-.06.16.48.48,0,0,0,.06.26,1.76,1.76,0,0,0,.32.39,1.56,1.56,0,0,0,.2.16.86.86,0,0,0,.24.11,2.83,2.83,0,0,0,.5,0l-.45-.18a1,1,0,0,1-.2-.11,1.22,1.22,0,0,1-.17-.15,3.51,3.51,0,0,1-.33-.34.41.41,0,0,1-.08-.34A.64.64,0,0,0,199.29,359.69ZM197.7,357h0v0Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-168",
    d: "M161.77,348.4c-3.54.77-4.6,1.12-6.27,1.5,0,0-3.47,3.21-1.43,14.69a49.79,49.79,0,0,1,.55,8.47c-.06,2.55-.46,6.45-.52,8.2,0,0,4.23,2.73,14.1,1.79,7.76-.73,9.46-3.65,9.46-3.65V362.93c0-9.44-1.69-11.63-3.8-13.31-.27-.17-5.52-1-5.52-1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.08,329a7.61,7.61,0,0,0-7.63,3.6c-1.58.23-2.32,1.6-2.35,3.18-.1,5.35,4.47,7.56,5.45,10.05l10.31-10.65C171.84,333.26,171.17,329.45,166.08,329Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,332.05l2.18.55a1.2,1.2,0,0,1-1.42.81A1.08,1.08,0,0,1,156.4,332.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,330.51l.59,2.13a1.19,1.19,0,0,1-1.42-.8A1.08,1.08,0,0,1,158,330.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.12,333.66a2.73,2.73,0,0,1-.44,1c-.4.59-1.08.94-1.43,1.54s0,1.2,0,1.87a1.43,1.43,0,0,1-.47,1.13c-.86.67-1.49-.68-2.13-1a1.77,1.77,0,0,0-2.62.93,3.39,3.39,0,0,0,1.4,3.84,1.72,1.72,0,0,0,2.22-.37l.39,6.72a7,7,0,0,0,6.73,2.36c2.64-.48,1.88-1.77.83-2.7l-.12-2.33a7.65,7.65,0,0,0,2.18-.45c1.58-.62,2.25-2,2.5-3.77.31-2.16-.33-4.27-.65-6.09a10,10,0,0,0-.88-3.55c-.7-1.11-1.85-.56-3.09-.86a5.54,5.54,0,0,0-4.25.44.41.41,0,0,0-.15.14.55.55,0,0,0,0,.38A2,2,0,0,1,164.12,333.66Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.77 336.44 168.83 340.7 170.9 339.6 167.77 336.44",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.7,341.8l2.35.55a1.19,1.19,0,0,1-1.44.92A1.23,1.23,0,0,1,166.7,341.8Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.61,343.27l.15,0a1.08,1.08,0,0,0-1.08-1.07A1.24,1.24,0,0,0,167.61,343.27Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.75,335.62l-1.47.94a.88.88,0,0,1,.27-1.21A.87.87,0,0,1,165.75,335.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.25,338a.7.7,0,0,0,.8.6.71.71,0,1,0-.2-1.4A.7.7,0,0,0,165.25,338Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.33,337.28a.71.71,0,0,0,1.4-.2.71.71,0,0,0-.8-.6A.7.7,0,0,0,170.33,337.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.48,346.65a14.32,14.32,0,0,1-3.56-.3,3.77,3.77,0,0,1-2.85-2.2,3.69,3.69,0,0,0,1.22,2.15c1.72,1.31,5.22,1.11,5.22,1.11Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.44,333.51a1.45,1.45,0,0,1,.31.11,3.1,3.1,0,0,1,.56.47,5.46,5.46,0,0,0,2.6,1.64,3.79,3.79,0,0,0,1.83-.12,1.42,1.42,0,0,1-1.07-.87,3.42,3.42,0,0,0,2.53.34,1.67,1.67,0,0,0,.94-.79,1.16,1.16,0,0,0-.1-1.19,2.09,2.09,0,0,1,.86,1.1,2.18,2.18,0,0,0,.14-2.27,3.72,3.72,0,0,0-1.67-1.68,1.62,1.62,0,0,0,.52-1.92s0-.09-.09-.09-.08,0-.11,0c-1,.83-2.26.41-3.38.06a11.07,11.07,0,0,0-4.27-.51c-2.33.21-6,1.75-5.67,4.73a11.5,11.5,0,0,1,2.95.28c.34.11.62.36,1,.47a2.73,2.73,0,0,0,1.43.29A1.49,1.49,0,0,1,164.44,333.51Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.27,364.64h0l-.55-.52h0a.63.63,0,0,0-.58-.09L169.07,368a2.34,2.34,0,0,0-1.45,1.25l-5,12.71a.61.61,0,0,0,.05.67h0l.57.53h0a.62.62,0,0,0,.59.1l17.07-3.95a2.34,2.34,0,0,0,1.45-1.25l5-12.72C187.47,365,187.43,364.77,187.27,364.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93,368.84a2.25,2.25,0,0,0-.75.92l-5,12.71a.6.6,0,0,0,0,.65l-.54-.5h0a.58.58,0,0,1-.06-.67l5-12.71a2.2,2.2,0,0,1,.7-.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.19,382.47l5-12.71a2.24,2.24,0,0,1,1.44-1.25l17.07-3.95c.58-.13.88.21.66.76l-5,12.72a2.34,2.34,0,0,1-1.45,1.25l-17.07,3.95C163.27,383.37,163,383,163.19,382.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,372.46l.93-2.38a.44.44,0,0,1,.27-.23l1.18-.27c.1,0,.16,0,.12.14l-.93,2.38a.46.46,0,0,1-.27.24l-1.18.27C168.09,372.63,168,372.57,168.08,372.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,370.66a1.07,1.07,0,0,1,.69-.57c.28-.07.43.09.33.34a1.07,1.07,0,0,1-.69.57C169.09,371.07,168.94,370.92,169,370.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.59,371.86a1.07,1.07,0,0,1,.69-.57c.28-.07.43.09.33.34a1.12,1.12,0,0,1-.69.58C168.64,372.27,168.49,372.12,168.59,371.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.38,375l-.27.68a16.86,16.86,0,0,0,2.95.48c.34,0,1.61-.59,2.64-.86s1.69.35,1.16.76a8.17,8.17,0,0,1-.9.63c.43.43.73.83-.14,1.57a1.14,1.14,0,0,1-.37,1.28,10.78,10.78,0,0,1-2.91,1.84,12.8,12.8,0,0,1-3.76-.11,17.3,17.3,0,0,1-2.25-1.57,17.09,17.09,0,0,0-3-1.65c-.9-.3-8.91-3.61-10.32-4.33s-3.7-2.27-1.78-3.77,4.86-2.41,7.17-.92c1.67,1.08,5.9,3.43,7.79,4.55a2.38,2.38,0,0,0,1.71.35,12.7,12.7,0,0,1,2.66,0Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,350.08c-3.66,1-4.77,1.7-5.52,3.68-1.22,3.23-4,14.27-4.17,17.15-.07,1.42,6.77,1.65,6.77,1.65l1.14-3.56s2.36-8.06,2.9-9.76C157.12,357.32,157.83,351.94,155.4,350.08Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.62,369a6.06,6.06,0,0,0-4.78-.38c.91-1.16,3.66-1,4.94-.13Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,376.66c-.42.23-.82.49-1.23.75l-.6.4a.44.44,0,0,1-.28.12l-.34,0c-.95.07-1.91.07-2.87.15.48,0,1,.07,1.44.08a11.53,11.53,0,0,0,1.44,0l.37,0a.89.89,0,0,0,.2-.06.83.83,0,0,0,.17-.11l.57-.42C170.21,377.26,170.59,377,171,376.66Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.82,378.23c-.39.27-.79.54-1.2.79-.2.12-.4.25-.61.36a2.38,2.38,0,0,1-.31.17,1.27,1.27,0,0,1-.31.08c-.47.06-.95.07-1.43.09s-1,0-1.43.09a15.48,15.48,0,0,0,2.89,0,1.19,1.19,0,0,0,.38-.1l.31-.18a6.34,6.34,0,0,0,.6-.41A8.22,8.22,0,0,0,170.82,378.23Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.68,380.14l-1,.39a5.1,5.1,0,0,1-1,.24,7,7,0,0,1-1,0,6.17,6.17,0,0,0-1.05.06l1,.12a3.83,3.83,0,0,0,3-.83Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5,349.9c-3.08.77-3.63,1.21-4.64,2.05s-1.43,2.26-2.15,4.9-2.06,8-2.06,8a6.36,6.36,0,0,0,3.54,1.83,9,9,0,0,0,4.29-.2s2.15-6.77,2.53-8S158.26,351.49,155.5,349.9Z",
    style: {
      fill: "#10E2ED"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.77,286.57a1.73,1.73,0,0,0,0,.42,1,1,0,0,0,.38.59h0a1.12,1.12,0,0,0,1.17-.09,3.55,3.55,0,0,0,1.6-2.78,1.1,1.1,0,0,0-.45-1h0l-.08,0h0a1,1,0,0,0-.68,0,1.45,1.45,0,0,0-.39.17A3.53,3.53,0,0,0,84.77,286.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.21,283.13a1.45,1.45,0,0,1,.72-.22.87.87,0,0,1,.45.13l0,0,1,.6a1,1,0,0,0-.68,0,1.45,1.45,0,0,0-.39.17,3.53,3.53,0,0,0-1.61,2.77,1.73,1.73,0,0,0,0,.42,1,1,0,0,0,.38.59L84.14,287h0L84,286.9h0a1.22,1.22,0,0,1-.39-1A3.54,3.54,0,0,1,85.21,283.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.12,277.25a1.86,1.86,0,0,0,0,.42,1,1,0,0,0,.38.58h0a1.12,1.12,0,0,0,1.17-.09,3.55,3.55,0,0,0,1.6-2.78,1.14,1.14,0,0,0-.45-1h0l-.07,0h0a1,1,0,0,0-.68,0,1.65,1.65,0,0,0-.39.17A3.53,3.53,0,0,0,102.12,277.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.56,273.8a1.42,1.42,0,0,1,.72-.22.87.87,0,0,1,.45.13l0,0,1,.6a1,1,0,0,0-.68,0,1.65,1.65,0,0,0-.39.17,3.53,3.53,0,0,0-1.61,2.78,1.86,1.86,0,0,0,0,.42,1,1,0,0,0,.38.58l-1.06-.61h0l-.09-.06h0a1.2,1.2,0,0,1-.39-1A3.54,3.54,0,0,1,102.56,273.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,290.22a1.86,1.86,0,0,1,0,.42.9.9,0,0,1-.38.58h0a1.1,1.1,0,0,1-1.16-.09,3.53,3.53,0,0,1-1.61-2.78,1.14,1.14,0,0,1,.45-1h0l.08,0h0a1,1,0,0,1,.68,0,2.66,2.66,0,0,1,.4.17A3.56,3.56,0,0,1,99,290.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.59,286.77a1.42,1.42,0,0,0-.71-.22.85.85,0,0,0-.45.13l-.05,0-1,.6a1,1,0,0,1,.68,0,2.66,2.66,0,0,1,.4.17,3.56,3.56,0,0,1,1.6,2.78,1.86,1.86,0,0,1,0,.42.9.9,0,0,1-.38.58l1.07-.61h0l.09-.05,0,0a1.17,1.17,0,0,0,.39-1A3.52,3.52,0,0,0,98.59,286.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.29,284.7a2.72,2.72,0,0,1,0,.42,1,1,0,0,1-.38.59h0a1.1,1.1,0,0,1-1.16-.09,3.55,3.55,0,0,1-1.61-2.78,1.16,1.16,0,0,1,.45-1h0l.08-.05h0a1,1,0,0,1,.68,0,2,2,0,0,1,.4.18A3.54,3.54,0,0,1,110.29,284.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85,281.25a1.47,1.47,0,0,0-.71-.21.84.84,0,0,0-.45.12l0,0-1,.59a1,1,0,0,1,.68,0,2,2,0,0,1,.4.18,3.54,3.54,0,0,1,1.6,2.77,2.72,2.72,0,0,1,0,.42,1,1,0,0,1-.38.59l1.06-.62h0L111,285l0,0a1.16,1.16,0,0,0,.4-1A3.55,3.55,0,0,0,109.85,281.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,277.93a2.5,2.5,0,0,1,0,.42,1,1,0,0,1-.38.59h0a1.1,1.1,0,0,1-1.16-.09,3.53,3.53,0,0,1-1.61-2.78,1.12,1.12,0,0,1,.46-1h0l.08,0h0a1,1,0,0,1,.69,0,2.1,2.1,0,0,1,.39.17A3.54,3.54,0,0,1,88.52,277.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.08,274.49a1.39,1.39,0,0,0-.71-.22.85.85,0,0,0-.45.13l0,0-1,.6a1,1,0,0,1,.69,0,2.1,2.1,0,0,1,.39.17,3.54,3.54,0,0,1,1.6,2.77,2.5,2.5,0,0,1,0,.42,1,1,0,0,1-.38.59l1.06-.61h0l.09-.06h0a1.18,1.18,0,0,0,.4-1A3.53,3.53,0,0,0,88.08,274.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.09 274.55 103.82 272.9 103.82 274.13 98.09 277.43 98.09 274.55",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.09 274.55 97.53 274.2 103.27 272.63 103.82 272.9 98.09 274.55",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.62 278.19 87.5 275.15 87.5 273.92 95.62 274.64 95.62 278.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.5 273.92 88.1 273.76 96.1 274.27 95.62 274.64 87.5 273.92",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4,277.8c0,.92,2.82.92,2.82,0V267.16H95.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.52,275.71l1.55,10.08H98l-1.45-10.08A1.65,1.65,0,0,0,97.52,275.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.56 275.71 96.56 278.48 98.01 287.5 98.01 285.79 96.56 275.71",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.01,
    y: 285.79,
    width: 1.06,
    height: 1.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.07 278.4 85.61 283.89 85.61 282.2 96.07 275.72 96.07 278.4",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07,275.72a1.14,1.14,0,0,1-.67-.3L85,281.76l.66.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.61 283.89 85.61 282.2 84.95 281.76 84.95 283.39 85.61 283.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.27 281.95 98.09 278.12 98.09 275.61 109.27 280.26 109.27 281.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.09,275.61c.09,0,.13-.19.13-.44l11.38,4.95-.33.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.6 280.12 109.6 281.76 109.27 281.95 109.27 280.26 109.6 280.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.01,
    y: 285.79,
    width: 1.06,
    height: 1.71,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.61 283.89 85.61 282.2 84.95 281.76 84.95 283.39 85.61 283.89",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.6 280.12 109.6 281.76 109.27 281.95 109.27 280.26 109.6 280.12",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.79,259.85h-4v11.53c0,1.14,4,1.14,4,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.84,258.32v1.07l-17.37,10a2.27,2.27,0,0,1-2.23,0l-17.37-10v-1.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.21,
    y: 243.74,
    width: 1.85,
    height: 9.18,
    transform: "translate(212.26 496.66) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,241.68l9.68,5.59-3.7,2.13L101,243l2.3-1.32A2.77,2.77,0,0,1,106.15,241.68Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,241.68l9.68,5.59-3.7,2.13L101,243l2.3-1.32A2.77,2.77,0,0,1,106.15,241.68Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.04 243.99 101.04 243 112.13 249.4 112.13 250.4 101.04 243.99",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.04 243.99 101.04 243 112.13 249.4 112.13 250.4 101.04 243.99",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.83 247.27 115.83 248.26 112.13 250.4 112.13 249.4 115.83 247.27",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.83 247.27 115.83 248.26 112.13 250.4 112.13 249.4 115.83 247.27",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.14,252.79a1.68,1.68,0,0,0,.85-1.56L89.56,245c0-.46-.39-.64-.81-.41l-3.12,1.74a1.45,1.45,0,0,0-.7,1.25l.43,6.36a1.66,1.66,0,0,1-.86,1.57l1.86-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.62,253a1.67,1.67,0,0,0,.85-1.56L90,245.16c0-.46-.39-.64-.81-.41l-3.12,1.74a1.45,1.45,0,0,0-.7,1.25l.44,6.36a1.65,1.65,0,0,1-.87,1.56l1.86-1.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,258.32l17.35,10a2.28,2.28,0,0,0,2.26,0l17.36-10a3.69,3.69,0,0,0-1.85-3.2l-1.56-.9-.29-.17-12.7-7.33a4.16,4.16,0,0,0-4.18,0l-14.54,8.4,0,0s0,0,0,0A3.67,3.67,0,0,0,77.87,258.32Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.84,258.32a3.69,3.69,0,0,0-1.85-3.2l-1.56-.9c2.18,1.29,3.08,2.15,1.55,3l-15.46,8.93a2.29,2.29,0,0,1-1.16.31v2.14a2.29,2.29,0,0,0,1.16-.31Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.19,266.18c-2.92-1.69-10.54-6.1-13.63-7.86s-2.21-2.92-1.91-3.15a3.67,3.67,0,0,0-1.78,3.15l17.31,10a2.37,2.37,0,0,0,1.18.31v-2.14A2.3,2.3,0,0,1,95.19,266.18Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.05,216.4l-1.24-.63a2.92,2.92,0,0,0-2.72.32l-9.2,5.3a7.41,7.41,0,0,0-3.45,6.3L76,250.59l1.25.63,16.67-9.62-1.56-22.89A2.59,2.59,0,0,0,91.05,216.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.34,233.15l-1-14.44a2.59,2.59,0,0,0-1.31-2.31l-1.24-.63a2.92,2.92,0,0,0-2.72.32l-9.2,5.3a7.06,7.06,0,0,0-2.59,2.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.05,216.4a2.87,2.87,0,0,0-2.71.31l-9.2,5.3a7.41,7.41,0,0,0-3.45,6.3l1.56,22.91,1.71.84,16.67-9.62-1.56-22.89a2.58,2.58,0,0,0-1.26-2.28C92.51,217.11,91.34,216.54,91.05,216.4Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.55,224.82a6.64,6.64,0,0,0-.86,3.49l1.56,22.91,1.71.84,16.67-9.62L95.06,234Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.07,219.55a2.58,2.58,0,0,0-1.26-2.28c-.3-.16-1.47-.73-1.76-.87a2.87,2.87,0,0,0-2.71.31l-9.2,5.3a7.12,7.12,0,0,0-2.59,2.81L95.06,234Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,252.06l-1.56-22.9a7.43,7.43,0,0,1,3.45-6.3l9.2-5.3c2.07-1.19,3.87-.3,4,2l1.56,22.89Z",
    style: {
      fill: "#10E2ED"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.66,264.44l3.75-4.88,5.82,4.29c-3.88,2.63-8.15,5.92-9.2,7.18,0,0-3.31-1.4-3.53-3.26S104.63,264.86,105.66,264.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.38,265.84a2.93,2.93,0,0,0-.91.69c-.29.29-.52,1.9-.87,2.6a20.27,20.27,0,0,1-1.08,1.73,5.47,5.47,0,0,0-1.15,4.56,7.5,7.5,0,0,0,2.39,5.16,2.92,2.92,0,0,0,1.28.57s1.55-.27,1.49-1.18S101.38,265.84,101.38,265.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.22,269.93c-.09.27-.55.62-.75.81a7.27,7.27,0,0,0-1.43,2.47c-1.64,4-.37,6.46-2.92,7.61-.73.29-2.06-.07-3.63-3.09a7.63,7.63,0,0,1-.24-5.61c.65-1.18,1.36-1.89,1.8-2.81s.65-2.74,1.33-3.47a3.94,3.94,0,0,1,1.52-.88c.45-.17,1.38-.33,1.83-.48s.73-.38.93,0l-.58.5c-.92.88-.74,1.07-.83,1.61a7.91,7.91,0,0,1-.59,1.67c.64-.56,1-1.09,1.52-.89s.62.2,1.3,1.11S107.3,269.7,107.22,269.93Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.22,269.93c-.09.27-.55.62-.75.81a7.27,7.27,0,0,0-1.43,2.47c-1.64,4-.37,6.46-2.92,7.61-.73.29-2.06-.07-3.63-3.09a7.63,7.63,0,0,1-.24-5.61c.65-1.18,1.36-1.89,1.8-2.81s.65-2.74,1.33-3.47a3.94,3.94,0,0,1,1.52-.88c.45-.17,1.38-.33,1.83-.48s.73-.38.93,0l-.58.5c-.92.88-.74,1.07-.83,1.61a7.91,7.91,0,0,1-.59,1.67c.64-.56,1-1.09,1.52-.89s.62.2,1.3,1.11S107.3,269.7,107.22,269.93Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.49,277.73a7.63,7.63,0,0,1-.24-5.61c.24-.43.48-.79.71-1.13l-.1.24c0,.15-.11.31-.15.47a3.89,3.89,0,0,0-.15,1.94c.14.57.45,2,1.14,2.14a1.09,1.09,0,0,0,1-.65c.1-.18.3-.67.3-.67a6.29,6.29,0,0,1,1.69,1.09c.9.87.83,1,.83,1a3.05,3.05,0,0,0-.2.89,2.47,2.47,0,0,0,.21,1,1.84,1.84,0,0,0,.23.25,2.78,2.78,0,0,1-1.69,2.15C101.39,281.11,100.06,280.75,98.49,277.73Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,273.21a14.27,14.27,0,0,0-.89,3.3c-.58,1-.91.9-.86.34a33.29,33.29,0,0,1,2.14-4.54A9.8,9.8,0,0,0,105,273.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.74,266a2.42,2.42,0,0,1,.7-1.46,1.71,1.71,0,0,0,.29-.08c.49-.17.73-.38.93,0l-.58.5c-.92.88-.74,1.07-.83,1.61a7.91,7.91,0,0,1-.59,1.67,31,31,0,0,0-1.79,4c-.52,1.68-.39,2.89-.65,2.95s-.72-.24-.55-1.63a14.65,14.65,0,0,1,1.84-4.61A7.53,7.53,0,0,0,103.74,266Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,274.56a.16.16,0,0,0,.08.06,4.22,4.22,0,0,1,2.45,2.12.17.17,0,1,0,.3-.17,4.5,4.5,0,0,0-2.62-2.27.17.17,0,0,0-.22.1A.15.15,0,0,0,100.9,274.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.39,273.17s0,.05.07.06a4.66,4.66,0,0,1,2.57,2.3.18.18,0,0,0,.31-.18,5.1,5.1,0,0,0-2.73-2.45.19.19,0,0,0-.24.1A.21.21,0,0,0,101.39,273.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.65,271.58a.24.24,0,0,0,.09.08,5.31,5.31,0,0,1,2.86,2.57.2.2,0,0,0,.27.07.19.19,0,0,0,.07-.27,5.7,5.7,0,0,0-3-2.74.21.21,0,0,0-.26.11A.22.22,0,0,0,101.65,271.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13,270.28a.27.27,0,0,0,.08.07,5.21,5.21,0,0,1,2.81,2.51.2.2,0,0,0,.26.08.21.21,0,0,0,.07-.27,5.5,5.5,0,0,0-3-2.67.19.19,0,0,0-.26.1A.22.22,0,0,0,102.13,270.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,269.06a.27.27,0,0,0,.08.07,5.14,5.14,0,0,1,2.8,2.52.2.2,0,0,0,.34-.2,5.5,5.5,0,0,0-3-2.67.2.2,0,0,0-.26.09A.21.21,0,0,0,102.87,269.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.45,244s13.52,2.25,18.69,4.53,4.76,5.83,2.68,8c-4,4.2-15.13,10.67-15.13,10.67s-3.19-2-3.44-4.92l3.1-4.38-11.21-1.37-1.59-1.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.06,262.67c-.79-1.85-1.5-2.42-3.46-3.74l-2.35,3.33c.25,3,3.44,4.92,3.44,4.92s1.3-.89,3.18-2.24A21.82,21.82,0,0,0,113.06,262.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.31,253.49c-1,.85-1.83,1.63-2.58,2.39s-2.48.76-4,0a32.45,32.45,0,0,1-5.13-3.5,5.84,5.84,0,0,0,1.05-4.81,6.25,6.25,0,0,1-1.91,4.13l-.95.67-.34,2.94.53,1.15,11.4,1.42c3.13-4.07,4.21-5.93,6.83-6.25C117.18,251.63,115.19,251,112.31,253.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.39,285.8l-.16-.54-3.65-9.45,6.88-2.58c.9,4.87,2,11.28,3.05,13,0,0-1.87,2.89-3.71,2.56A3,3,0,0,1,110.39,285.8Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.63,289.25a2.92,2.92,0,0,0,.39,1.08c.19.36,1.67,1.05,2.23,1.59s.67.78,1.35,1.53a5.43,5.43,0,0,0,4,2.44,7.45,7.45,0,0,0,5.63-.78,2.91,2.91,0,0,0,.92-1.05s.19-1.57-.69-1.77S110.63,289.25,110.63,289.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.24,284.87a3.1,3.1,0,0,1,.56.95,7.42,7.42,0,0,0,1.94,2.09c3.37,2.74,6.08,2.24,6.43,5,.07.78-.67,1.95-4,2.56a7.57,7.57,0,0,1-5.43-1.41c-.94-1-1.41-1.85-2.16-2.54s-2.44-1.42-2.93-2.29a4,4,0,0,1-.4-1.71c0-.47,0-2.08,0-2.08.58,1.14,1.47,1,2,1.26a9.06,9.06,0,0,1,1.43,1c-.35-.78-.77-1.24-.41-1.71s.37-.54,1.45-.92S116,284.72,116.24,284.87Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.24,284.87a3.1,3.1,0,0,1,.56.95,7.42,7.42,0,0,0,1.94,2.09c3.37,2.74,6.08,2.24,6.43,5,.07.78-.67,1.95-4,2.56a7.57,7.57,0,0,1-5.43-1.41c-.94-1-1.41-1.85-2.16-2.54s-2.44-1.42-2.93-2.29a4,4,0,0,1-.4-1.71c0-.47,0-2.08,0-2.08.58,1.14,1.47,1,2,1.26a9.06,9.06,0,0,1,1.43,1c-.35-.78-.77-1.24-.41-1.71s.37-.54,1.45-.92S116,284.72,116.24,284.87Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.15,295.49a7.57,7.57,0,0,1-5.43-1.41,10.68,10.68,0,0,1-.87-1l.19.16.41.28a3.69,3.69,0,0,0,1.82.71c.58,0,2,.16,2.37-.47a1,1,0,0,0-.32-1.18c-.14-.15-.55-.49-.55-.49a6.54,6.54,0,0,1,1.54-1.3c1.09-.6,1.21-.5,1.21-.5a2.54,2.54,0,0,0,.79.45,2.27,2.27,0,0,0,1,.08,1.69,1.69,0,0,0,.31-.13,2.76,2.76,0,0,1,1.56,2.24C125.24,293.71,124.5,294.88,121.15,295.49Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.74,287.91a14.41,14.41,0,0,0,2.9,1.81c.78.85.6,1.14.07.92a33.66,33.66,0,0,1-3.71-3.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.49,287.05a3.16,3.16,0,0,1-1.28-.64c-.24-.22-.08-.86,0-1.15l.18.58a6.12,6.12,0,0,0,1.73.88,9.06,9.06,0,0,1,1.43,1,31.32,31.32,0,0,0,3.26,2.87c1.45,1,2.66,1.22,2.63,1.49s-.43.61-1.72,0a14.43,14.43,0,0,1-3.87-3.1A7.57,7.57,0,0,0,111.49,287.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,292.26a.16.16,0,0,0,.08-.06,4.22,4.22,0,0,1,2.74-1.72.17.17,0,0,0-.08-.34,4.52,4.52,0,0,0-2.93,1.84.18.18,0,0,0,0,.25A.17.17,0,0,0,118.83,292.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.64,291.39l.08-.05a4.71,4.71,0,0,1,2.94-1.79.17.17,0,0,0,.14-.21.19.19,0,0,0-.22-.14,5,5,0,0,0-3.13,1.9.17.17,0,0,0,0,.25A.16.16,0,0,0,117.64,291.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.2,290.68a.31.31,0,0,0,.09-.07,5.33,5.33,0,0,1,3.3-2,.21.21,0,0,0,.15-.24.21.21,0,0,0-.24-.15,5.7,5.7,0,0,0-3.51,2.12.2.2,0,0,0,0,.28A.27.27,0,0,0,116.2,290.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.09,289.84a.15.15,0,0,0,.09-.06,5.21,5.21,0,0,1,3.23-1.95.19.19,0,1,0-.09-.37,5.52,5.52,0,0,0-3.43,2.07.19.19,0,0,0,0,.27A.23.23,0,0,0,115.09,289.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.14,288.77a.15.15,0,0,0,.09-.06,5.16,5.16,0,0,1,3.23-1.94.2.2,0,0,0-.09-.38,5.61,5.61,0,0,0-3.43,2.07.19.19,0,0,0,0,.27A.17.17,0,0,0,114.14,288.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.53,281.87c-1.81,1.88-6.16,1.74-6.16,1.74s-1.25-2.39-3.5-7.61a24.18,24.18,0,0,1-2.5-8.32,120.29,120.29,0,0,1-15.1-8.15c-4.19-2.7-4.59-6.27-5-14.12L104.45,244c-.33,2.41-3.18,6.74-5.69,8.42,0,0,8.08,5.79,10.8,7.86,1.25.95,1.85,1.26,2.45,4.14C113.77,272.8,115.53,281.87,115.53,281.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.33,283.59l.36,0A88.91,88.91,0,0,1,106.42,273c-.25-.78-.77-3-.93-3.6-.74-2.9-.84-4-1.64-4.22-.2-.07-.64-.33-1.33-.67-3.49-1.73-12-6-14.87-8.77l-.24-.25c1.47-.85,1.92-3.1,1.39-4.7s-.53-4.8.37-6.07l-.26-.18c-1,1.48-1,4.75-.41,6.35s0,3.64-1.33,4.36c-2.72-2.91-3.43-6.91-2-11.64l-.31-.09c-1.52,5.12-.63,9.42,2.59,12.45,3,2.78,11.45,7.09,14.95,8.83.66.32,1.14.56,1.32.66.76.41,1,2.4,1.47,4.07.16.61.68,2.8,1,3.59A103.75,103.75,0,0,0,110.33,283.59Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "87.03 255.57 88.88 255.57 88.88 264.75 87.07 264.19 87.03 255.57",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,253.51l9.68,5.59L94,261.23l-11.09-6.4,2.29-1.32A2.82,2.82,0,0,1,88,253.51Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,253.51l9.68,5.59L94,261.23l-11.09-6.4,2.29-1.32A2.82,2.82,0,0,1,88,253.51Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.87 255.82 82.87 254.83 93.96 261.23 93.96 262.23 82.87 255.82",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.87 255.82 82.87 254.83 93.96 261.23 93.96 262.23 82.87 255.82",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.65 259.1 97.65 260.09 93.96 262.23 93.96 261.23 97.65 259.1",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.65 259.1 97.65 260.09 93.96 262.23 93.96 261.23 97.65 259.1",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.91,247.07v44.34a.49.49,0,0,1-.21.37l-.46.26a.45.45,0,0,1-.42,0l-.45-.26a.47.47,0,0,1-.22-.37V247.07c0-.14.1-.19.22-.13l.45.26a.45.45,0,0,0,.42,0l.46-.26C178.81,246.88,178.91,246.93,178.91,247.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.82,292l-.45-.26a.47.47,0,0,1-.22-.37V247.07c0-.14.1-.19.22-.13l.45.26a.48.48,0,0,1,.21.37v44.35C178,292.05,177.94,292.11,177.82,292Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.03 285.54 159.09 296.46 159.09 258.07 178.03 247.14 178.03 285.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.03 249.09 178.03 250.07 159.09 260.99 159.09 260.02 178.03 249.09",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.03 260.92 178.03 261.89 159.09 272.81 159.09 271.85 178.03 260.92",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.03 272.74 178.03 273.71 159.09 284.64 159.09 283.66 178.03 272.74",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.03 284.56 178.03 285.54 159.09 296.46 159.09 295.49 178.03 284.56",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.09 296.46 130.39 279.89 130.38 241.5 159.09 258.07 159.09 296.46",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.26,241.24v44.34a.46.46,0,0,1-.21.37l-.45.26a.47.47,0,0,1-.43,0l-.45-.26a.49.49,0,0,1-.21-.37V241.24c0-.14.1-.19.21-.12l.45.26a.47.47,0,0,0,.43,0l.45-.26C131.17,241.05,131.26,241.1,131.26,241.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,286.21l-.45-.26a.49.49,0,0,1-.21-.37V241.24c0-.14.1-.19.21-.12l.45.26a.47.47,0,0,1,.22.37v44.34C130.39,286.23,130.29,286.28,130.17,286.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46,271.34l-28.07-16.2v-1l.87-.5,28.08,16.2a.13.13,0,0,1,0,.25l-.45.26a.47.47,0,0,0-.22.37v.52C158.67,271.36,158.58,271.41,158.46,271.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.39,254.12l.87-.5h0l28.08,16.2a.13.13,0,0,1,0,.25l-.45.26a.47.47,0,0,1-.43,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,257.81v44.34a.46.46,0,0,1-.21.37l-.45.26a.47.47,0,0,1-.43,0l-.45-.26a.49.49,0,0,1-.21-.37V257.81c0-.14.1-.19.21-.12l.45.26a.54.54,0,0,0,.43,0l.45-.26C159.87,257.62,160,257.67,160,257.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.87,302.78l-.45-.26a.49.49,0,0,1-.21-.37V257.81c0-.14.1-.19.21-.12l.45.26a.45.45,0,0,1,.22.36v44.35C159.09,302.79,159,302.85,158.87,302.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.05,262.69v48.17a.54.54,0,0,1-.23.4l-.49.28a.49.49,0,0,1-.47,0l-.49-.28a.54.54,0,0,1-.23-.4V262.69c0-.15.11-.21.23-.14l.49.29a.55.55,0,0,0,.47,0l.49-.29C93.94,262.48,94.05,262.54,94.05,262.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.86,311.54l-.49-.28a.54.54,0,0,1-.23-.4V262.69c0-.15.11-.21.23-.14l.49.29a.49.49,0,0,1,.23.4v48.17C93.09,311.56,93,311.62,92.86,311.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,293.33,93.09,277.79v-1.1l1-.55L121,291.68a.15.15,0,0,1,0,.27l-.5.28a.52.52,0,0,0-.23.4v.57C120.23,293.35,120.13,293.4,120,293.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.09,276.69l1-.55h0L121,291.68a.15.15,0,0,1,0,.27l-.5.28a.53.53,0,0,1-.46,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.64,278.62v48.17a.5.5,0,0,1-.24.4l-.49.29a.53.53,0,0,1-.46,0l-.49-.29a.49.49,0,0,1-.23-.4V278.62c0-.15.1-.21.23-.13l.49.28a.47.47,0,0,0,.46,0l.49-.28C121.53,278.41,121.64,278.47,121.64,278.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.45,327.48l-.49-.29a.49.49,0,0,1-.23-.4V278.62c0-.15.1-.21.23-.13l.49.28a.51.51,0,0,1,.23.4v48.17C120.68,327.49,120.58,327.55,120.45,327.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.31,246.61v-.15a.86.86,0,0,0-.39-.67l-29.5-17a.89.89,0,0,0-.78,0L90.8,262.17a.86.86,0,0,0-.39.67V263a.86.86,0,0,0,.39.67l29.5,17a.89.89,0,0,0,.78,0l57.84-33.4A.86.86,0,0,0,179.31,246.61Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.31,246.61v-.15a.86.86,0,0,0-.39-.67l-29.5-17a.89.89,0,0,0-.78,0L90.8,262.17a.86.86,0,0,0-.39.67V263a.86.86,0,0,0,.39.67l29.5,17a.89.89,0,0,0,.78,0l57.84-33.4A.86.86,0,0,0,179.31,246.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.69,279.72v1a.83.83,0,0,0,.39-.09l57.84-33.4a.87.87,0,0,0,.39-.67v-.15a.86.86,0,0,0-.32-.62c.14.12.12.28-.07.39l-57.84,33.4A.83.83,0,0,1,120.69,279.72Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.69,279.72v1a.83.83,0,0,0,.39-.09l57.84-33.4a.87.87,0,0,0,.39-.67v-.15a.86.86,0,0,0-.32-.62c.14.12.12.28-.07.39l-57.84,33.4A.83.83,0,0,1,120.69,279.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.92,246.23l-57.84,33.4a.89.89,0,0,1-.78,0l-29.5-17a.23.23,0,0,1,0-.44l57.84-33.4a.89.89,0,0,1,.78,0l29.5,17A.23.23,0,0,1,178.92,246.23Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.92,246.23l-57.84,33.4a.89.89,0,0,1-.78,0l-29.5-17a.23.23,0,0,1,0-.44l57.84-33.4a.89.89,0,0,1,.78,0l29.5,17A.23.23,0,0,1,178.92,246.23Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.37,246.77,159,255.57a.33.33,0,0,1-.17,0,.34.34,0,0,1-.18,0l-19.1-11a.12.12,0,0,1,0-.22l15.4-8.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67,244.3a.35.35,0,0,0,.17.27l17.83,10.28a.33.33,0,0,0,.32,0l13.91-7.95,0-.33-18.15-10.48L140.81,244A.35.35,0,0,0,140.67,244.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.88,246.57,159,254.51a.27.27,0,0,1-.16,0,.29.29,0,0,1-.16,0l-17.83-10.29a.11.11,0,0,1,0-.2l13.91-7.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.88,246.57l0,.33L159,254.85a.29.29,0,0,1-.16,0l0-.34a.27.27,0,0,0,.16,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.67 246.7 154.51 236.23 154.29 231.78 172.45 242.31 172.67 246.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.74,241.91a.49.49,0,0,0-.18.37l.05.9a.5.5,0,0,0,.22.36l17.74,10.24a.43.43,0,0,0,.4,0l11.77-7.18-.07-1.39-18.15-10.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.52,234.72l-11.78,7.19a.13.13,0,0,0,0,.24l17.74,10.24a.43.43,0,0,0,.4,0l11.77-7.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.13,245.34l.14,0a.49.49,0,0,0,.21,0l.07,0c.11-.07.09-.18,0-.26a.46.46,0,0,0-.2-.05.4.4,0,0,0-.22,0l0,0C169,245.17,169,245.27,169.13,245.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.71,252.44l.07,1.38a.36.36,0,0,1-.21,0l-17.74-10.24a.48.48,0,0,1-.22-.36l-.05-.9a.52.52,0,0,1,.14-.33c-.06.06,0,.15.06.2l17.74,10.24A.46.46,0,0,0,158.71,252.44Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.16,243.38a.75.75,0,0,0-.82.06,3,3,0,0,0-1,1.79l.28,0a2.63,2.63,0,0,1,.9-1.58.7.7,0,0,1,.34-.12.42.42,0,0,1,.21.06,1.2,1.2,0,0,1,.38,1,3,3,0,0,1-1,2.33.59.59,0,0,1-.41.12l-.28.18,0,0a.68.68,0,0,0,.35.09.85.85,0,0,0,.46-.16,3.22,3.22,0,0,0,1.12-2.58A1.46,1.46,0,0,0,171.16,243.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.53,241.48a.37.37,0,0,0,.17.27L158.53,252a.34.34,0,0,0,.31,0l13.83-9.55v-.34l-18.15-10.47-13.84,9.54A.35.35,0,0,0,140.53,241.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.66,242.14l-13.83,9.55a.32.32,0,0,1-.16,0,.38.38,0,0,1-.16,0l-17.83-10.29a.11.11,0,0,1,0-.2l13.84-9.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.66,242.14v.34L158.85,252a.32.32,0,0,1-.16,0l0-.34a.32.32,0,0,0,.16,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.88 246.57 172.66 242.15 172.45 242.31 172.67 246.7 172.88 246.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.14,242.09a.31.31,0,0,0,.14-.23c0-.08,0-.34,0-.34l-17.54-9.93a.76.76,0,0,0-.73,0l-13.67,8.9L158.48,251Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.14,242.09a.31.31,0,0,0,.14-.23c0-.08,0-.34,0-.34l-17.54-9.93a.76.76,0,0,0-.73,0l-13.67,8.9L158.48,251Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.12,241.75a.24.24,0,0,0,0-.45l-17.4-10a.76.76,0,0,0-.73,0l-13.66,8.91,18.15,10.47Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.12,241.75a.24.24,0,0,0,0-.45l-17.4-10a.76.76,0,0,0-.73,0l-13.66,8.91,18.15,10.47Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.44,237.86l10.11-6.59a.76.76,0,0,1,.73,0l16.16,9.33,1.31-.86.09,1.7,0,0a.24.24,0,0,1-.11.31l-11.58,7.54L142,238.82l-.09-1.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.61,239.88a.25.25,0,0,0,0-.45l-17.4-10a.76.76,0,0,0-.73,0L141.87,237,160,247.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.02 247.43 160.12 249.29 141.96 238.82 141.87 236.95 160.02 247.43",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.79,246.7l.14.05a.41.41,0,0,0,.22,0l.06,0c.11-.06.09-.18,0-.25a.7.7,0,0,0-.19-.06.34.34,0,0,0-.23,0l0,0C159.65,246.53,159.67,246.63,159.79,246.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,248.2a1.06,1.06,0,0,0,.21.64.65.65,0,0,0,.54.25h0a.94.94,0,0,0,.5-.17l.09-.06-.21-.12c-.48.3-.89.06-.92-.55a2.09,2.09,0,0,1,.81-1.68.56.56,0,0,1,.68,0,.47.47,0,0,1,.2.28.41.41,0,0,0,.22,0,1.08,1.08,0,0,0-.17-.34.69.69,0,0,0-.54-.25.94.94,0,0,0-.5.17A2.27,2.27,0,0,0,158,248.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46,246.42l13.67-7.54v.24a.42.42,0,0,1-.17.34l-13.49,7.3Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46,246.42l13.67-7.54v.24a.42.42,0,0,1-.17.34l-13.49,7.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,239.11a.24.24,0,0,0,0-.45l-17.39-10a.76.76,0,0,0-.73,0l-13.74,7.45,18.15,10.47Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.48 250.99 140.32 240.51 140.1 236.07 158.25 246.55 158.48 250.99",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.48 250.99 140.32 240.51 140.1 236.07 158.25 246.55 158.48 250.99",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.12,248.2a.65.65,0,0,0,.52-.28,1.08,1.08,0,0,0,.15-.65,2.48,2.48,0,0,0-1.11-1.84,1.06,1.06,0,0,0-.51-.15c-.43,0-.7.38-.67.92a2.45,2.45,0,0,0,1.11,1.84,1,1,0,0,0,.51.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.58,247.28c0,.61-.36.87-.88.57a2.27,2.27,0,0,1-1-1.65c0-.61.36-.87.88-.57A2.27,2.27,0,0,1,155.58,247.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.18,245.11l0,.33c0,.67-.4,1-1,.63l-8.65-5a2.47,2.47,0,0,1-1.08-1.81l0-.34c0-.67.4-1,1-.62l8.65,5A2.43,2.43,0,0,1,152.18,245.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.69 250.85 158.47 246.44 158.25 246.55 158.48 250.99 158.69 250.85",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.69 250.85 158.47 246.44 158.25 246.55 158.48 250.99 158.69 250.85",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebook--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.77,270.51a1.15,1.15,0,0,0,.59-.15l9-5.17-12.8-7.39-8.16,4.71a.92.92,0,0,0,0,1.6l10.82,6.25A1.2,1.2,0,0,0,107.77,270.51Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.88,258.72,96.67,263l-.16.27v.21a.32.32,0,0,0,.16.27L107.49,270a.53.53,0,0,0,.28.07.49.49,0,0,0,.28-.07l8-4.63v-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.77,269.89a.64.64,0,0,1-.28-.07l-10.82-6.25a.3.3,0,0,1-.16-.26.33.33,0,0,1,.16-.27l7.85-4.53,11.56,6.68-8,4.63A.58.58,0,0,1,107.77,269.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.52,257.89l-7.76,4.48-.08.11v.83h0a.14.14,0,0,0,.08.11l10.82,6.25a.45.45,0,0,0,.39,0l7.75-4.48v-.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,264.35l-.09.06-1.27.73-.23.14L108,268.83a.45.45,0,0,1-.39,0l-10.82-6.24a.12.12,0,0,1,0-.22l.11-.06,7.65-4.42,11.11,6.41h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.77,268.88v.83a.38.38,0,0,1-.19,0l-10.82-6.25a.14.14,0,0,1-.08-.11v-.83a.14.14,0,0,0,.08.11l10.82,6.24A.38.38,0,0,0,107.77,268.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,264.24l-1.39.81-.22.13L108,268.72a.45.45,0,0,1-.39,0l-9.69-5.59-.24-.14a2.48,2.48,0,0,1-.78-.68l0,0s0,0,0-.06A.18.18,0,0,1,97,262a3.13,3.13,0,0,0,.73-.3h0l6.82-3.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.28,264.15a.1.1,0,0,0,0,.2.38.38,0,0,0,.36,0,.1.1,0,0,0,0-.2A.38.38,0,0,0,114.28,264.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.43,263.47a.45.45,0,0,0-.48,0,1.46,1.46,0,0,0-.61.87l.13,0a1.39,1.39,0,0,1,.55-.78.47.47,0,0,1,.22-.07.22.22,0,0,1,.13,0,.49.49,0,0,1,.18.44.41.41,0,0,1,0,.11l.13.07a1.09,1.09,0,0,0,0-.18A.62.62,0,0,0,115.43,263.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.66,264.28s0,0,0,0h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.19,263.52c-.1.06-.1.15,0,.21a.38.38,0,0,0,.36,0c.1-.06.1-.15,0-.21A.38.38,0,0,0,113.19,263.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.35,262.85a.48.48,0,0,0-.49,0,1.51,1.51,0,0,0-.6.87.27.27,0,0,0,.13,0,1.34,1.34,0,0,1,.54-.78.49.49,0,0,1,.22-.06.28.28,0,0,1,.13,0,.49.49,0,0,1,.18.45v.1l.12.08a1.1,1.1,0,0,0,0-.18A.61.61,0,0,0,114.35,262.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.11,262.89c-.1.06-.1.15,0,.21a.38.38,0,0,0,.36,0c.1-.06.1-.15,0-.21A.45.45,0,0,0,112.11,262.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.26,262.22a.47.47,0,0,0-.48,0,1.52,1.52,0,0,0-.61.88.29.29,0,0,0,.13,0,1.4,1.4,0,0,1,.55-.77.4.4,0,0,1,.22-.07.22.22,0,0,1,.13,0,.48.48,0,0,1,.18.44.41.41,0,0,1,0,.11l.13.07a1.09,1.09,0,0,0,0-.18A.62.62,0,0,0,113.26,262.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,262.27a.12.12,0,0,0,0,.21.45.45,0,0,0,.36,0c.1-.06.1-.15,0-.21A.38.38,0,0,0,111,262.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.18,261.59a.47.47,0,0,0-.48,0,1.49,1.49,0,0,0-.61.87.3.3,0,0,0,.13,0,1.34,1.34,0,0,1,.54-.78.52.52,0,0,1,.22-.06.28.28,0,0,1,.13,0,.49.49,0,0,1,.19.44s0,.08,0,.11l.13.07a1.09,1.09,0,0,0,0-.18A.63.63,0,0,0,112.18,261.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.94,261.64c-.1.06-.1.15,0,.21a.38.38,0,0,0,.36,0c.1-.06.1-.15,0-.21A.38.38,0,0,0,109.94,261.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1,261a.48.48,0,0,0-.49,0,1.56,1.56,0,0,0-.61.88.32.32,0,0,0,.14,0,1.34,1.34,0,0,1,.54-.77.4.4,0,0,1,.22-.07.28.28,0,0,1,.13,0,.49.49,0,0,1,.18.45v.11l.12.07a1.1,1.1,0,0,0,0-.18A.63.63,0,0,0,111.1,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.86,261a.1.1,0,0,0,0,.2.38.38,0,0,0,.36,0,.1.1,0,0,0,0-.2A.38.38,0,0,0,108.86,261Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,260.34a.47.47,0,0,0-.48,0,1.46,1.46,0,0,0-.61.87l.13,0a1.38,1.38,0,0,1,.54-.78.55.55,0,0,1,.23-.07.33.33,0,0,1,.13,0,.49.49,0,0,1,.18.44.41.41,0,0,1,0,.11l.13.07a1.09,1.09,0,0,0,0-.18A.62.62,0,0,0,110,260.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.77,260.39c-.1.06-.1.15,0,.21a.38.38,0,0,0,.36,0c.1-.06.1-.15,0-.21A.38.38,0,0,0,107.77,260.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.93,259.72a.48.48,0,0,0-.49,0,1.51,1.51,0,0,0-.6.88H108a1.31,1.31,0,0,1,.54-.77.4.4,0,0,1,.22-.07.28.28,0,0,1,.13,0,.49.49,0,0,1,.18.45v.1l.12.08a1.1,1.1,0,0,0,0-.18A.61.61,0,0,0,108.93,259.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.69,259.76c-.1.06-.1.16,0,.21a.38.38,0,0,0,.36,0c.1-.05.1-.15,0-.21A.45.45,0,0,0,106.69,259.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.84,259.09a.47.47,0,0,0-.48,0,1.52,1.52,0,0,0-.61.88l.13,0a1.39,1.39,0,0,1,.55-.78.38.38,0,0,1,.22-.07.22.22,0,0,1,.13,0,.49.49,0,0,1,.18.44.41.41,0,0,1,0,.11l.13.07a1.09,1.09,0,0,0,0-.18A.62.62,0,0,0,107.84,259.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6,259.14a.12.12,0,0,0,0,.21.45.45,0,0,0,.36,0c.1-.06.1-.15,0-.21A.38.38,0,0,0,105.6,259.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.76,258.46a.47.47,0,0,0-.48,0,1.48,1.48,0,0,0-.61.87.27.27,0,0,0,.13,0,1.34,1.34,0,0,1,.54-.78.52.52,0,0,1,.22-.06.28.28,0,0,1,.13,0,.49.49,0,0,1,.19.45s0,.07,0,.1l.13.08c0-.07,0-.13,0-.18A.64.64,0,0,0,106.76,258.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.52,258.51c-.1.06-.1.15,0,.21a.38.38,0,0,0,.36,0c.1-.06.1-.15,0-.21A.38.38,0,0,0,104.52,258.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.68,257.84a.48.48,0,0,0-.49,0,1.56,1.56,0,0,0-.61.88.32.32,0,0,0,.14,0,1.34,1.34,0,0,1,.54-.77.4.4,0,0,1,.22-.07.28.28,0,0,1,.13,0,.52.52,0,0,1,.18.45v.11l.12.07a1.09,1.09,0,0,0,0-.18A.62.62,0,0,0,105.68,257.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.69,267.61a.11.11,0,0,1-.11-.06.13.13,0,0,1,0-.18l6-3.44a.13.13,0,0,1,.18,0,.14.14,0,0,1,0,.18l-6,3.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,267.19a.14.14,0,0,1-.12-.06.13.13,0,0,1,.05-.17l6-3.45a.13.13,0,0,1,.18.05.13.13,0,0,1,0,.17l-6,3.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.24,266.78a.15.15,0,0,1-.11-.07.13.13,0,0,1,.05-.17l6-3.45a.13.13,0,0,1,.13.23l-6,3.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.52,266.36a.13.13,0,0,1-.06-.24l6-3.45a.13.13,0,1,1,.13.23l-6,3.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.8,265.94a.11.11,0,0,1-.11-.06.13.13,0,0,1,0-.18l6-3.44a.13.13,0,0,1,.18,0,.14.14,0,0,1,0,.18l-6,3.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.07,265.53a.15.15,0,0,1-.11-.07.13.13,0,0,1,.05-.17l6-3.45a.13.13,0,0,1,.17.05.12.12,0,0,1,0,.17l-6,3.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.35,265.11a.12.12,0,0,1-.11-.07.13.13,0,0,1,.05-.17l6-3.45a.13.13,0,0,1,.17.05.13.13,0,0,1-.05.18l-6,3.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.63,264.69a.13.13,0,0,1-.11-.06.13.13,0,0,1,0-.18l6-3.45a.13.13,0,1,1,.13.23l-6,3.44A.07.07,0,0,1,101.63,264.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.91,264.27a.13.13,0,0,1-.07-.24l6-3.44a.13.13,0,0,1,.18,0,.14.14,0,0,1,0,.18l-6,3.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.18,263.86a.15.15,0,0,1-.11-.07.13.13,0,0,1,.05-.17l6-3.45a.13.13,0,0,1,.17.05.12.12,0,0,1,0,.17l-6,3.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.46,263.44a.13.13,0,0,1-.11-.06.12.12,0,0,1,.05-.18l6-3.45a.14.14,0,0,1,.18.05.14.14,0,0,1-.05.18l-6,3.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.74,263a.11.11,0,0,1-.11-.06.13.13,0,0,1,0-.18l6-3.44a.13.13,0,0,1,.18,0,.14.14,0,0,1,0,.18l-6,3.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,262.6a.13.13,0,0,1-.07-.24l6-3.44a.12.12,0,0,1,.17.05.12.12,0,0,1,0,.17l-6,3.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42,268a.13.13,0,0,1-.11-.06.14.14,0,0,1,0-.18l6.31-3.65a.13.13,0,0,1,.18.05.13.13,0,0,1,0,.17L107.49,268Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.58,263.49a.51.51,0,0,0-.25-.16l-.11-.06c-.06-.09-.13-.23,0-.25a.8.8,0,0,1,.24.07s0,0,0,0-.31-.18-.35,0a.19.19,0,0,0,0,.16.45.45,0,0,0-.16,0c-.05,0-.09,0-.11.07s0,0,0,.07,0,.05,0,.05h-.06c-.07,0-.28-.05-.33.05s0,.09,0,.1l-.17.07s0,.05,0,.06h-.22c-.12,0-.42,0-.38.15,0,0,0,0,0,0s0,0,0,0,0,0,0,0l-.07,0c0,.08,0,.1,0,.14s-.31-.06-.41,0,0,.24-.13.24,0,.06,0,.06.14,0,.16-.14.35-.06.51-.1,0,0,0-.05,0-.11.08-.14,0,0,0,0-.08-.13,0-.18l.17,0h.39s0,0,0,0,.15-.07.19-.08,0,0,0,0c-.08-.2.21-.13.33-.11s0,0,0,0-.17-.13,0-.16a.27.27,0,0,1,.14,0,1,1,0,0,0,.3.31C110.55,263.66,110.67,263.62,110.58,263.49Zm-.06,0c0,.05-.08,0-.09,0s-.11-.11-.15-.17l.09.05A.42.42,0,0,1,110.52,263.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,264.74c0-.08,0-.18.06-.19s0-.05,0-.06-.14.09-.13.21l-.13-.05c-.07,0-.12,0-.14.06s0,.07,0,.11,0,0,0,.05-.08,0-.1,0-.1,0-.15.05.08.06-.08,0a.25.25,0,0,0-.12,0c-.06,0-.09,0-.08.09s.07.07.07.09-.15,0-.21,0,0,0,0,0,0,.09,0,.1-.08,0-.11,0-.12.08-.2.08,0,0,0,0,0,.1-.07.16l-.15,0s0,.06,0,.06.25.08.31,0,0-.12,0-.16.11,0,.12,0l.1,0s0,0,0,0h.07l0-.05s0,0,0,0,.06,0,.09,0,.11.05.15,0,0-.11,0-.16.16,0,.22-.06a0,0,0,0,0,0,0c0-.14.21,0,.28-.05a0,0,0,0,0,0,0l0-.08c0-.08.13-.07.18-.06,0,.17.18.33.32.29l0,0C107.85,264.93,107.72,264.82,107.59,264.74Zm0,.14,0,0s.1.08.1.1S107.66,264.9,107.64,264.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.76,265.63c-.05-.09-.16-.12-.24-.16l-.12-.06c-.06-.09-.13-.23,0-.25a.68.68,0,0,1,.23.07s0,0,0-.05-.31-.18-.35,0a.35.35,0,0,0,0,.17.4.4,0,0,0-.15,0c-.05,0-.1,0-.11.07s0,0,0,.07a.08.08,0,0,0,0,.05h0c-.08,0-.28-.05-.33,0s0,.1,0,.11l-.18.07s0,0,0,0-.17,0-.22,0-.41,0-.37.15c0,0,0,0,0,0a.2.2,0,0,0,0,0l0,0s0,0-.06,0,0,.1,0,.14-.31-.06-.41,0,0,.24-.13.24,0,.06,0,.06.13,0,.16-.14.34-.06.51-.11,0,0,0,0,0-.11.07-.14,0,0,0,0-.08-.13,0-.18l.18,0h.38s0,0,0,0,.15-.07.18-.08,0,0,0,0c-.08-.19.21-.12.34-.1s0,0,0,0-.17-.13,0-.16a.27.27,0,0,1,.13,0,1,1,0,0,0,.31.31C109.73,265.8,109.85,265.76,109.76,265.63Zm-.05,0s-.08,0-.1,0a.46.46,0,0,1-.15-.16l.09.05A.36.36,0,0,1,109.71,265.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6,264.11c0-.09,0-.18.05-.19s0-.06,0-.06-.14.09-.12.2a.43.43,0,0,0-.14,0c-.07,0-.11,0-.14.05s0,.07,0,.11,0,0,0,.06h-.1a.15.15,0,0,0-.15,0c0,.05.08.07-.07,0a.53.53,0,0,0-.13,0s-.08,0-.07.09.06.07.06.08-.15,0-.2,0,0,0,0,0,0,.09,0,.09l-.1,0c-.07,0-.12.08-.21.07s0,0,0,0,.06.1-.07.15l-.14,0s0,.06,0,.06.25.09.31,0,0-.12,0-.16.11,0,.12,0l.1,0s0,0,0,0h.07s0,0,0-.05,0,0,0-.05.06,0,.09,0,.12.05.16,0-.05-.11,0-.15.16,0,.22-.07,0,0,0,0,.21,0,.29,0,0,0,0,0,0-.08,0-.09.13-.07.18-.05.18.33.33.28,0,0,0,0S111.73,264.19,111.6,264.11Zm.05.13s0,0,0,0a.3.3,0,0,1,.1.09C111.76,264.39,111.66,264.27,111.65,264.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17,261.05a.63.63,0,0,0-.24-.16.34.34,0,0,1-.12-.06c-.06-.08-.13-.23,0-.25a.75.75,0,0,1,.23.07s0,0,0,0-.31-.17-.35,0a.1.1,0,1,1-.14.14s-.09,0-.11.06,0,.05,0,.07a.05.05,0,0,0,0,.05h-.06c-.07,0-.28-.05-.32,0s0,.09,0,.11a1,1,0,0,0-.17.07s0,.05,0,.05h-.22c-.12,0-.41,0-.37.15,0,0,0,0,0,0a.06.06,0,0,0,0,0l0,0s0,0-.07,0,0,.09,0,.14-.3-.07-.4,0,0,.24-.14.25,0,.05,0,.05.14,0,.17-.13.34-.07.5-.11,0,0,0,0,0-.11.07-.14,0,0,0,0-.08-.13,0-.17.15,0,.18,0H105s0,0,0,0,.14-.07.18-.08,0,0,0,0c-.08-.2.21-.13.33-.11s0,0,0,0-.17-.14,0-.16a.24.24,0,0,1,.13,0,.81.81,0,0,0,.3.31C106.14,261.23,106.26,261.19,106.17,261.05Zm-.06,0s-.07,0-.09,0-.11-.11-.15-.16l.09,0A.35.35,0,0,1,106.11,261.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.18,262.31c0-.09,0-.18.06-.19s0-.06,0-.06-.14.09-.13.2a.38.38,0,0,0-.13,0c-.07,0-.12,0-.14,0s0,.07,0,.11,0,0,0,.06h-.1a.15.15,0,0,0-.15,0s.08.07-.07,0a.57.57,0,0,0-.13,0s-.08,0-.07.09.06.06.06.08-.15,0-.2,0l0,0c0,.07,0,.1,0,.1l-.1,0c-.07,0-.13.09-.21.08s0,0,0,0,0,.1-.07.15l-.14,0s0,.06,0,.06.25.09.31,0,0-.12,0-.16.11,0,.12,0l.1,0s0,0,0,0,0,0,.07,0a.08.08,0,0,0,0,0s0,0,0-.05.06,0,.09,0,.11.05.15,0,0-.11,0-.15.16,0,.22-.07a0,0,0,0,0,0,0c0-.14.21,0,.28,0l0,0,0-.09c0-.08.13-.07.18-.06,0,.17.18.33.32.29s0,0,0,0A.46.46,0,0,0,103.18,262.31Zm.06.13a.05.05,0,0,1,0,0l.1.1C103.34,262.58,103.25,262.47,103.24,262.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.35,263.19a.45.45,0,0,0-.24-.16L105,263c0-.09-.13-.23,0-.25a.68.68,0,0,1,.23.07s0,0,0-.05-.31-.17-.35,0a.24.24,0,0,0,0,.16l-.16,0s-.09,0-.11.07a.16.16,0,0,0,0,.07.06.06,0,0,0,.05.05h-.05c-.08,0-.28-.06-.33,0s0,.09,0,.1-.15.06-.18.08,0,0,0,0a1.46,1.46,0,0,1-.21,0c-.12,0-.42,0-.38.15,0,0,0,0,0,.05a.1.1,0,0,1,0,0l0,0s-.05,0-.06,0,0,.09,0,.14-.31-.07-.41,0,0,.24-.13.25,0,.05,0,.05.13,0,.16-.14.34-.06.51-.1c0,0,0,0,0,0s0-.11.07-.14,0,0,0,0-.09-.13-.05-.18l.18,0c.13,0,.26,0,.39,0a0,0,0,0,0,0,0s.15-.07.19-.08a0,0,0,0,0,0,0c-.08-.2.22-.13.34-.11s0,0,0,0-.17-.13,0-.15a.24.24,0,0,1,.13,0,.91.91,0,0,0,.31.31C105.32,263.36,105.44,263.32,105.35,263.19Zm0,0s-.08,0-.09,0a.44.44,0,0,1-.16-.17l.09.05A.38.38,0,0,1,105.3,263.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.19,261.67c0-.08,0-.18,0-.19s0-.06,0-.06-.14.09-.12.21a.48.48,0,0,0-.14-.05c-.07,0-.11,0-.14.06s0,.07,0,.11.06,0,0,.05-.07,0-.1,0-.09,0-.14,0,.07.06-.08,0a.25.25,0,0,0-.12,0c-.06,0-.09,0-.08.09s.06.07.06.09-.15,0-.2,0,0,0,0,0,0,.09,0,.1l-.1,0c-.06,0-.12.08-.21.08s0,0,0,0,.06.1-.07.16l-.14,0s0,.05,0,.06.25.08.31,0,0-.13,0-.16.11,0,.12,0l.1,0s0,0,0,0h.07s0,0,0-.05,0,0,0,0,.06,0,.09,0,.12.05.16,0,0-.12,0-.16.16,0,.23-.07,0,0,0,0,.21,0,.29,0,0,0,0,0a.69.69,0,0,0,0-.08c0-.08.13-.07.19-.06,0,.16.18.33.32.28l0,0C107.45,261.86,107.32,261.75,107.19,261.67Zm0,.14,0,0a.31.31,0,0,1,.1.1C107.35,262,107.25,261.83,107.24,261.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.81,264.66a.6.6,0,0,0-.25-.16l-.12-.06c0-.08-.12-.23,0-.25a.68.68,0,0,1,.23.07s0,0,0-.05-.31-.17-.36,0a.23.23,0,0,0,0,.16.3.3,0,0,0-.16,0s-.09,0-.11.06,0,.05,0,.07a.05.05,0,0,0,0,.05h-.06c-.07,0-.28-.05-.33,0s0,.09,0,.11a1,1,0,0,0-.17.07s0,.05,0,.05h-.22c-.12,0-.42,0-.38.15,0,0,0,0,0,.05s0,0,0,0l0,0s0,0-.07,0,0,.09,0,.14-.31-.07-.41,0,0,.24-.13.25,0,.05,0,.05.13,0,.16-.13.35-.07.51-.11a0,0,0,0,0,0,0c0-.07,0-.11.08-.14a0,0,0,0,0,0-.05s-.08-.13,0-.18l.17,0h.39s0,0,0,0,.15-.07.19-.07,0,0,0,0c-.08-.2.22-.13.34-.11a0,0,0,0,0,0,0c0-.07-.16-.14,0-.16a.25.25,0,0,1,.14,0,.81.81,0,0,0,.3.31C105.78,264.84,105.9,264.8,105.81,264.66Zm-.06,0s-.08,0-.09,0-.11-.11-.15-.16l.09,0A.35.35,0,0,1,105.75,264.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.26,263.28c0-.09,0-.18,0-.19s0-.06,0-.06-.14.09-.13.2l-.13,0c-.07,0-.12,0-.14.05s0,.07,0,.11.06,0,0,.06h-.1a.14.14,0,0,0-.14,0c0,.05.08.07-.08,0s-.08,0-.12,0-.09,0-.08.09.07.07.07.08-.15,0-.21,0a0,0,0,0,0,0,0c0,.06,0,.09-.06.09l-.1,0c-.06,0-.12.08-.2.07s0,0,0,0,.06.1-.07.15l-.14,0s0,.06,0,.06.24.09.3,0,0-.12,0-.16.11,0,.13,0l.09,0s0,0,0,0,0,0,.07,0l0,0s0,0,0-.05.06,0,.09,0,.12.05.16,0,0-.11,0-.15.16,0,.23-.07a0,0,0,0,0,0,0c0-.13.2,0,.28,0s0,0,0,0a.47.47,0,0,1,0-.09c0-.08.13-.07.18-.05s.18.33.32.28l0,0C107.52,263.47,107.39,263.35,107.26,263.28Zm0,.13s0,0,0,0a.45.45,0,0,1,.1.1C107.42,263.56,107.32,263.44,107.31,263.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.92,262.16s0,0,0,0-.12,0-.14,0,0,.07,0,.11.06,0,0,.05-.07,0-.1,0-.09,0-.14.05.07.06-.08,0a.25.25,0,0,0-.12,0c-.06,0-.09,0-.08.09s.06.07.06.09-.15,0-.2,0,0,0,0,0,.05.09,0,.1l-.1,0c-.06,0-.12.08-.21.07s0,0,0,0,.06.1-.07.15h-.14s0,.05,0,.06.25.08.31,0,0-.13,0-.16.11,0,.12,0l.1,0s0,0,0,0h.07s0,0,0-.05,0,0,0,0,.06,0,.09,0,.12,0,.16,0,0-.11,0-.15.16,0,.23-.07,0,0,0,0,.2,0,.28,0,0,0,0,0a1,1,0,0,1,0-.17A.08.08,0,0,0,108.92,262.16Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M108.47,257.87l7.14,4.15a.82.82,0,0,0,.76,0l20.07-11.57c.21-.12.21-.31,0-.44l-7.14-4.15a.85.85,0,0,0-.76,0l-20.07,11.57A.23.23,0,0,0,108.47,257.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.89,249.16a.26.26,0,0,0-.16-.22l-6.35-3.66a.85.85,0,0,0-.76,0l-19.38,11.2a.27.27,0,0,0-.15.22v.67a.26.26,0,0,0,.16.22l6.34,3.66a.85.85,0,0,0,.76,0l19.38-11.19a.26.26,0,0,0,.16-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.59,260.57l-6.34-3.65a.23.23,0,0,1,0-.44l19.38-11.2a.85.85,0,0,1,.76,0l6.35,3.66a.23.23,0,0,1,0,.44l-19.38,11.19A.85.85,0,0,1,115.59,260.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,260.66v.68a.71.71,0,0,1-.36-.09l-6.34-3.66a.26.26,0,0,1-.16-.22v-.67a.26.26,0,0,0,.16.22l6.34,3.65A.71.71,0,0,0,116,260.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.25,256.65l.85-.5.63.38-.85.49-.63-.36Zm1,.56.67-.38.63.37-.67.39-.63-.36h0Zm.21-1.25.67-.39.63.38-.67.38-.63-.36Zm.77,1.82,1.09-.62.63.37-1.08.63-.63-.36h0Zm0-1.15.53-.3.63.37-.53.31-.63-.36h0Zm.21-1.25.66-.39.64.38-.67.38-.63-.36h0Zm.66.75.53-.31.63.38-.53.31-.63-.37Zm.09,2.22.85-.49.63.37-.85.5-.63-.37h0Zm.25-3.56,4.84-2.79.63.38-4.83,2.79-.63-.36h0Zm.18,2.17.54-.3.63.37-.53.31-.63-.36h0Zm.35-1.33.53-.31.63.38-.53.3-.63-.36Zm.2,3.29.53-.31.64.38-.54.3-.62-.36Zm.21-1.26.53-.3.63.37L115,258l-.63-.36h0Zm.12-1.2.53-.31.63.38-.53.31-.63-.37h0Zm.34-1.34.53-.3.63.37-.53.31-.63-.36h0Zm.2,3.3.53-.31.64.37-.54.31-.62-.36Zm.21-1.26.53-.31.63.38-.53.31-.63-.37h0Zm.12-1.2.53-.31.63.38-.53.3-.63-.36h0Zm0,3.65.66-.39.64.38L116,260l-.63-.36Zm.34-5,.53-.3.63.37-.53.31-.63-.36h0Zm.2,3.29.53-.3.64.37-.53.31-.63-.36h0Zm.21-1.25.53-.31.63.38-.53.3-.63-.36Zm.12-1.21.53-.3.63.37-.53.31-.63-.36h0Zm.34-1.33.53-.31.64.38-.54.31-.63-.37Zm.17,4.69.53-.31.64.38-.53.3-.63-.36Zm0-1.4.53-.31.64.38-.53.31-.63-.37h0Zm.21-1.25.53-.31.64.37-.54.31-.63-.36Zm.12-1.21.53-.3.63.37-.53.31-.63-.36h0Zm.34-1.33.53-.31.64.38-.54.3-.62-.36Zm.17,4.69.53-.31.64.37-.53.31-.63-.36Zm0-1.4.54-.31.63.38-.53.3-.63-.36Zm.21-1.26.53-.3.64.37-.54.31-.62-.36h0Zm.12-1.2.53-.31.63.38-.53.31-.63-.37Zm.34-1.34.53-.3.64.37-.54.31-.62-.36h0Zm.17,4.69.54-.3.63.37-.53.31-.63-.36h0Zm0-1.39.53-.31.63.37-.53.31-.63-.36h0Zm.09-4.6.67-.39.63.37-.67.39-.63-.36Zm.11,3.34.53-.31.64.38-.54.31-.62-.37Zm.12-1.2.53-.31.63.38-.53.3-.63-.36Zm.34-1.34.53-.3.64.37-.53.31-.63-.37h0Zm.17,4.69.54-.31.63.38-.53.31-.63-.37Zm0-1.4.53-.3.63.37-.53.31-.63-.36h0Zm.2-1.25.53-.31.64.38-.54.3-.62-.36Zm0-3.43.67-.38.63.37-.67.39-.63-.36h0Zm.09,2.22.53-.3.63.37-.53.31-.63-.36h0Zm.34-1.33.53-.31.64.38-.53.3-.63-.36Zm.21,3.29.53-.31.63.38-.53.31-.63-.37h0Zm.2-1.26.53-.3.64.37-.53.31-.63-.36h0Zm.12-1.2.53-.3.63.37-.53.31-.63-.37h0Zm0,3.64.54-.31.63.38-.53.3-.63-.36Zm0-5.94.67-.38.63.37-.67.39-.63-.37h0Zm.29,1,.54-.31.63.38-.53.3-.63-.36Zm.21,3.29.53-.31.63.38-.53.3-.63-.36Zm.2-1.26.54-.3.63.37L122,254l-.63-.37h0Zm.12-1.2.53-.31.63.38-.53.3-.63-.36Zm0,3.64.54-.31.63.37-.53.31-.63-.36Zm.17-6,.85-.49.63.37-.85.5-.63-.37h0Zm.15,1,1.68-1,.63.37-1.67,1-.63-.36h0Zm.21,3.3.53-.31.63.37-.53.31-.63-.36Zm.2-1.26.54-.31.63.38-.53.31-.63-.37Zm.12-1.2.53-.31.63.38-.53.3-.63-.36Zm0,3.63.53-.3.63.37L123,256l-.63-.36h0Zm.52-1.68.53-.3.63.37-.53.31-.63-.36h0Zm.14-4.62.53-.31.63.37-.53.31-.63-.36Zm.07,3.37.53-.31.63.38-.53.3-.63-.36h0Zm.11-1.21,1.27-.73,1.61,1-.62.36-.83-.48a.32.32,0,0,0-.16,0,.31.31,0,0,0-.15,0l-.49.28-.63-.36h0Zm0,3.64.53-.31.63.38-.53.31-.63-.37h0Zm.52-1.68.53-.31.63.38-.53.31-.63-.37Zm.14-4.63.53-.3.63.37-.53.31-.63-.36h0Zm.07,3.37.53-.3.63.37-.53.31-.63-.36h0Zm.52,2.22L125,254l.63.38-.53.31-.63-.37h0Zm.14-1.46.53-.31.63.38-.53.3-.63-.36Zm.14-4.63.53-.31.63.38-.53.31-.63-.37h0Zm.11,1.07.54-.31.63.38-.53.31-.63-.37h0Zm.48,4.52.53-.31.63.38-.53.3-.63-.36h0Zm.14-1.47.94-.54.64.38-1,.54-.63-.36h0Zm.32-4.73,1.41-.81.63.38-1.4.81-.63-.36h0ZM126,251l.53-.31.64.38-.54.31L126,251Zm.25,2.37.53-.3.63.37-.53.31-.63-.36h0Zm.58-5.12.53-.31.63.38-.53.31-.63-.37h0Zm0,2.25.53-.31.64.38-.54.3-.62-.36Zm.12,1.07.53-.31.63.38-.53.3-.63-.36h0Zm.13,1.3.53-.31.63.38-.53.31-.63-.37h0Zm.47-6.19.53-.31.63.38-.53.3-.63-.36h0Zm.11,1.07.53-.31.63.38-.53.3-.63-.36Zm0,2.25.53-.31.64.37-.54.31-.62-.36Zm.07-1.18.53-.31.64.38-.54.3-.62-.36Zm0,2.25.53-.31.63.37-.53.31-.63-.36Zm.32,1.19.53-.31.63.38-.53.3-.63-.36Zm.28-6.09.53-.3,1.61.94-.53.31-1.61-.93h0Zm.11,1.08.53-.31.63.37-.53.31-.63-.36Zm.11,1.07.53-.31.64.37-.53.31-.63-.36Zm.05,2.24.53-.3.63.37-.53.31-.63-.36h0Zm.07-1.17.53-.31.63.38-.53.3-.63-.36Zm.25,2.37.53-.31.63.37-.53.31-.63-.36Zm.5-3.95.54-.3.63.37-.53.31-.63-.36h0Zm.12,1.07.53-.3.63.37-.53.31-.63-.36h0Zm.11,1.07.53-.3.63.37-.53.31-.63-.36h0Zm.14,1.3.53-.3.63.37-.53.31-.63-.36h0Zm.5-3.94.54-.31,1.61.95-.53.3-1.61-.93h0Zm.12,1.07.53-.31.63.38-.53.31-.63-.37h0Zm.11,1.07.53-.3.64.37-.54.31-.63-.37h0Zm.58,1.34.53-.31.27.17-.53.31-.27-.16Zm.29-1.84.53-.31.64.38-.54.31-.62-.37Zm.58,1.34.53-.31.27.17-.53.31-.27-.16Zm.29-1.84.53-.31.64.38-.54.3-.62-.36Zm.58,1.33.53-.3.27.17-.53.31-.27-.16h0Zm.87-.5.53-.3.27.17-.53.3-.27-.15h0Z",
    style: {
      fill: "#10E2ED"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.63,236.85c-2.24-.83-8.81-4-8.81-4s-4.12-8-5.25-9.74c-1.35-2.11-2.44-4.36-6.38-3.94l.72,8.43,5.79,9.79c.75,1.27,1.37,1.81,3.33,2.19l9.28,1.82.37.1a1.23,1.23,0,0,1,.65.44,3.41,3.41,0,0,1,.42.67c.4.82.37,1.1.78,2s.6.81,1.23,1.48.84,1.06,1.13,1,.41-.79.2-1.4a9.31,9.31,0,0,0-.92-1.41c-.09-.21-.08-.62.62-.48a11.35,11.35,0,0,1,2.91,2,20.41,20.41,0,0,0,1.86,1.8c.62.37.58-.26.61-.81a14.31,14.31,0,0,0,.57-2.25,6.61,6.61,0,0,0-1.89-3.63c-.88-.69-2.59-1.88-3-2.14A26.44,26.44,0,0,0,120.63,236.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,218.92c1.81-.23,4.07,0,5.3,1.25s1.41,2.1,3.49,6.28c1.78,3.57,2.59,5.36,2.59,5.36a6.43,6.43,0,0,1-2.78,2.6,12.41,12.41,0,0,1-3.66.93l-4.22-7.6Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.91,229.16c.41-4,1.08-8.43-3.84-9.85a13.13,13.13,0,0,0-8,.62,27.88,27.88,0,0,0-7.93,4c-1.17,1-2.08,1.34-2.68,5.52A118.2,118.2,0,0,0,83,242.72a68.05,68.05,0,0,0,.56,8.63c4,1.92,19.34,1.39,23.18-7.11-.36-3.91-1.11-5-1.26-7.2A59.62,59.62,0,0,1,105.91,229.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.62,217.37c-.13-1.69-1.63-3.59-2.24-5.12a7.15,7.15,0,0,1-.71-3.91,2.64,2.64,0,0,1,1.32-2,3.57,3.57,0,0,1,2.88-4.18c.44-.11,1.41-.26,1.85-.39.66-.21.85-.7,1.4-1.08a1.88,1.88,0,0,1,2.87.63,2,2,0,0,1,2.33-.28,1.55,1.55,0,0,1,1,1.87,1.65,1.65,0,0,1,2.37,1.12c0,.54-.12,1,.18,1.48a.82.82,0,0,0,1.34.22c0,.76-.29,1.31-1.1,1.19a1.71,1.71,0,0,1,.07,1.45,1.55,1.55,0,0,1-1.5.94,2.75,2.75,0,0,1-.47,1.11,2.83,2.83,0,0,1-1,.78,17.08,17.08,0,0,1-4,.68l-1.6.18c-.1,0-.58,0-.64.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8,215a1.62,1.62,0,0,0,2,.13l-.6,5.5c.69,2.44,4.68,3.22,6.21,2.69s1.43-1.42.6-2.83l.18-.89a15.26,15.26,0,0,0,2,.1,3.38,3.38,0,0,0,2.92-2.41,14.85,14.85,0,0,0,.69-5.6,4.9,4.9,0,0,1,0-1.38,6.35,6.35,0,0,0-.13-3c-1.33-1.3-4.62-2-7.91-.41a3.53,3.53,0,0,1-2.08,3.86c0,.5,0,1.77-.86,1.67-.59-.07-.56-.82-1.1-1.53a1.67,1.67,0,0,0-2.59-.1A3.2,3.2,0,0,0,90.8,215Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.54,210l-4,.71a1.55,1.55,0,0,1,.51.69l3.51-.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.55,209.77a7.62,7.62,0,0,0-2.8.11c-.81.27-1.1.57-1.56.58s-.78-.27-1.65-.51a8.26,8.26,0,0,0-2.73,0c-.31,0-.58.1-.6.51s.27.45.33.76c.13.65.1,1.54.63,2.09a1.74,1.74,0,0,0,1.36.5,2,2,0,0,0,1.92-1.2c.29-.6.22-1.42.74-1.42s.41.81.68,1.39a1.74,1.74,0,0,0,1.79,1.12,1.61,1.61,0,0,0,1.59-1.12,10.11,10.11,0,0,0,.29-1.54c.07-.28.29-.38.31-.77A.47.47,0,0,0,105.55,209.77Zm-5.79,3.09h0c-.62.73-2.25.68-2.58-.34a.36.36,0,0,1,0-.09h0a1.54,1.54,0,0,1,0-.17h0c-.11-.46-.27-1.42,0-1.7a2.17,2.17,0,0,1,1.55-.31,3.24,3.24,0,0,1,1.26.34l0,0a.79.79,0,0,1,.25.21A2.26,2.26,0,0,1,99.76,212.86Zm5.33-1.11a1.76,1.76,0,0,1-.77,1.33,1.54,1.54,0,0,1-1.92-.43,1.49,1.49,0,0,1-.17-.36,2.36,2.36,0,0,1-.06-1.52,2.84,2.84,0,0,1,2.43-.6h0a1.17,1.17,0,0,1,.2.06h0a1,1,0,0,1,.21.13C105.25,210.55,105.16,211.35,105.09,211.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.7,211.77l.4,3.2,2.07-.84c-.08-.13-.15-.26-.22-.39a1.28,1.28,0,0,1-.11-.2c-.07-.13-.14-.26-.22-.39-.19-.34-.39-.68-.58-1a5.55,5.55,0,0,0-.45-.63h0a2.82,2.82,0,0,0-.25-.3l-.08-.08h-.07C100.89,211.16,100.79,211.43,100.7,211.77Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.16,219.62c-2-.44-3.61-.81-4.55-2.42a13.09,13.09,0,0,1-1-2.58,10.2,10.2,0,0,0,.6,3.17c.44,1,1.59,2,4.82,2.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6,211.7a.6.6,0,0,1-.62.58.61.61,0,1,1,.62-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.09,209.12l-1.39.35a.74.74,0,0,1,.54-.89A.69.69,0,0,1,99.09,209.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6,215.22l1.89.76a1.07,1.07,0,0,1-1.36.58A1,1,0,0,1,98.6,215.22Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.69,216.61a1.21,1.21,0,0,0-1.16-1.11,1,1,0,0,0,.6,1.06A1.08,1.08,0,0,0,99.69,216.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.38,209.58l-1.42-.3a.7.7,0,0,1,.83-.57A.77.77,0,0,1,104.38,209.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.14,211.66a.59.59,0,0,1-.66.52.61.61,0,0,1,.16-1.21A.61.61,0,0,1,104.14,211.66Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.58,248.79a9.82,9.82,0,0,1,3.79.05,20.32,20.32,0,0,0,2.76.11c.72.36.09,1.57-1.76,1.54C112,250.48,108.58,248.79,108.58,248.79Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.62,251.07h0c2.62.7,5.32,1.11,8,1.58l3.56.62a9.36,9.36,0,0,1,2.59.74,4.94,4.94,0,0,0,2,.62c1.15,0,2.28-.56,3.41-.21.62.19,1.22.42,1.84.64a2.47,2.47,0,0,0,1.54.11,4.71,4.71,0,0,0,.52-.21,2.68,2.68,0,0,1,.8-.06,1.09,1.09,0,0,0,.57-.22c.09-.08.13-.23.23-.3a1,1,0,0,1,.52-.06,3.64,3.64,0,0,0,.81-.05c.36-.07.88-.25.84-.7,0-.2-.17-.3-.32-.43a10.44,10.44,0,0,1-.77-.71c-.56-.58-1.21-1.07-1.76-1.65a3.88,3.88,0,0,0-1.8-1c-.71-.2-1.41-.47-2.13-.64a5.13,5.13,0,0,0-1.76-.37,11.1,11.1,0,0,1-4.61-.41c-2.19-.71-10.9-4.2-10.9-4.2l-2-12.64s-.52-6.85-3.55-8.2a5.75,5.75,0,0,0-3.79,3.21c-.93,2.14-.44,4.87.38,10.29.64,4.18.84,5.6,1.65,9.36C86.27,249.44,86.37,250.19,89.62,251.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.31,223.1c-3,1.25-4.16,2.59-4.44,5.63S84.5,241.4,84.5,241.4a9.7,9.7,0,0,0,3.58-.21,11,11,0,0,0,4.29-1.59s-.54-4-.94-6.63C91.12,231,90.48,224.47,87.31,223.1Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M122.64,274.08,119,272a.6.6,0,0,1,0-1.14l26.26-15.16a2.18,2.18,0,0,1,2,0l3.66,2.11a.61.61,0,0,1,0,1.15l-26.26,15.16A2.25,2.25,0,0,1,122.64,274.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--monitor--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.75,267.89a1,1,0,0,0,.94,0l27.21-15.71a1.22,1.22,0,0,0,.54-.89l1.44-22.73a1.09,1.09,0,0,0-.4-.89,1,1,0,0,0-.93,0l-27.22,15.72a1.22,1.22,0,0,0-.54.89L117.35,267A1.09,1.09,0,0,0,117.75,267.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.69,267.89l27.21-15.71a1.22,1.22,0,0,0,.54-.89l1.44-22.73c0-.33-.19-.47-.47-.31L120.2,244a1.22,1.22,0,0,0-.54.89l-1.44,22.73C118.2,267.91,118.41,268.05,118.69,267.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,243.76l.86.58a1.23,1.23,0,0,0-.17.51l-1.27,20-.17,2.79c0,.3.15.44.39.34a1,1,0,0,1-.86,0,1.09,1.09,0,0,1-.4-.89l.18-2.78,1.26-20A1.12,1.12,0,0,1,119,243.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "128.47 264.62 131 263.16 131.52 266.56 128.47 264.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.35,263.46l-7.42,4.28a.91.91,0,0,1-.47.11,1,1,0,0,1-.41-.11h0l-3.26-1.89h0a.94.94,0,0,1-.42-.75v-.18c0-.28.19-.4.44-.25l2,1.13.44.26-.1-.5L130.4,256l6.09-3.54,1,.6,3.17,9.63A.79.79,0,0,1,140.35,263.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.43 256.61 137.52 253.07 136.49 252.47 130.4 256.01 131.43 256.61",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.43,256.61l-1-.6.69,9.54c.06.27-.1.39-.34.24l-2-1.13c-.25-.15-.44,0-.44.25v.18a.94.94,0,0,0,.42.75h0l3.26,1.89h0a1,1,0,0,0,.41.11Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.05,44.29c-2.05-3-7.51-5.44-14.26-5.5-6.14-.06-13.62,1.75-15.49,7.65-1.59,5,3.31,9.71,8.41,10.7a34.17,34.17,0,0,0,6.15.65,6.27,6.27,0,0,0,4.82,3,4.83,4.83,0,0,1-1.1-3.1,31.53,31.53,0,0,0,4.72-.79C209.14,54.65,209.33,47.62,207.05,44.29Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.05,44.29c-2.05-3-7.51-5.44-14.26-5.5-6.14-.06-13.62,1.75-15.49,7.65-1.59,5,3.31,9.71,8.41,10.7a34.17,34.17,0,0,0,6.15.65,6.27,6.27,0,0,0,4.82,3,4.83,4.83,0,0,1-1.1-3.1,31.53,31.53,0,0,0,4.72-.79C209.14,54.65,209.33,47.62,207.05,44.29Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.05,46.4a1.84,1.84,0,1,0,1.83,1.84A1.84,1.84,0,0,0,184.05,46.4Zm8.59,0a1.84,1.84,0,1,0,1.83,1.84A1.84,1.84,0,0,0,192.64,46.4Zm8.59,0a1.84,1.84,0,1,0,1.83,1.84A1.84,1.84,0,0,0,201.23,46.4Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.72,317.9l-.48-1.69c.21-1-3.75,1.31-4,2.28l1.27,3.44a.6.6,0,0,0,.22.25c.28.17,2.17,1.24,2.26,1.29a.54.54,0,0,0,.81-.3l1.65-5.66C166.61,317,165.69,317.34,164.72,317.9Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.72,317.9l-.48-1.69c.21-1-3.75,1.31-4,2.28l1.27,3.44a.6.6,0,0,0,.22.25c.28.17,2.17,1.24,2.26,1.29a.54.54,0,0,0,.81-.3l1.65-5.66C166.61,317,165.69,317.34,164.72,317.9Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,294.33,154.19,303a1.15,1.15,0,0,0-.51.88v17.83a1.11,1.11,0,0,0,.51.88l1.79,1a1.14,1.14,0,0,0,1,0l15.05-8.68a1.13,1.13,0,0,0,.51-.88V296.22a1.13,1.13,0,0,0-.51-.88l-1.79-1A1.14,1.14,0,0,0,169.24,294.33Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,294.33,154.19,303a1.15,1.15,0,0,0-.51.88v17.83a1.11,1.11,0,0,0,.51.88l1.79,1a1.14,1.14,0,0,0,1,0l15.05-8.68a1.13,1.13,0,0,0,.51-.88V296.22a1.13,1.13,0,0,0-.51-.88l-1.79-1A1.14,1.14,0,0,0,169.24,294.33Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.05,295.93,157,304.61a1.1,1.1,0,0,0-.5.88v17.83c0,.32.22.45.5.29l5.76-3.32,1.06,2.93a.55.55,0,0,0,1-.05l1.41-4.9,5.79-3.34a1.13,1.13,0,0,0,.51-.88V296.22C172.56,295.9,172.33,295.76,172.05,295.93Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,296.13c0-.26-.24-.35-.5-.2l-15,8.68a.94.94,0,0,0-.36.38l-2.81-1.62a1.1,1.1,0,0,1,.35-.36l15.05-8.68a1.14,1.14,0,0,1,1,0l1.79,1A1.09,1.09,0,0,1,172.55,296.13Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,296.13c0-.26-.24-.35-.5-.2l-15,8.68a.94.94,0,0,0-.36.38l-2.81-1.62a1.1,1.1,0,0,1,.35-.36l15.05-8.68a1.14,1.14,0,0,1,1,0l1.79,1A1.09,1.09,0,0,1,172.55,296.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-168",
    d: "M169.07,301.14a1.3,1.3,0,0,0-1.69.69l-4.85,11.55-1.16-1.12a1.28,1.28,0,0,0-1.79,1.84l2.51,2.44a1.29,1.29,0,0,0,.89.36l.26,0a1.29,1.29,0,0,0,.93-.77l5.58-13.28A1.29,1.29,0,0,0,169.07,301.14Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-168",
    d: "M293.89,380.2a6.42,6.42,0,0,0-3.87-.66,4.36,4.36,0,0,0-1.53-1.39,10.46,10.46,0,0,0-9.44,0,3.55,3.55,0,0,0-1.93,2.37,14.26,14.26,0,0,0-9.24,1.27,6.82,6.82,0,0,0-1.55,1.2c-4.17-1.32-9.51-1-13,1.08a7.12,7.12,0,0,0-2.54,2.31,16,16,0,0,0-12.09,1,7.66,7.66,0,0,0-1.36,1,8.64,8.64,0,0,0-1.25-.88,15.61,15.61,0,0,0-7.85-1.8,7.12,7.12,0,0,0-2.9-2.83c-3.75-2.16-9.44-2.5-13.82-1a5.37,5.37,0,0,0-2.54-2.73,14.26,14.26,0,0,0-8.45-1.48,3.83,3.83,0,0,0-1.72-1.78,10.15,10.15,0,0,0-9.17,0,4.84,4.84,0,0,0-1.23,1,6.93,6.93,0,0,0-4.4.65c-1.75,1-1.75,2.65,0,3.66a7,7,0,0,0,6,.16,9,9,0,0,0,3.11.87c-.39,1.62.49,3.32,2.64,4.56a14.73,14.73,0,0,0,10.07,1.2c.16,1.56,1.26,3.1,3.32,4.29a17.14,17.14,0,0,0,9.39,1.89,7,7,0,0,0,2.41,2.13c3.5,2,8.83,2.35,12.92,1a7.85,7.85,0,0,0,7,0,4.54,4.54,0,0,0,.58-.41A16,16,0,0,0,253,395.6a7,7,0,0,0,2.07-1.74c4.27,1.62,10,1.35,13.8-.82a7,7,0,0,0,2.67-2.52,14.27,14.27,0,0,0,9.31-1.26c2.14-1.24,3-2.94,2.55-4.55a10,10,0,0,0,4.77-.94,6.61,6.61,0,0,0,5.76-.11C295.55,382.71,295.55,381.16,293.89,380.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Smoke--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.25,377.55c0,6.23-12.31,11.28-27.5,11.28s-27.5-5.05-27.5-11.28,12.31-11.27,27.5-11.27S265.25,371.33,265.25,377.55Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.25,377.55c0,6.23-12.31,11.28-27.5,11.28s-27.5-5.05-27.5-11.28,12.31-11.27,27.5-11.27S265.25,371.33,265.25,377.55Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.25,377.55c0,6.23-12.31,11.28-27.5,11.28s-27.5-5.05-27.5-11.28,12.31-11.27,27.5-11.27S265.25,371.33,265.25,377.55Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.31,371.73a12.22,12.22,0,0,1,24.43,0c0,.11,0,.22,0,.34s0,.22,0,.34c-.14,1.69-1.33,3.35-3.58,4.65-4.76,2.76-12.51,2.76-17.29,0-2.23-1.3-3.42-3-3.56-4.65,0-.12,0-.22,0-.34S213.3,371.84,213.31,371.73Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.31,371.73a12.22,12.22,0,0,1,24.43,0c0,.11,0,.22,0,.34s0,.22,0,.34c-.14,1.69-1.33,3.35-3.58,4.65-4.76,2.76-12.51,2.76-17.29,0-2.23-1.3-3.42-3-3.56-4.65,0-.12,0-.22,0-.34S213.3,371.84,213.31,371.73Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,361.06h0a12.21,12.21,0,0,1,17.52,10.67c0,.11,0,.22,0,.34s0,.22,0,.34c-.14,1.69-1.33,3.35-3.58,4.65A16.16,16.16,0,0,1,228,379c3.17-.54,5.22-4.08,4.25-8C231.15,366.44,226.57,359.89,220.22,361.06Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.31,372.41c0-.12,0-.22,0-.34s0-.23,0-.34a12.17,12.17,0,0,1,4.14-8.83c-1.32,1.36-4.28,6.51-1.07,10.43,2.11,2.58,12.13,6.26,20.38,1.53a8.53,8.53,0,0,1-2.6,2.2c-4.76,2.76-12.51,2.76-17.29,0C214.64,375.76,213.45,374.1,213.31,372.41Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.65,362.6c-.55,1.24.5,2.91,2.34,3.72s3.79.45,4.33-.79-.5-2.91-2.34-3.72S226.19,361.35,225.65,362.6Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,367.67a1.6,1.6,0,0,0,2.88,1.26,1.6,1.6,0,0,0-2.88-1.26Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.35,372.09a10.38,10.38,0,0,0-20.75,0,4.21,4.21,0,0,0,0,.58c.12,1.43,1.13,2.84,3,3.95a16.23,16.23,0,0,0,14.68,0c1.9-1.11,2.91-2.52,3-3.95a4.21,4.21,0,0,0,0-.58Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.35,372.09a10.38,10.38,0,0,0-20.75,0,4.21,4.21,0,0,0,0,.58c.12,1.43,1.13,2.84,3,3.95a16.23,16.23,0,0,0,14.68,0c1.9-1.11,2.91-2.52,3-3.95a4.21,4.21,0,0,0,0-.58Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.48,363h0a10.36,10.36,0,0,0-14.88,9.06,4.21,4.21,0,0,0,0,.58c.12,1.43,1.13,2.84,3,3.95a13.91,13.91,0,0,0,5.21,1.62c-2.7-.46-4.44-3.47-3.61-6.79C243.2,367.6,247.09,362,252.48,363Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.35,372.67a4.21,4.21,0,0,0,0-.58,10.34,10.34,0,0,0-3.52-7.5c1.13,1.16,3.63,5.53.91,8.86-1.79,2.19-10.3,5.32-17.3,1.3a7.18,7.18,0,0,0,2.2,1.87,16.23,16.23,0,0,0,14.68,0C257.22,375.51,258.23,374.1,258.35,372.67Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.87,364.33c.47,1.06-.43,2.48-2,3.17s-3.21.38-3.68-.68.43-2.47,2-3.16S247.41,363.28,247.87,364.33Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.86,368.64a1.37,1.37,0,1,1-1.66-.46A1.24,1.24,0,0,1,241.86,368.64Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.69,376.46a6.86,6.86,0,0,0-13.72,0,1.15,1.15,0,0,0,0,.19,1.28,1.28,0,0,0,0,.19,3.5,3.5,0,0,0,2,2.61,10.74,10.74,0,0,0,9.72,0,3.55,3.55,0,0,0,2-2.61v-.38Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.69,376.46a6.86,6.86,0,0,0-13.72,0,1.15,1.15,0,0,0,0,.19,1.28,1.28,0,0,0,0,.19,3.5,3.5,0,0,0,2,2.61,10.74,10.74,0,0,0,9.72,0,3.55,3.55,0,0,0,2-2.61v-.38Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8,370.47h0a6.75,6.75,0,0,0-3-.69,6.85,6.85,0,0,0-6.86,6.68,1.15,1.15,0,0,0,0,.19,1.28,1.28,0,0,0,0,.19,3.5,3.5,0,0,0,2,2.61,9.07,9.07,0,0,0,3.45,1.07c-1.78-.3-2.94-2.29-2.39-4.49C256.67,373.49,259.24,369.81,262.8,370.47Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.69,376.84v-.38a6.84,6.84,0,0,0-2.33-5c.74.76,2.4,3.65.6,5.85-1.19,1.45-6.81,3.52-11.44.86a4.77,4.77,0,0,0,1.45,1.24,10.74,10.74,0,0,0,9.72,0A3.55,3.55,0,0,0,266.69,376.84Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.76,371.33c.3.7-.29,1.63-1.32,2.09s-2.13.25-2.43-.45.28-1.63,1.32-2.09S259.45,370.63,259.76,371.33Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.78,374.18a.9.9,0,0,1-1.62.71.83.83,0,0,1,.52-1A.81.81,0,0,1,255.78,374.18Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,377.32a9.33,9.33,0,0,0-18.65,0v.52a4.8,4.8,0,0,0,2.73,3.55,14.55,14.55,0,0,0,13.2,0,4.81,4.81,0,0,0,2.72-3.55,2.17,2.17,0,0,0,0-.26A2.35,2.35,0,0,0,280,377.32Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,377.32a9.33,9.33,0,0,0-18.65,0v.52a4.8,4.8,0,0,0,2.73,3.55,14.55,14.55,0,0,0,13.2,0,4.81,4.81,0,0,0,2.72-3.55,2.17,2.17,0,0,0,0-.26A2.35,2.35,0,0,0,280,377.32Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.68,369.19h0a9.13,9.13,0,0,0-4-.94,9.33,9.33,0,0,0-9.33,9.07v.52a4.8,4.8,0,0,0,2.73,3.55,12.3,12.3,0,0,0,4.68,1.46c-2.42-.41-4-3.11-3.24-6.1C266.34,373.29,269.84,368.29,274.68,369.19Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,377.84a2.17,2.17,0,0,0,0-.26,2.35,2.35,0,0,0,0-.26,9.23,9.23,0,0,0-3.17-6.73c1,1,3.27,5,.82,8-1.61,2-9.25,4.77-15.55,1.16a6.59,6.59,0,0,0,2,1.68,14.55,14.55,0,0,0,13.2,0A4.81,4.81,0,0,0,280,377.84Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.54,370.36c.42.95-.38,2.22-1.79,2.84s-2.89.34-3.3-.61.38-2.22,1.79-2.84S270.12,369.41,270.54,370.36Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.14,374.23a1.23,1.23,0,0,1-2.2,1,1.22,1.22,0,0,1,2.2-1Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.4,323.53a17,17,0,0,1-6,13,11.08,11.08,0,0,0-4,8.45v44.23a3.48,3.48,0,0,1-2.06,2.87,9,9,0,0,1-2.57.94,12,12,0,0,1-4.78,0,8.86,8.86,0,0,1-2.56-.94,3.48,3.48,0,0,1-2.05-2.87V344.9a11,11,0,0,0-4-8.36,17,17,0,0,1-6.05-13.15,17.08,17.08,0,0,1,34.15.14Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.4,323.53a17,17,0,0,1-6,13,11.08,11.08,0,0,0-4,8.45v44.23a3.48,3.48,0,0,1-2.06,2.87,9,9,0,0,1-2.57.94,12,12,0,0,1-4.78,0,8.86,8.86,0,0,1-2.56-.94,3.48,3.48,0,0,1-2.05-2.87V344.9a11,11,0,0,0-4-8.36,17,17,0,0,1-6.05-13.15,17.08,17.08,0,0,1,34.15.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.85,323.53a9.51,9.51,0,0,1-4,7.76,7.72,7.72,0,0,0-3.12,6.33v51.59a2.41,2.41,0,0,1-2.36,2.44h0a2.42,2.42,0,0,1-2.37-2.44V337.5a7.61,7.61,0,0,0-3.12-6.22,9.49,9.49,0,0,1-4-8,9.53,9.53,0,0,1,19,.27Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.85,323.53a9.51,9.51,0,0,1-4,7.76,7.72,7.72,0,0,0-3.12,6.33v51.59a2.41,2.41,0,0,1-2.36,2.44h0a2.42,2.42,0,0,1-2.37-2.44V337.5a7.61,7.61,0,0,0-3.12-6.22,9.49,9.49,0,0,1-4-8,9.53,9.53,0,0,1,19,.27Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,329.84a4.45,4.45,0,1,1,4.45,4.45A4.45,4.45,0,0,1,240,329.84Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.73,321a2.72,2.72,0,1,1,2.72,2.72A2.72,2.72,0,0,1,241.73,321Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.53,316.64a1.35,1.35,0,1,1,1.35,1.34A1.34,1.34,0,0,1,236.53,316.64Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,318.26a3.66,3.66,0,1,1,3.65,3.65A3.66,3.66,0,0,1,225.77,318.26Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16,324.87a1.72,1.72,0,1,0,1.71-1.72A1.72,1.72,0,0,0,225.16,324.87Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.44,330.87a2.79,2.79,0,1,1,2.78,2.78A2.79,2.79,0,0,1,226.44,330.87Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,335.07a2.3,2.3,0,1,1,2.29,2.29A2.3,2.3,0,0,1,233.08,335.07Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.9,321a1.17,1.17,0,1,1,1.17,1.17A1.17,1.17,0,0,1,221.9,321Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.34,316.14a1.54,1.54,0,1,1,1.54,1.54A1.54,1.54,0,0,1,247.34,316.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.42,
    cy: 323.7,
    r: 1.55,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.81,325a1.55,1.55,0,1,1,1.55,1.55A1.55,1.55,0,0,1,232.81,325Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.45,380a5.69,5.69,0,0,0-11.37,0v.32a2.92,2.92,0,0,0,1.67,2.16,8.84,8.84,0,0,0,8,0,2.9,2.9,0,0,0,1.66-2.16V380Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.45,380a5.69,5.69,0,0,0-11.37,0v.32a2.92,2.92,0,0,0,1.67,2.16,8.84,8.84,0,0,0,8,0,2.9,2.9,0,0,0,1.66-2.16V380Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.23,375h0a5.63,5.63,0,0,0-2.46-.57,5.69,5.69,0,0,0-5.69,5.53v.32a2.92,2.92,0,0,0,1.67,2.16,7.39,7.39,0,0,0,2.85.89,2.88,2.88,0,0,1-2-3.72C281.15,377.55,283.28,374.5,286.23,375Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.45,380.32V380a5.63,5.63,0,0,0-1.93-4.1c.62.63,2,3,.5,4.85-1,1.2-5.64,2.91-9.48.71a3.91,3.91,0,0,0,1.21,1,8.84,8.84,0,0,0,8,0A2.9,2.9,0,0,0,289.45,380.32Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.71,375.76c.25.58-.24,1.35-1.09,1.73s-1.76.21-2-.37.24-1.35,1.1-1.73S283.45,375.18,283.71,375.76Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.42,378.11a.69.69,0,0,1-.43.85.61.61,0,1,1-.48-1.1A.68.68,0,0,1,280.42,378.11Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.15,384.27a7.83,7.83,0,0,0-15.65,0v.44a4.05,4.05,0,0,0,2.29,3,12.29,12.29,0,0,0,11.08,0,4,4,0,0,0,2.28-3,1.55,1.55,0,0,0,0-.22A1.7,1.7,0,0,0,282.15,384.27Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.15,384.27a7.83,7.83,0,0,0-15.65,0v.44a4.05,4.05,0,0,0,2.29,3,12.29,12.29,0,0,0,11.08,0,4,4,0,0,0,2.28-3,1.55,1.55,0,0,0,0-.22A1.7,1.7,0,0,0,282.15,384.27Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.72,377.44h0a7.82,7.82,0,0,0-11.22,6.83v.44a4.05,4.05,0,0,0,2.29,3,10.66,10.66,0,0,0,3.93,1.23c-2-.36-3.34-2.62-2.72-5.13C270.72,380.89,273.66,376.69,277.72,377.44Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.15,384.71a1.55,1.55,0,0,0,0-.22,1.7,1.7,0,0,0,0-.22,7.78,7.78,0,0,0-2.65-5.65c.85.87,2.74,4.17.68,6.68-1.35,1.65-7.77,4-13.05,1a5.51,5.51,0,0,0,1.66,1.41,12.29,12.29,0,0,0,11.08,0A4,4,0,0,0,282.15,384.71Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.25,378.43c.35.79-.32,1.86-1.51,2.38s-2.42.29-2.77-.51.33-1.86,1.51-2.38S273.9,377.63,274.25,378.43Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.71,381.67a1,1,0,1,1-1.25-.34A.92.92,0,0,1,269.71,381.67Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.76,387.06a9.71,9.71,0,0,0-19.42,0,2.35,2.35,0,0,0,0,.27,2.44,2.44,0,0,0,0,.27c.11,1.34,1,2.66,2.84,3.7a15.19,15.19,0,0,0,13.74,0c1.78-1,2.73-2.36,2.84-3.7a2.44,2.44,0,0,0,0-.27A2.35,2.35,0,0,0,270.76,387.06Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.76,387.06a9.71,9.71,0,0,0-19.42,0,2.35,2.35,0,0,0,0,.27,2.44,2.44,0,0,0,0,.27c.11,1.34,1,2.66,2.84,3.7a15.19,15.19,0,0,0,13.74,0c1.78-1,2.73-2.36,2.84-3.7a2.44,2.44,0,0,0,0-.27A2.35,2.35,0,0,0,270.76,387.06Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.26,378.58h0a9.58,9.58,0,0,0-4.21-1,9.71,9.71,0,0,0-9.71,9.45,2.35,2.35,0,0,0,0,.27,2.44,2.44,0,0,0,0,.27c.11,1.34,1,2.66,2.84,3.7a13,13,0,0,0,4.87,1.52c-2.52-.44-4.15-3.25-3.37-6.36C256.57,382.86,260.22,377.65,265.26,378.58Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.76,387.6a2.44,2.44,0,0,0,0-.27,2.35,2.35,0,0,0,0-.27,9.65,9.65,0,0,0-3.3-7c1.06,1.08,3.4,5.17.85,8.29-1.68,2.05-9.64,5-16.19,1.22a6.9,6.9,0,0,0,2.06,1.75,15.19,15.19,0,0,0,13.74,0C269.7,390.26,270.65,388.94,270.76,387.6Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,379.8c.43,1-.4,2.31-1.87,3s-3,.36-3.44-.63.4-2.32,1.87-3S260.51,378.81,261,379.8Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.32,383.83a1.28,1.28,0,1,1-1.55-.43A1.14,1.14,0,0,1,255.32,383.83Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.26,381.34a3.44,3.44,0,0,0-6.87,0v.19a1.77,1.77,0,0,0,1,1.3,5.34,5.34,0,0,0,4.86,0,1.75,1.75,0,0,0,1-1.3v-.19Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.26,381.34a3.44,3.44,0,0,0-6.87,0v.19a1.77,1.77,0,0,0,1,1.3,5.34,5.34,0,0,0,4.86,0,1.75,1.75,0,0,0,1-1.3v-.19Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.32,378.34h0a3.42,3.42,0,0,0-4.93,3v.19a1.77,1.77,0,0,0,1,1.3,4.35,4.35,0,0,0,1.72.54,1.73,1.73,0,0,1-1.19-2.25C289.24,379.85,290.53,378,292.32,378.34Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.26,381.53v-.19a3.43,3.43,0,0,0-1.17-2.49,2.36,2.36,0,0,1,.3,2.94,5.27,5.27,0,0,1-5.72.43,2.39,2.39,0,0,0,.73.61,5.34,5.34,0,0,0,4.86,0A1.75,1.75,0,0,0,294.26,381.53Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.79,378.77c.15.35-.14.82-.66,1.05s-1.06.12-1.22-.23.15-.82.66-1S290.64,378.42,290.79,378.77Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.8,380.19a.45.45,0,1,1-.55-.15A.41.41,0,0,1,288.8,380.19Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.52,377.2a5.68,5.68,0,0,1,11.36,0,.92.92,0,0,1,0,.16.81.81,0,0,1,0,.16,2.9,2.9,0,0,1-1.66,2.16,8.92,8.92,0,0,1-8.05,0,2.89,2.89,0,0,1-1.65-2.16.81.81,0,0,1,0-.16A.92.92,0,0,1,188.52,377.2Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.52,377.2a5.68,5.68,0,0,1,11.36,0,.92.92,0,0,1,0,.16.81.81,0,0,1,0,.16,2.9,2.9,0,0,1-1.66,2.16,8.92,8.92,0,0,1-8.05,0,2.89,2.89,0,0,1-1.65-2.16.81.81,0,0,1,0-.16A.92.92,0,0,1,188.52,377.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.73,372.24h0a5.67,5.67,0,0,1,8.15,5,.92.92,0,0,1,0,.16.81.81,0,0,1,0,.16,2.9,2.9,0,0,1-1.66,2.16,7.45,7.45,0,0,1-2.85.89,2.87,2.87,0,0,0,2-3.72C196.81,374.75,194.68,371.7,191.73,372.24Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.52,377.52a.81.81,0,0,1,0-.16.92.92,0,0,1,0-.16,5.62,5.62,0,0,1,1.93-4.1c-.62.63-2,3-.5,4.85,1,1.2,5.64,2.91,9.47.71a3.86,3.86,0,0,1-1.2,1,8.92,8.92,0,0,1-8.05,0A2.89,2.89,0,0,1,188.52,377.52Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,373c-.26.58.23,1.35,1.09,1.73s1.76.21,2-.37-.23-1.35-1.09-1.73S194.51,372.38,194.26,373Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.55,375.31a.75.75,0,1,0,.91-.25A.67.67,0,0,0,197.55,375.31Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.38,376.61a8.24,8.24,0,0,1,16.48,0,2.65,2.65,0,0,1,0,.46,4.25,4.25,0,0,1-2.41,3.14,13,13,0,0,1-11.67,0,4.23,4.23,0,0,1-2.4-3.14,2.65,2.65,0,0,1,0-.46Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.38,376.61a8.24,8.24,0,0,1,16.48,0,2.65,2.65,0,0,1,0,.46,4.25,4.25,0,0,1-2.41,3.14,13,13,0,0,1-11.67,0,4.23,4.23,0,0,1-2.4-3.14,2.65,2.65,0,0,1,0-.46Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,369.41h0a8.24,8.24,0,0,1,11.82,7.2,2.65,2.65,0,0,1,0,.46,4.25,4.25,0,0,1-2.41,3.14,11.3,11.3,0,0,1-4.14,1.29c2.14-.37,3.53-2.76,2.87-5.4C212.41,373,209.32,368.62,205,369.41Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.38,377.07a2.65,2.65,0,0,1,0-.46,8.16,8.16,0,0,1,2.8-6c-.9.92-2.89,4.39-.73,7,1.43,1.74,8.19,4.22,13.75,1a5.86,5.86,0,0,1-1.75,1.49,13,13,0,0,1-11.67,0A4.23,4.23,0,0,1,200.38,377.07Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.7,370.45c-.37.84.34,2,1.59,2.51s2.55.31,2.92-.53-.34-2-1.59-2.52S209.07,369.61,208.7,370.45Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.48,373.87a1.08,1.08,0,1,0,1.32-.37A1,1,0,0,0,213.48,373.87Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,381.45a7.83,7.83,0,0,1,15.65,0,1.55,1.55,0,0,1,0,.22,1.48,1.48,0,0,1,0,.21,4,4,0,0,1-2.29,3,12.2,12.2,0,0,1-11.07,0,4,4,0,0,1-2.29-3v-.43Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,381.45a7.83,7.83,0,0,1,15.65,0,1.55,1.55,0,0,1,0,.22,1.48,1.48,0,0,1,0,.21,4,4,0,0,1-2.29,3,12.2,12.2,0,0,1-11.07,0,4,4,0,0,1-2.29-3v-.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.93,374.62h0a7.8,7.8,0,0,1,11.22,6.83,1.55,1.55,0,0,1,0,.22,1.48,1.48,0,0,1,0,.21,4,4,0,0,1-2.29,3,10.37,10.37,0,0,1-3.92,1.23c2-.35,3.34-2.62,2.72-5.12C205.93,378.06,203,373.87,198.93,374.62Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,381.88v-.43a7.79,7.79,0,0,1,2.66-5.66c-.85.88-2.74,4.17-.68,6.68,1.35,1.65,7.76,4,13,1a5.39,5.39,0,0,1-1.66,1.41,12.2,12.2,0,0,1-11.07,0A4,4,0,0,1,194.5,381.88Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.41,375.6c-.35.8.32,1.86,1.5,2.38s2.42.29,2.77-.5-.32-1.87-1.5-2.39S202.76,374.8,202.41,375.6Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.94,378.85a1,1,0,1,0,1.26-.35A.93.93,0,0,0,206.94,378.85Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.62,385.89a9.71,9.71,0,0,1,19.42,0,2.35,2.35,0,0,1,0,.27,2.53,2.53,0,0,1,0,.27c-.11,1.34-1,2.66-2.84,3.69a15.19,15.19,0,0,1-13.74,0c-1.78-1-2.73-2.35-2.84-3.69a2.53,2.53,0,0,1,0-.27A2.35,2.35,0,0,1,207.62,385.89Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.62,385.89a9.71,9.71,0,0,1,19.42,0,2.35,2.35,0,0,1,0,.27,2.53,2.53,0,0,1,0,.27c-.11,1.34-1,2.66-2.84,3.69a15.19,15.19,0,0,1-13.74,0c-1.78-1-2.73-2.35-2.84-3.69a2.53,2.53,0,0,1,0-.27A2.35,2.35,0,0,1,207.62,385.89Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.12,377.41h0a9.61,9.61,0,0,1,4.21-1,9.71,9.71,0,0,1,9.71,9.45,2.35,2.35,0,0,1,0,.27,2.53,2.53,0,0,1,0,.27c-.11,1.34-1,2.66-2.84,3.69a12.77,12.77,0,0,1-4.87,1.52c2.52-.43,4.15-3.24,3.37-6.35C221.81,381.68,218.16,376.48,213.12,377.41Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.62,386.43a2.53,2.53,0,0,1,0-.27,2.35,2.35,0,0,1,0-.27,9.68,9.68,0,0,1,3.3-7c-1,1.08-3.4,5.17-.85,8.29,1.68,2,9.64,5,16.19,1.21a6.62,6.62,0,0,1-2.06,1.75,15.19,15.19,0,0,1-13.74,0C208.68,389.09,207.73,387.77,207.62,386.43Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.43,378.63c-.43,1,.4,2.31,1.87,2.95s3,.37,3.44-.62-.4-2.32-1.87-3S217.87,377.64,217.43,378.63Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.06,382.66a1.28,1.28,0,1,0,1.55-.43A1.14,1.14,0,0,0,223.06,382.66Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.69,390.23a8.87,8.87,0,0,0-17.73,0,2.09,2.09,0,0,0,0,.25,2.18,2.18,0,0,0,0,.25,4.57,4.57,0,0,0,2.6,3.37,13.88,13.88,0,0,0,12.55,0,4.56,4.56,0,0,0,2.58-3.37,2.18,2.18,0,0,0,0-.25A2.09,2.09,0,0,0,254.69,390.23Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.69,390.23a8.87,8.87,0,0,0-17.73,0,2.09,2.09,0,0,0,0,.25,2.18,2.18,0,0,0,0,.25,4.57,4.57,0,0,0,2.6,3.37,13.88,13.88,0,0,0,12.55,0,4.56,4.56,0,0,0,2.58-3.37,2.18,2.18,0,0,0,0-.25A2.09,2.09,0,0,0,254.69,390.23Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.68,382.49h0A8.87,8.87,0,0,0,237,390.23a2.09,2.09,0,0,0,0,.25,2.18,2.18,0,0,0,0,.25,4.57,4.57,0,0,0,2.6,3.37,11.86,11.86,0,0,0,4.45,1.39c-2.3-.4-3.79-3-3.08-5.8C241.75,386.4,245.07,381.64,249.68,382.49Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.69,390.73a2.18,2.18,0,0,0,0-.25,2.09,2.09,0,0,0,0-.25,8.82,8.82,0,0,0-3-6.41c1,1,3.11,4.73.78,7.57-1.53,1.88-8.8,4.55-14.78,1.11a6,6,0,0,0,1.88,1.6,13.88,13.88,0,0,0,12.55,0A4.56,4.56,0,0,0,254.69,390.73Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.74,383.61c.39.9-.37,2.11-1.71,2.7s-2.74.33-3.14-.58.37-2.11,1.71-2.7S245.34,382.7,245.74,383.61Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.6,387.29a1,1,0,0,1-.67,1.31,1.06,1.06,0,0,1-1.42-.4,1.16,1.16,0,0,1,2.09-.91Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.88,390.92a8.43,8.43,0,0,1,16.86,0,1.93,1.93,0,0,1,0,.24,1.77,1.77,0,0,1,0,.23,4.33,4.33,0,0,1-2.47,3.21,13.2,13.2,0,0,1-11.93,0,4.34,4.34,0,0,1-2.46-3.21,1.77,1.77,0,0,1,0-.23A1.93,1.93,0,0,1,219.88,390.92Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.88,390.92a8.43,8.43,0,0,1,16.86,0,1.93,1.93,0,0,1,0,.24,1.77,1.77,0,0,1,0,.23,4.33,4.33,0,0,1-2.47,3.21,13.2,13.2,0,0,1-11.93,0,4.34,4.34,0,0,1-2.46-3.21,1.77,1.77,0,0,1,0-.23A1.93,1.93,0,0,1,219.88,390.92Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.65,383.56h0a8.34,8.34,0,0,1,3.66-.84,8.43,8.43,0,0,1,8.43,8.2,1.93,1.93,0,0,1,0,.24,1.77,1.77,0,0,1,0,.23,4.33,4.33,0,0,1-2.47,3.21,11.17,11.17,0,0,1-4.23,1.32c2.19-.38,3.61-2.82,2.93-5.52C232.19,387.27,229,382.75,224.65,383.56Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.88,391.39a1.77,1.77,0,0,1,0-.23,1.93,1.93,0,0,1,0-.24,8.36,8.36,0,0,1,2.86-6.09c-.92.94-3,4.49-.74,7.2,1.46,1.78,8.37,4.32,14.06,1.05a5.74,5.74,0,0,1-1.79,1.52,13.2,13.2,0,0,1-11.93,0A4.34,4.34,0,0,1,219.88,391.39Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.4,384.62c-.38.86.34,2,1.62,2.57s2.61.31,3-.55-.34-2-1.62-2.57S228.77,383.76,228.4,384.62Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28,388.12a1.11,1.11,0,1,0,1.35-.38A1,1,0,0,0,233.28,388.12Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.77,394.14a3.44,3.44,0,0,0-6.87,0v.2a1.77,1.77,0,0,0,1,1.3,5.34,5.34,0,0,0,4.86,0,1.75,1.75,0,0,0,1-1.3v-.2Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.77,394.14a3.44,3.44,0,0,0-6.87,0v.2a1.77,1.77,0,0,0,1,1.3,5.34,5.34,0,0,0,4.86,0,1.75,1.75,0,0,0,1-1.3v-.2Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.83,391.15h0a3.4,3.4,0,0,0-1.49-.35,3.44,3.44,0,0,0-3.44,3.34v.2a1.77,1.77,0,0,0,1,1.3,4.51,4.51,0,0,0,1.72.54,1.73,1.73,0,0,1-1.19-2.25C235.76,392.66,237.05,390.82,238.83,391.15Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.77,394.34v-.2a3.4,3.4,0,0,0-1.16-2.48c.37.39,1.2,1.83.3,2.93a5.27,5.27,0,0,1-5.73.43,2.28,2.28,0,0,0,.73.62,5.34,5.34,0,0,0,4.86,0A1.75,1.75,0,0,0,240.77,394.34Z",
    style: {
      fill: "#10E2ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.3,391.58c.16.35-.14.82-.66,1s-1.06.13-1.21-.22.14-.82.66-1S237.15,391.23,237.3,391.58Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.31,393a.4.4,0,0,1-.26.51.41.41,0,0,1-.55-.15.41.41,0,0,1,.26-.51A.41.41,0,0,1,235.31,393Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71,378.54a3.43,3.43,0,0,1,6.86,0,.28.28,0,0,1,0,.09.38.38,0,0,1,0,.1,1.75,1.75,0,0,1-1,1.3,5.34,5.34,0,0,1-4.86,0,1.73,1.73,0,0,1-1-1.3.38.38,0,0,1,0-.1A.28.28,0,0,1,183.71,378.54Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71,378.54a3.43,3.43,0,0,1,6.86,0,.28.28,0,0,1,0,.09.38.38,0,0,1,0,.1,1.75,1.75,0,0,1-1,1.3,5.34,5.34,0,0,1-4.86,0,1.73,1.73,0,0,1-1-1.3.38.38,0,0,1,0-.1A.28.28,0,0,1,183.71,378.54Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.65,375.54h0a3.37,3.37,0,0,1,1.49-.35,3.43,3.43,0,0,1,3.43,3.35.28.28,0,0,1,0,.09.38.38,0,0,1,0,.1,1.75,1.75,0,0,1-1,1.3,4.34,4.34,0,0,1-1.73.54,1.74,1.74,0,0,0,1.2-2.25C188.72,377.05,187.43,375.21,185.65,375.54Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71,378.73a.38.38,0,0,1,0-.1.28.28,0,0,1,0-.09,3.42,3.42,0,0,1,1.16-2.49c-.37.39-1.2,1.83-.3,2.93a5.27,5.27,0,0,0,5.73.43,2.28,2.28,0,0,1-.73.62,5.34,5.34,0,0,1-4.86,0A1.73,1.73,0,0,1,183.71,378.73Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.17,376c-.15.35.15.82.66,1s1.07.13,1.22-.22-.14-.82-.66-1S187.33,375.62,187.17,376Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.16,377.39a.41.41,0,0,0,.26.51.37.37,0,1,0-.26-.51Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.89,305.92l-8.7-2.25-8.7,2.25a35.1,35.1,0,0,0,.09,12c1.14,7.3,6.23,14.61,8.61,14.61s7.47-7.31,8.61-14.61A35.1,35.1,0,0,0,245.89,305.92Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.89,305.92l-8.7-2.25-8.7,2.25a35.1,35.1,0,0,0,.09,12c1.14,7.3,6.23,14.61,8.61,14.61s7.47-7.31,8.61-14.61A35.1,35.1,0,0,0,245.89,305.92Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.89,307H231c-1.7,10.3,3.77,18.19,6,18.19S244.59,317.27,242.89,307Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.93,307h2a9,9,0,0,1,1.11,5.5c-.25,2.78-1.92,6.39-3.15,6.39s-2.9-3.61-3.15-6.39a9,9,0,0,1,1.11-5.5h2",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253,302.2h0l-1.36-14.55H222.28l-1.36,14.55h0c-.28,2.57,1.26,5.2,4.67,7.16,6.28,3.62,16.47,3.62,22.74,0C251.74,307.4,253.28,304.77,253,302.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.56,294.23c-5.75-3.32-5.75-8.69,0-12s15.06-3.32,20.81,0,5.75,8.69,0,12S232.31,297.55,226.56,294.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.68,298.64l-.46-4.88c-.42,1.88-1.87,3.7-4.37,5.14-6,3.46-15.75,3.46-21.76,0-2.5-1.44-4-3.26-4.38-5.14l-.46,4.88c.37,2,1.88,3.95,4.54,5.48,6.18,3.56,16.19,3.56,22.36,0C250.8,302.59,252.31,300.64,252.68,298.64Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.52,309.25,249,309h0A26.58,26.58,0,0,1,236.9,311c-7.31-.31-11.79-3.1-11.92-5.15a25.54,25.54,0,0,1,.31-5.05,26.71,26.71,0,0,0,11.91,2.39c8.19,0,13.16-2.83,15.4-5.42l-.23-2.43-.72-7.73H222.28l-1.36,14.55h0a5.42,5.42,0,0,0,0,1.45c0,.21.08.41.13.62a6.56,6.56,0,0,0,.29.81,9.6,9.6,0,0,0,4.21,4.28A23.29,23.29,0,0,0,237,312.08a28.43,28.43,0,0,0,3.07-.17c.51-.06,1-.13,1.51-.22a20.5,20.5,0,0,0,6.79-2.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.39,297.72H237c-6,.06-11.37-1.49-15.08-4.42a3.27,3.27,0,1,1,4.05-5.13c2.54,2,6.45,3.08,11,3H237c4.54.05,8.44-1,11-3a3.27,3.27,0,1,1,4,5.13C248.42,296.16,243.23,297.72,237.39,297.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.78,279.73l2.47-30,9.95,5.75c4.78,2.76,6.92,9.82,6.14,20.26l-1.27,16.78-2.68-9.29c-1.46-5.07-5.18-6.81-10.56-4.95Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.78,279.73l2.47-30,9.95,5.75c4.78,2.76,6.92,9.82,6.14,20.26l-1.27,16.78-2.68-9.29c-1.46-5.07-5.18-6.81-10.56-4.95Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.13,279.73l-2.47-30-9.95,5.75c-4.78,2.76-6.92,9.82-6.13,20.26l1.26,16.78,2.68-9.29c1.46-5.07,5.19-6.81,10.56-4.95Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.13,279.73l-2.47-30-9.95,5.75c-4.78,2.76-6.92,9.82-6.13,20.26l1.26,16.78,2.68-9.29c1.46-5.07,5.19-6.81,10.56-4.95Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8,226.18c0-32-13.52-59.65-23.57-66.05L239,160l-.05,0h0a3.83,3.83,0,0,0-3.89,0h0l-.05,0-.27.18c-10,6.4-23.57,34.05-23.57,66.05,0,30.79,8.63,58.08,9.46,60.61l.06.19h0a9.66,9.66,0,0,0,4.54,4.89c6.5,3.75,17.05,3.75,23.55,0a9.51,9.51,0,0,0,4.61-5.08C254.17,284.25,262.8,257,262.8,226.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.58,167.82a28.34,28.34,0,0,0-7.35-7.7L239,160l-.05,0h0a3.83,3.83,0,0,0-3.89,0h0l-.05,0-.27.17a28.5,28.5,0,0,0-7.36,7.7A65.78,65.78,0,0,0,223,175a7.83,7.83,0,0,0,4,4.51c5.5,3.18,14.43,3.18,19.93,0a7.86,7.86,0,0,0,4-4.51A63.91,63.91,0,0,0,246.58,167.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.3,161,237,147.86,235.63,161h0a.68.68,0,0,0,.39.55,2.1,2.1,0,0,0,1.89,0,.68.68,0,0,0,.39-.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.13,226.18c0,30.79,8.63,58.08,9.46,60.61l.06.19h0a9.66,9.66,0,0,0,4.54,4.89,19.39,19.39,0,0,0,3.62,1.57A265.71,265.71,0,0,1,219.66,227c0-35.46,8.73-60.58,15-66.83C224.65,166.53,211.13,194.18,211.13,226.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8,226.18c0,30.79-8.63,58.08-9.45,60.61a1.07,1.07,0,0,1-.07.19h0a9.61,9.61,0,0,1-4.54,4.89C253.62,274,259.19,252.6,259.19,227c0-35.46-13.65-60.58-20-66.83C249.28,166.53,262.8,194.18,262.8,226.18Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.57,270.08l-8.79-16.22-2.32,1.35-4,25.49,3.81,3.08a28.45,28.45,0,0,1,9.93,16.12l2.53,11.66s1.1-7.41,2.32-16.38C267.1,287.14,267.07,277.87,262.57,270.08Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.57,270.08l-8.79-16.22-2.32,1.35-4,25.49,3.81,3.08a28.45,28.45,0,0,1,9.93,16.12l2.53,11.66s1.1-7.41,2.32-16.38C267.1,287.14,267.07,277.87,262.57,270.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.42,280.7l4-25.49,8.79,16.21c4.49,7.79,5.36,16.76,4.62,25.72l-1.18,14.42-2.53-11.66a28.45,28.45,0,0,0-9.93-16.12Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.36,270.08l8.79-16.22,2.32,1.35,4,25.49-3.81,3.08a28.45,28.45,0,0,0-9.93,16.12l-2.52,11.66s-1.11-7.41-2.33-16.38C206.83,287.14,206.86,277.87,211.36,270.08Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.36,270.08l8.79-16.22,2.32,1.35,4,25.49-3.81,3.08a28.45,28.45,0,0,0-9.93,16.12l-2.52,11.66s-1.11-7.41-2.33-16.38C206.83,287.14,206.86,277.87,211.36,270.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.51,280.7l-4-25.49-8.79,16.21c-4.49,7.79-5.36,16.76-4.62,25.72l1.19,14.42,2.52-11.66a28.45,28.45,0,0,1,9.93-16.12Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.43,200.66a9.65,9.65,0,0,0-4.44-7.13l-1.59-.91a7.64,7.64,0,0,0-3.84-1,9.17,9.17,0,0,0-3,.52c-4.85,1.68-8.16,7.21-7.89,13.13a10.91,10.91,0,0,0,4.91,9.06l1.68,1a7.71,7.71,0,0,0,3.9,1.06,8,8,0,0,0,2.63-.45C255.49,214,258.34,206.44,257.43,200.66Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.43,200.66a9.65,9.65,0,0,0-4.44-7.13l-1.59-.91a7.64,7.64,0,0,0-3.84-1,9.17,9.17,0,0,0-3,.52c-4.85,1.68-8.16,7.21-7.89,13.13a10.91,10.91,0,0,0,4.91,9.06l1.68,1a7.71,7.71,0,0,0,3.9,1.06,8,8,0,0,0,2.63-.45C255.49,214,258.34,206.44,257.43,200.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M247.18,216.35c-4.82,0-8.65-4.38-8.92-10.18s3-11.45,7.89-13.13a8.91,8.91,0,0,1,3-.52c4.26,0,7.52,3.19,8.3,8.14.91,5.78-1.94,13.29-7.62,15.24A8,8,0,0,1,247.18,216.35Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9,213.25c-4.05,1.4-7.62-2.3-7.85-7.21s2.48-9.13,6-10.36,6.85.66,7.59,5.41S253,211.86,248.9,213.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,200.24a7.25,7.25,0,0,0-2.45-4.72,5.71,5.71,0,0,0-3.5.16c-3.54,1.23-6.24,5.44-6,10.36a8.56,8.56,0,0,0,3,6.43,5,5,0,0,0,3.17-.07C251.31,211,253.76,205,253,200.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.78,197.7c-3.32,1.66-4.85,5.62-4.22,9.18.05.29.17.63.46.7s.6-.27.77-.57c1-1.67,2-3.71,3.81-4.65a5.54,5.54,0,0,1,1.32-.44c1.24-.32,2.33-.85,2.42-2.3a2.08,2.08,0,0,0-1.64-2.37A4.25,4.25,0,0,0,246.78,197.7Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.8,228.59a7.4,7.4,0,0,0-3.4-5.46l-1.21-.69a5.87,5.87,0,0,0-2.95-.77,6.81,6.81,0,0,0-2.28.4c-3.7,1.28-6.24,5.51-6,10a8.36,8.36,0,0,0,3.75,6.94l1.29.74a5.92,5.92,0,0,0,3,.81,6.08,6.08,0,0,0,2-.35C254.32,238.76,256.49,233,255.8,228.59Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.8,228.59a7.4,7.4,0,0,0-3.4-5.46l-1.21-.69a5.87,5.87,0,0,0-2.95-.77,6.81,6.81,0,0,0-2.28.4c-3.7,1.28-6.24,5.51-6,10a8.36,8.36,0,0,0,3.75,6.94l1.29.74a5.92,5.92,0,0,0,3,.81,6.08,6.08,0,0,0,2-.35C254.32,238.76,256.49,233,255.8,228.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M248,240.6c-3.68,0-6.61-3.35-6.82-7.79s2.33-8.76,6-10.05a6.76,6.76,0,0,1,2.28-.4c3.26,0,5.75,2.45,6.35,6.23.69,4.43-1.48,10.17-5.84,11.66A6.08,6.08,0,0,1,248,240.6Z",
    style: {
      fill: "#10E2ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.27,238.23c-3.1,1.06-5.83-1.76-6-5.52s1.89-7,4.6-7.93,5.24.51,5.81,4.14S252.37,237.17,249.27,238.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.42,228.27a5.53,5.53,0,0,0-1.87-3.61,4.35,4.35,0,0,0-2.68.12c-2.71.94-4.78,4.17-4.6,7.93a6.5,6.5,0,0,0,2.31,4.92,3.9,3.9,0,0,0,2.43,0C251.11,236.51,253,231.91,252.42,228.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.65,226.33a6.56,6.56,0,0,0-3.23,7c0,.22.13.48.35.54s.46-.21.59-.44c.73-1.28,1.56-2.83,2.92-3.56a4.27,4.27,0,0,1,1-.33c1-.25,1.78-.65,1.85-1.77a1.59,1.59,0,0,0-1.25-1.8A3.19,3.19,0,0,0,247.65,226.33Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech);
export default __webpack_public_path__ + "static/media/tech.ae08150902f1379e0d33673c82c02f83.svg";
export { ForwardRef as ReactComponent };